<template>
    <div class="big-box">
        <div style="width:100%;height:4.75%;position: relative;display:flex;">
            <div style="width:30%;height:100%;padding-left:20rem;display:flex;justify-content: flex-start;align-content: center;align-items: center;">
                <span style="font-size: 30rem;">{{curTime}}</span>
            </div>
            <div class="nowrap" :style="{'font-size':proNameSize+'px'}" style="width:40%;height:100%;text-align: center;display: flex;align-items: center;justify-content: center;">
                {{proInfo.name}}智慧工地数据展示平台
            </div>
            <div style="width:30%;height:100%;"></div>
        </div>
        <div class="list-group-box1">
            <draggable class="list-group" tag="ul" :list="list0" group="project" @change="log">
                <li class="list-group-item" v-for="(element, index) in list0" :key="index">
                    <p class="item-title" v-if="index==0"> 劳务统计 </p>
                    <div v-if="element.index=='1' && element.show" class="item-div" :style="{'margin-top':element.margin+'rem','margin-bottom':element.margin+'rem'}">
                        <div style="width:100%;height:30rem;position: relative;display:flex;justify-content: space-between;padding:0 36rem;">
                            <p>
                                <span class="crile"></span>
                                <span style="color:#34ECFF;font-size:22rem;">今日出勤</span>
                                <span style="color:#34ECFF;font-size:22rem;margin-left:50rem;">{{attend.allTeamsCount}}</span>
                            </p>
                        </div>
                        <div style="width:100%;height:60rem;position: relative;display:flex;align-items: center;margin-top:30rem;">
                            <p style="width:30%;position: relative;text-align: center;padding:0 18rem;"></p>
                            <p style="width:40%;position: relative;text-align: center;padding:0 18rem;">出勤人数</p>
                            <p style="width:30%;position: relative;text-align: center;padding:0 18rem;">出勤率</p>
                        </div>
                        <div style="width:100%;height:300rem;position: relative;overflow: hidden;">
                            <ul>
                                <li style="height:80rem;align-content: center;align-items: center;width: 100%;position: relative;display: flex;">
                                    <p style="width:30%;padding:0 18rem;">
                                        <span class="nowrap" style="display: inline-block;width: 100%;">管理人员</span>
                                    </p>
                                    <p style="width:40%;padding:0 18rem;">
                                        <img src="../../assets/image/visual/li0.png" style="width:86rem;height:42rem;position: absolute;left: calc( 50% - 43rem );top: -12rem;" />
                                        <span class="nowrap" style="display: inline-block;width: 100%;">{{attend.manageCount}}</span>
                                    </p>
                                    <p style="width:30%;padding:0 18rem;">
                                        <img src="../../assets/image/visual/li0.png" style="width:86rem;height:42rem;position: absolute;left: calc( 50% - 43rem );top: -12rem;" />
                                        <span class="nowrap" style="display: inline-block;width: 100%;">{{attend.manageRate}}%</span>
                                    </p>
                                </li>
                                <li style="height:80rem;align-content: center;align-items: center;width: 100%;position: relative;display: flex;">
                                    <p style="width:30%;padding:0 18rem;">
                                        <span class="nowrap" style="display: inline-block;width: 100%;">建筑工人</span>
                                    </p>
                                    <p style="width:40%;padding:0 18rem;">
                                        <img src="../../assets/image/visual/li1.png" style="width:86rem;height:42rem;position: absolute;left: calc( 50% - 43rem );top: -12rem;" />
                                        <span class="nowrap" style="display: inline-block;width: 100%;">{{attend.workersCount}}</span>
                                    </p>
                                    <p style="width:30%;padding:0 18rem;">
                                        <img src="../../assets/image/visual/li1.png" style="width:86rem;height:42rem;position: absolute;left: calc( 50% - 43rem );top: -12rem;" />
                                        <span class="nowrap" style="display: inline-block;width: 100%;">{{attend.workersRate}}%</span>
                                    </p>
                                </li>
                                <li style="height:80rem;align-content: center;align-items: center;width: 100%;position: relative;display: flex;">
                                    <p style="width:30%;padding:0 18rem;">
                                        <span class="nowrap" style="display: inline-block;width: 100%;">特种人员</span>
                                    </p>
                                    <p style="width:40%;padding:0 18rem;">
                                        <img src="../../assets/image/visual/li0.png" style="width:86rem;height:42rem;position: absolute;left: calc( 50% - 43rem );top: -12rem;" />
                                        <span class="nowrap" style="display: inline-block;width: 100%;">{{attend.specialCount}}</span>
                                    </p>
                                    <p style="width:30%;padding:0 18rem;">
                                        <img src="../../assets/image/visual/li0.png" style="width:86rem;height:42rem;position: absolute;left: calc( 50% - 43rem );top: -12rem;" />
                                        <span class="nowrap" style="display: inline-block;width: 100%;">{{attend.specialRate}}%</span>
                                    </p>
                                </li>
                            </ul>
                        </div>
                    </div>
                    
                    <div v-if="element.index=='2' && element.show" class="item-div" :style="{'margin-top':element.margin+'rem','margin-bottom':element.margin+'rem'}">
                        <div style="width:100%;height:30rem;position: relative;display:flex;justify-content: space-between;padding:0 36rem;">
                            <p>
                                <span class="crile"></span>
                                <span style="color:#34ECFF;font-size:22rem;">在场人员</span>
                                <span style="color:#34ECFF;font-size:22rem;margin-left:50rem;">{{persent.allTeamsCount}}</span>
                            </p>
                        </div>
                        <div style="width:100%;height:60rem;position: relative;display:flex;align-items: center;margin-top:30rem;">
                            <p style="width:30%;position: relative;text-align: center;padding:0 18rem;"></p>
                            <p style="width:40%;position: relative;text-align: center;padding:0 18rem;">出勤人数</p>
                            <p style="width:30%;position: relative;text-align: center;padding:0 18rem;">出勤率</p>
                        </div>
                        <div style="width:100%;height:300rem;position: relative;overflow: hidden;">
                            <ul>
                                <li style="height:80rem;align-content: center;align-items: center;width: 100%;position: relative;display: flex;">
                                    <p style="width:30%;padding:0 18rem;">
                                        <span class="nowrap" style="display: inline-block;width: 100%;">管理人员</span>
                                    </p>
                                    <p style="width:40%;padding:0 18rem;">
                                        <img src="../../assets/image/visual/li0.png" style="width:86rem;height:42rem;position: absolute;left: calc( 50% - 43rem );top: -12rem;" />
                                        <span class="nowrap" style="display: inline-block;width: 100%;">{{persent.manageCount}}</span>
                                    </p>
                                    <p style="width:30%;padding:0 18rem;">
                                        <img src="../../assets/image/visual/li0.png" style="width:86rem;height:42rem;position: absolute;left: calc( 50% - 43rem );top: -12rem;" />
                                        <span class="nowrap" style="display: inline-block;width: 100%;">{{persent.manageRate}}%</span>
                                    </p>
                                </li>
                                <li style="height:80rem;align-content: center;align-items: center;width: 100%;position: relative;display: flex;">
                                    <p style="width:30%;padding:0 18rem;">
                                        <span class="nowrap" style="display: inline-block;width: 100%;">建筑工人</span>
                                    </p>
                                    <p style="width:40%;padding:0 18rem;">
                                        <img src="../../assets/image/visual/li1.png" style="width:86rem;height:42rem;position: absolute;left: calc( 50% - 43rem );top: -12rem;" />
                                        <span class="nowrap" style="display: inline-block;width: 100%;">{{persent.workersCount}}</span>
                                    </p>
                                    <p style="width:30%;padding:0 18rem;">
                                        <img src="../../assets/image/visual/li1.png" style="width:86rem;height:42rem;position: absolute;left: calc( 50% - 43rem );top: -12rem;" />
                                        <span class="nowrap" style="display: inline-block;width: 100%;">{{persent.workersRate}}%</span>
                                    </p>
                                </li>
                                <li style="height:80rem;align-content: center;align-items: center;width: 100%;position: relative;display: flex;">
                                    <p style="width:30%;padding:0 18rem;">
                                        <span class="nowrap" style="display: inline-block;width: 100%;">特种人员</span>
                                    </p>
                                    <p style="width:40%;padding:0 18rem;">
                                        <img src="../../assets/image/visual/li0.png" style="width:86rem;height:42rem;position: absolute;left: calc( 50% - 43rem );top: -12rem;" />
                                        <span class="nowrap" style="display: inline-block;width: 100%;">{{persent.specialCount}}</span>
                                    </p>
                                    <p style="width:30%;padding:0 18rem;">
                                        <img src="../../assets/image/visual/li0.png" style="width:86rem;height:42rem;position: absolute;left: calc( 50% - 43rem );top: -12rem;" />
                                        <span class="nowrap" style="display: inline-block;width: 100%;">{{persent.specialRate}}%</span>
                                    </p>
                                </li>
                            </ul>
                        </div>
                    </div>

                    <div v-if="element.index=='3' && element.show" class="item-div" :style="{'margin-top':element.margin+'rem','margin-bottom':element.margin+'rem'}">
                        <div style="width:100%;height:30rem;position: relative;display:flex;justify-content: space-between;padding:0 36rem;">
                            <p>
                                <span class="crile"></span>
                                <span style="color:#34ECFF;font-size:22rem;">人员动态</span>
                            </p>
                        </div>
                        <div style="width:100%;height:100rem;position: relative;display:flex;padding:0 36rem;align-items: center;">
                            <p style="font-size:18rem;color:#fff;padding-left:30rem;">累计采集{{syn.zs}}人</p>
                            <p style="font-size:18rem;color:#fff;padding-left:50rem;">实名占比{{syn.smRate}}</p>
                        </div>
                        <div style="width:100%;height:360rem;position: relative;display:flex;">
                            <div style="width: 50%;height: 100%;">
                                <div id="myChart1" style="width:100%; height:100%"></div>
                            </div>
                            <div class="first-gress-con" style="width: 50%;height: 100%;position: relative;display: flex;flex-wrap: wrap;">
                                <p style="color:#fff;display:flex;align-items: flex-end;padding-left:20rem;">在职人员({{syn.zz}}/{{syn.zs}})</p>
                                <p style="width: 100%;position: relative;height: 20rem;"><el-progress :show-text="false" :percentage="parseFloat(syn.zzLv)" :stroke-width="20"></el-progress></p>
                                <p style="color:#fff;display:flex;align-items: flex-end;padding-left:20rem;">未在职人员({{syn.wzz}}/{{syn.zs}})</p>
                                <p style="width: 100%;position: relative;height: 20rem;"><el-progress :show-text="false" :percentage="parseFloat(syn.wzzLv)" :stroke-width="20" color="#FF9F20"></el-progress></p>
                                <p style="color:#fff;display:flex;align-items: flex-end;padding-left:20rem;">未实名人员({{syn.lz}}/{{syn.zs}})</p>
                                <p style="width: 100%;position: relative;height: 20rem;"><el-progress :show-text="false" :percentage="parseFloat(syn.lzLv)" :stroke-width="20" color="#E66E3A"></el-progress></p>
                            </div>
                        </div>
                    </div>

                    <div v-if="element.index=='4' && element.show" class="item-div" :style="{'margin-top':element.margin+'rem','margin-bottom':element.margin+'rem'}">
                        <div style="width:100%;height:60rem;position: relative;display:flex;justify-content: space-between;padding:0 36rem;">
                            <p>
                                <span class="crile"></span>
                                <span style="color:#34ECFF;font-size:22rem;">班组出勤</span>
                            </p>
                        </div>
                        <div style="width:100%;height:60rem;position: relative;display:flex;align-items: center;">
                            <p style="width:25%;position: relative;text-align: center;padding:0 18rem;">班组</p>
                            <p style="width:25%;position: relative;text-align: center;padding:0 18rem;">人数</p>
                            <p style="width:25%;position: relative;text-align: center;padding:0;">出勤人数</p>
                            <p style="width:25%;position: relative;text-align: center;padding:0 18rem;">出勤率</p>
                        </div>
                        <div style="width:100%;height:420rem;position: relative;overflow: hidden;">
                            <ul :class="{anim:animate==true}">
                                <li v-for="(item,index) in attendTeam" :key="index" style="height:80rem;align-content: center;align-items: center;width: 100%;position: relative;display: flex;">
                                    <p style="width:25%;padding:0 18rem;">
                                        <span class="nowrap" style="display: inline-block;width: 100%;" :title="item.teamsName">{{item.teamsName}}</span>
                                    </p>
                                    <p style="width:25%;padding:0 18rem;">
                                        <img src="../../assets/image/visual/li0.png" style="width:86rem;height:42rem;position: absolute;left: calc( 50% - 43rem );top: -12rem;" />
                                        <span class="nowrap" style="display: inline-block;width: 100%;">{{item.zzCount}}</span>
                                    </p>
                                    <p style="width:25%;padding:0;">
                                        <img src="../../assets/image/visual/li0.png" style="width:86rem;height:42rem;position: absolute;left: calc( 50% - 43rem );top: -12rem;" />
                                        <span class="nowrap" style="display: inline-block;width: 100%;">{{item.cqCount}}</span>
                                    </p>
                                    <p style="width:25%;padding:0 18rem;">
                                        <img src="../../assets/image/visual/li0.png" style="width:86rem;height:42rem;position: absolute;left: calc( 50% - 43rem );top: -12rem;" />
                                        <span class="nowrap" style="display: inline-block;width: 100%;">{{item.lv}}%</span>
                                    </p>
                                </li>
                            </ul>
                        </div>
                    </div>

                    <div v-if="element.index=='5' && element.show" class="item-div" :style="{'margin-top':element.margin+'rem','margin-bottom':element.margin+'rem'}">
                        <div style="width:100%;height:100rem;position: relative;display:flex;justify-content: space-between;padding:0 0 0 36rem;flex-wrap:wrap;">
                            <p style="width:100%;text-align:left;">
                                <span class="crile"></span>
                                <span style="color:#34ECFF;font-size:22rem;">合同信息</span>
                            </p>
                            <p style="color:#fff;font-size:12rem;">应签{{agreeNum.yqht}}人</p>
                            <p style="color:#fff;font-size:12rem;">已网签{{agreeNum.ywq}}人</p>
                            <p style="color:#fff;font-size:12rem;">未网签{{agreeNum.wxq}}人</p>
                        </div>
                        <div style="width:100%;height:60rem;position: relative;display:flex;align-items: center;margin-top:30rem;">
                            <p style="width:25%;position: relative;text-align: center;padding:0 18rem;">姓名</p>
                            <p style="width:50%;position: relative;text-align: center;padding:0 18rem;">入职时间</p>
                            <p style="width:25%;position: relative;text-align: center;padding:0;">合同状态</p>
                        </div>
                        <div style="width:100%;height:540rem;position: relative;overflow: hidden;">
                            <ul :class="{anim1:animate1==true}">
                                <li v-for="(item,index) in tableAgree" :key="index" style="height:60rem;align-content: center;align-items: center;width: 100%;position: relative;display: flex;">
                                    <p style="width:25%;padding:0 18rem;">
                                        <span class="nowrap" style="display: inline-block;width: 100%;">{{item.name}}</span>
                                    </p>
                                    <p style="width:50%;padding:0 18rem;">
                                        <span class="nowrap" style="display: inline-block;width: 100%;">{{item.create_date}}</span>
                                    </p>
                                    <p style="width:25%;padding:0;">
                                        <span v-if="item.status=='已网签'" style="display: inline-block;width: 100%;color:#FFFFFF;">已网签</span>
                                        <span v-else style="display: inline-block;width: 100%;color:#E66E3A;">未网签</span>
                                    </p>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <!-- list1 -->
                    <!-- <div v-if="element.index=='6' && element.show" class="item-div" :style="{'margin-top':element.margin+'rem','margin-bottom':element.margin+'rem'}" :class="(element.border?'borderCss':'')">
                        <p class="item-title"> 质量安全 </p>
                        <div style="width:100%;height:400rem;position: relative;display:flex;">
                            <div style="width:50%;height:100%;position: relative;display:flex;flex-wrap:wrap;">
                                <p style="width:100%;font-size:20rem;position: relative;height:100rem;display: flex;align-items: flex-end;align-content: center;justify-content: center;">项目检查  {{qsChar.projectAllQsCount}}次</p>
                                <div style="width:100%;height:300rem;position: relative;display:flex;justify-content: center;">
                                    <div id="safe1" style="width:240rem; height:240rem:"></div>
                                    <div style="width:calc( 100% - 300rem );height:260rem;display:flex;flex-wrap:wrap;align-content: center;">
                                        <p style="width:100%;margin-top:30rem;text-align: left;">
                                            <span style="width: 18rem;height: 18rem;background: #1299F3;border-radius: 50%;display: inline-block;"></span>
                                            <span style="margin-left:20rem;">符合</span>
                                        </p>
                                        <p style="width:100%;margin-top:20rem;text-align: left;">
                                            <span style="width: 18rem;height: 18rem;background: #FF9B52;border-radius: 50%;display: inline-block;"></span>
                                            <span style="margin-left:20rem;">待处理</span>
                                        </p>
                                        <p style="width:100%;margin-top:20rem;text-align: left;">
                                            <span style="width: 18rem;height: 18rem;background: #4EE6B7;border-radius: 50%;display: inline-block;"></span>
                                            <span style="margin-left:20rem;">已处理</span>
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div style="width:50%;height:100%;position: relative;display:flex;flex-wrap:wrap;">
                                <p style="width:100%;font-size:20rem;position: relative;height:100rem;display: flex;align-items: flex-end;align-content: center;justify-content: center;">公司检查  {{qsChar.entAllQsCount}}次</p>
                                <div style="width:100%;height:300rem;position: relative;display:flex;justify-content: center;">
                                    <div id="safe2" style="width:240rem; height:240rem:"></div>
                                    <div style="width:calc( 100% - 300rem );height:260rem;display:flex;flex-wrap:wrap;align-content: center;">
                                        <p style="width:100%;margin-top:30rem;text-align: left;">
                                            <span style="width: 18rem;height: 18rem;background: #6E38A8;border-radius: 50%;display: inline-block;"></span>
                                            <span style="margin-left:20rem;">符合</span>
                                        </p>
                                        <p style="width:100%;margin-top:20rem;text-align: left;">
                                            <span style="width: 18rem;height: 18rem;background: #70BFED;border-radius: 50%;display: inline-block;"></span>
                                            <span style="margin-left:20rem;">待处理</span>
                                        </p>
                                        <p style="width:100%;margin-top:20rem;text-align: left;">
                                            <span style="width: 18rem;height: 18rem;background: #F47E86;border-radius: 50%;display: inline-block;"></span>
                                            <span style="margin-left:20rem;">已处理</span>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div v-if="element.index=='7' && element.show" class="item-div" :style="{'margin-top':element.margin+'rem','margin-bottom':element.margin+'rem'}" :class="(element.border?'borderCss':'')">
                        <p class="item-title"> 疫情管控 </p>
                        <div style="width:100%;height:400rem;position: relative;margin-top:20rem;padding:0 20rem;">
                            <div id="disease1" style="width:100%; height:100%;"></div>
                        </div>
                        <div style="width:100%;height:400rem;position: relative;margin-top:20rem;padding:0 20rem;">
                            <div id="disease2" style="width:100%; height:100%;"></div>
                        </div>
                    </div>

                    <div v-if="element.index=='8' && element.show" class="item-div" :style="{'margin-top':element.margin+'rem','margin-bottom':element.margin+'rem'}" :class="(element.border?'borderCss':'')">
                        <p class="item-title"> 车辆统计 </p>
                        <div style="width:100%;height:300rem;position: relative;margin-top:20rem;padding:0 20rem;">
                            <div id="car1" style="width:100%; height:100%;"></div>
                        </div>
                    </div> -->
                    <!-- list4 -->
                    <!-- <div v-if="element.index=='18' && element.show" class="item-div" :style="{'margin-top':element.margin+'rem','margin-bottom':element.margin+'rem'}" :class="(element.border?'borderCss':'')">
                        <p class="item-title"> 高支模监测 </p>
                        <div style="width:100%;height:760rem;position: relative;padding:20rem 40rem;">
                            <div style="width:100%;height:120rem;position: relative;display:flex;align-items: center;">
                                <p style="width:200rem;">位移（米）</p>
                                <div style="width:calc( 100% - 200rem );position: relative;height:32rem;background: linear-gradient(270deg, #91E3F7 0%, #6CB8FB 51%, #468CFF 99%, #468CFF 100%);">
                                    <div :style="{'left':'calc( '+highMod.wyRate1+' - 50rem )'}" style="width:100rem;height:80rem;position: absolute;top:-33rem;display:flex;flex-wrap:wrap;justify-content: center;justify-items: center;">
                                        <p style="width:100%;height:20rem;position: relative;text-align: center;">{{highMod.wyVal1}}</p>
                                        <p style="width:1rem;height:55rem;border-left: 1rem dashed #fff;"></p>
                                    </div>
                                </div>
                            </div>
                            <div style="width:100%;height:120rem;position: relative;display:flex;align-items: center;">
                                <p style="width:200rem;"></p>
                                <div style="width:calc( 100% - 200rem );position: relative;height:32rem;background: linear-gradient(270deg, #91E3F7 0%, #6CB8FB 51%, #468CFF 99%, #468CFF 100%);">
                                    <div :style="{'left':'calc( '+highMod.wyRate2+' - 50rem )'}" style="width:100rem;height:80rem;position: absolute;top:-33rem;display:flex;flex-wrap:wrap;justify-content: center;justify-items: center;">
                                        <p style="width:100%;height:20rem;position: relative;text-align: center;">{{highMod.wyVal2}}</p>
                                        <p style="width:1rem;height:55rem;border-left: 1rem dashed #fff;"></p>
                                    </div>
                                </div>
                            </div>
                            <div style="width:100%;height:120rem;position: relative;display:flex;align-items: center;">
                                <p style="width:200rem;">倾角（°）</p>
                                <div style="width:calc( 100% - 200rem );position: relative;height:32rem;background: linear-gradient(270deg, #FFA0E5 0%, #FF86B8 52%, #FF6C8B 100%);">
                                    <div :style="{'left':'calc( '+highMod.qjRate1+' - 50rem )'}" style="width:100rem;height:80rem;position: absolute;top:-33rem;display:flex;flex-wrap:wrap;justify-content: center;justify-items: center;">
                                        <p style="width:100%;height:20rem;position: relative;text-align: center;">{{highMod.qjVal1}}</p>
                                        <p style="width:1rem;height:55rem;border-left: 1rem dashed #fff;"></p>
                                    </div>
                                </div>
                            </div>
                            <div style="width:100%;height:120rem;position: relative;display:flex;align-items: center;">
                                <p style="width:200rem;"></p>
                                <div style="width:calc( 100% - 200rem );position: relative;height:32rem;background: #7D6CFF;">
                                    <div :style="{'left':'calc( '+highMod.qjRate2+' - 50rem )'}" style="width:100rem;height:80rem;position: absolute;top:-33rem;display:flex;flex-wrap:wrap;justify-content: center;justify-items: center;">
                                        <p style="width:100%;height:20rem;position: relative;text-align: center;">{{highMod.qjVal2}}</p>
                                        <p style="width:1rem;height:55rem;border-left: 1rem dashed #fff;"></p>
                                    </div>
                                </div>
                            </div>
                            <div style="width:100%;height:120rem;position: relative;display:flex;align-items: center;">
                                <p style="width:200rem;">压力（N）</p>
                                <div style="width:calc( 100% - 200rem );position: relative;height:32rem;background: linear-gradient(270deg, #ABA0FF 0%, #9486FF 51%, #7D6CFF 99%, #7D6CFF 100%);">
                                    <div :style="{left:'calc( '+highMod.ylRate1+' - 50rem )'}" style="width:100rem;height:80rem;position: absolute;top:-33rem;display:flex;flex-wrap:wrap;justify-content: center;justify-items: center;">
                                        <p style="width:100%;height:20rem;position: relative;text-align: center;">{{highMod.ylVal1}}</p>
                                        <p style="width:1rem;height:55rem;border-left: 1rem dashed #fff;"></p>
                                    </div>
                                </div>
                            </div>
                            <div style="width:100%;height:120rem;position: relative;display:flex;align-items: center;">
                                <p style="width:200rem;"></p>
                                <div style="width:calc( 100% - 200rem );position: relative;height:32rem;background: linear-gradient(270deg, #ABA0FF 0%, #9486FF 51%, #7D6CFF 99%, #7D6CFF 100%);">
                                    <div :style="{'left':'calc( '+highMod.ylRate2+' - 50rem )'}" style="width:100rem;height:80rem;position: absolute;top:-33rem;display:flex;flex-wrap:wrap;justify-content: center;justify-items: center;">
                                        <p style="width:100%;height:20rem;position: relative;text-align: center;">{{highMod.ylVal2}}</p>
                                        <p style="width:1rem;height:55rem;border-left: 1rem dashed #fff;"></p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div v-if="element.index=='19' && element.show" class="item-div" :style="{'margin-top':element.margin+'rem','margin-bottom':element.margin+'rem'}" :class="(element.border?'borderCss':'')">
                        <p class="item-title"> 混凝土测温 </p>
                        <div style="width:100%;height:50rem;padding-left:30rem;display:flex;" class="hunlin">
                        </div>
                        <div style="width:100%;height:240rem;padding:10rem 20rem;">
                            <div id="hunlin1" style="width:100%; height:200rem;"></div>
                        </div>
                        <div style="width:100%;height:240rem;padding:10rem 20rem;">
                            <div id="hunlin2" style="width:100%; height:200rem;"></div>
                        </div>
                        <div style="width:100%;height:240rem;padding:10rem 20rem;">
                            <div id="hunlin3" style="width:100%; height:200rem;"></div>
                        </div>
                    </div>

                    <div v-if="element.index=='20' && element.show" class="item-div" :style="{'margin-top':element.margin+'rem','margin-bottom':element.margin+'rem'}" :class="(element.border?'borderCss':'')">
                        <p class="item-title"> BIM </p>
                        <div style="width:100%;height:370rem;position: relative;padding:10rem 20rem;">
                            <iframe width="100%" src='https://720yun.com/t/e8vkne87pdw' frameborder="no" style="border: 0;height: 100%;"></iframe>
                        </div>
                    </div> -->
                </li>
            </draggable>
        </div>
        
        <!--  -->
        <div class="list-group-box1" style="margin:0;">
            <draggable class="list-group" tag="ul" :list="list1" group="project" @change="log" style="background: transparent;padding:0;">
                <li class="list-group-item" v-for="(element, index) in list1" :key="index">
                    <!-- list0 -->
                    <!-- <div v-if="element.index=='1' && element.show" class="item-div" :style="{'margin-top':element.margin+'rem','margin-bottom':element.margin+'rem'}">
                        <div style="width:100%;height:30rem;position: relative;display:flex;justify-content: space-between;padding:0 36rem;">
                            <p>
                                <span class="crile"></span>
                                <span style="color:#34ECFF;font-size:22rem;">今日出勤</span>
                                <span style="color:#34ECFF;font-size:22rem;margin-left:50rem;">{{attend.allTeamsCount}}</span>
                            </p>
                        </div>
                        <div style="width:100%;height:60rem;position: relative;display:flex;align-items: center;margin-top:30rem;">
                            <p style="width:25%;position: relative;text-align: center;padding:0 18rem;"></p>
                            <p style="width:50%;position: relative;text-align: center;padding:0 18rem;">出勤人数</p>
                            <p style="width:25%;position: relative;text-align: center;padding:0 18rem;">出勤率</p>
                        </div>
                        <div style="width:100%;height:300rem;position: relative;overflow: hidden;">
                            <ul>
                                <li style="height:80rem;align-content: center;align-items: center;width: 100%;position: relative;display: flex;">
                                    <p style="width:25%;padding:0 18rem;">
                                        <span class="nowrap" style="display: inline-block;width: 100%;">管理人员</span>
                                    </p>
                                    <p style="width:50%;padding:0 18rem;">
                                        <img src="../../assets/image/visual/li0.png" style="width:86rem;height:42rem;position: absolute;left: calc( 50% - 43rem );top: -12rem;" />
                                        <span class="nowrap" style="display: inline-block;width: 100%;">{{attend.manageCount}}</span>
                                    </p>
                                    <p style="width:25%;padding:0 18rem;">
                                        <img src="../../assets/image/visual/li0.png" style="width:86rem;height:42rem;position: absolute;left: calc( 50% - 43rem );top: -12rem;" />
                                        <span class="nowrap" style="display: inline-block;width: 100%;">{{attend.manageRate}}%</span>
                                    </p>
                                </li>
                                <li style="height:80rem;align-content: center;align-items: center;width: 100%;position: relative;display: flex;">
                                    <p style="width:25%;padding:0 18rem;">
                                        <span class="nowrap" style="display: inline-block;width: 100%;">建筑工人</span>
                                    </p>
                                    <p style="width:50%;padding:0 18rem;">
                                        <img src="../../assets/image/visual/li1.png" style="width:86rem;height:42rem;position: absolute;left: calc( 50% - 43rem );top: -12rem;" />
                                        <span class="nowrap" style="display: inline-block;width: 100%;">{{attend.workersCount}}</span>
                                    </p>
                                    <p style="width:25%;padding:0 18rem;">
                                        <img src="../../assets/image/visual/li1.png" style="width:86rem;height:42rem;position: absolute;left: calc( 50% - 43rem );top: -12rem;" />
                                        <span class="nowrap" style="display: inline-block;width: 100%;">{{attend.workersRate}}%</span>
                                    </p>
                                </li>
                                <li style="height:80rem;align-content: center;align-items: center;width: 100%;position: relative;display: flex;">
                                    <p style="width:25%;padding:0 18rem;">
                                        <span class="nowrap" style="display: inline-block;width: 100%;">特种人员</span>
                                    </p>
                                    <p style="width:50%;padding:0 18rem;">
                                        <img src="../../assets/image/visual/li0.png" style="width:86rem;height:42rem;position: absolute;left: calc( 50% - 43rem );top: -12rem;" />
                                        <span class="nowrap" style="display: inline-block;width: 100%;">{{attend.specialCount}}</span>
                                    </p>
                                    <p style="width:25%;padding:0 18rem;">
                                        <img src="../../assets/image/visual/li0.png" style="width:86rem;height:42rem;position: absolute;left: calc( 50% - 43rem );top: -12rem;" />
                                        <span class="nowrap" style="display: inline-block;width: 100%;">{{attend.specialRate}}%</span>
                                    </p>
                                </li>
                            </ul>
                        </div>
                    </div>
                    
                    <div v-if="element.index=='2' && element.show" class="item-div" :style="{'margin-top':element.margin+'rem','margin-bottom':element.margin+'rem'}">
                        <div style="width:100%;height:30rem;position: relative;display:flex;justify-content: space-between;padding:0 36rem;">
                            <p>
                                <span class="crile"></span>
                                <span style="color:#34ECFF;font-size:22rem;">在场人员</span>
                                <span style="color:#34ECFF;font-size:22rem;margin-left:50rem;">{{persent.allTeamsCount}}</span>
                            </p>
                        </div>
                        <div style="width:100%;height:60rem;position: relative;display:flex;align-items: center;margin-top:30rem;">
                            <p style="width:25%;position: relative;text-align: center;padding:0 18rem;"></p>
                            <p style="width:50%;position: relative;text-align: center;padding:0 18rem;">出勤人数</p>
                            <p style="width:25%;position: relative;text-align: center;padding:0 18rem;">出勤率</p>
                        </div>
                        <div style="width:100%;height:300rem;position: relative;overflow: hidden;">
                            <ul>
                                <li style="height:80rem;align-content: center;align-items: center;width: 100%;position: relative;display: flex;">
                                    <p style="width:25%;padding:0 18rem;">
                                        <span class="nowrap" style="display: inline-block;width: 100%;">管理人员</span>
                                    </p>
                                    <p style="width:50%;padding:0 18rem;">
                                        <img src="../../assets/image/visual/li0.png" style="width:86rem;height:42rem;position: absolute;left: calc( 50% - 43rem );top: -12rem;" />
                                        <span class="nowrap" style="display: inline-block;width: 100%;">{{persent.manageCount}}</span>
                                    </p>
                                    <p style="width:25%;padding:0 18rem;">
                                        <img src="../../assets/image/visual/li0.png" style="width:86rem;height:42rem;position: absolute;left: calc( 50% - 43rem );top: -12rem;" />
                                        <span class="nowrap" style="display: inline-block;width: 100%;">{{persent.manageRate}}%</span>
                                    </p>
                                </li>
                                <li style="height:80rem;align-content: center;align-items: center;width: 100%;position: relative;display: flex;">
                                    <p style="width:25%;padding:0 18rem;">
                                        <span class="nowrap" style="display: inline-block;width: 100%;">建筑工人</span>
                                    </p>
                                    <p style="width:50%;padding:0 18rem;">
                                        <img src="../../assets/image/visual/li1.png" style="width:86rem;height:42rem;position: absolute;left: calc( 50% - 43rem );top: -12rem;" />
                                        <span class="nowrap" style="display: inline-block;width: 100%;">{{persent.workersCount}}</span>
                                    </p>
                                    <p style="width:25%;padding:0 18rem;">
                                        <img src="../../assets/image/visual/li1.png" style="width:86rem;height:42rem;position: absolute;left: calc( 50% - 43rem );top: -12rem;" />
                                        <span class="nowrap" style="display: inline-block;width: 100%;">{{persent.workersRate}}%</span>
                                    </p>
                                </li>
                                <li style="height:80rem;align-content: center;align-items: center;width: 100%;position: relative;display: flex;">
                                    <p style="width:25%;padding:0 18rem;">
                                        <span class="nowrap" style="display: inline-block;width: 100%;">特种人员</span>
                                    </p>
                                    <p style="width:50%;padding:0 18rem;">
                                        <img src="../../assets/image/visual/li0.png" style="width:86rem;height:42rem;position: absolute;left: calc( 50% - 43rem );top: -12rem;" />
                                        <span class="nowrap" style="display: inline-block;width: 100%;">{{persent.specialCount}}</span>
                                    </p>
                                    <p style="width:25%;padding:0 18rem;">
                                        <img src="../../assets/image/visual/li0.png" style="width:86rem;height:42rem;position: absolute;left: calc( 50% - 43rem );top: -12rem;" />
                                        <span class="nowrap" style="display: inline-block;width: 100%;">{{persent.specialRate}}%</span>
                                    </p>
                                </li>
                            </ul>
                        </div>
                    </div>

                    <div v-if="element.index=='3' && element.show" class="item-div" :style="{'margin-top':element.margin+'rem','margin-bottom':element.margin+'rem'}">
                        <div style="width:100%;height:30rem;position: relative;display:flex;justify-content: space-between;padding:0 36rem;">
                            <p>
                                <span class="crile"></span>
                                <span style="color:#34ECFF;font-size:22rem;">人员动态</span>
                            </p>
                        </div>
                        <div style="width:100%;height:100rem;position: relative;display:flex;padding:0 36rem;align-items: center;">
                            <p style="font-size:18rem;color:#fff;padding-left:30rem;">累计采集{{syn.zs}}人</p>
                            <p style="font-size:18rem;color:#fff;padding-left:50rem;">实名占比{{syn.smRate}}</p>
                        </div>
                        <div style="width:100%;height:360rem;position: relative;display:flex;">
                            <div style="width: 50%;height: 100%;">
                                <div id="myChart1" style="width:100%; height:100%"></div>
                            </div>
                            <div class="first-gress-con" style="width: 50%;height: 100%;position: relative;display: flex;flex-wrap: wrap;">
                                <p style="color:#fff;display:flex;align-items: flex-end;padding-left:20rem;">在职人员（{{syn.zz}}/{{syn.zs}}）</p>
                                <p style="width: 100%;position: relative;height: 20rem;"><el-progress :percentage="parseFloat(syn.zzLv)" :stroke-width="20"></el-progress></p>
                                <p style="color:#fff;display:flex;align-items: flex-end;padding-left:20rem;">未在职人员（{{syn.wzz}}/{{syn.zs}}）</p>
                                <p style="width: 100%;position: relative;height: 20rem;"><el-progress :percentage="parseFloat(syn.wzzLv)" :stroke-width="20" color="#FF9F20"></el-progress></p>
                                <p style="color:#fff;display:flex;align-items: flex-end;padding-left:20rem;">未实名人员（{{syn.lz}}/{{syn.zs}}）</p>
                                <p style="width: 100%;position: relative;height: 20rem;"><el-progress :percentage="parseFloat(syn.lzLv)" :stroke-width="20" color="#E66E3A"></el-progress></p>
                            </div>
                        </div>
                    </div>

                    <div v-if="element.index=='4' && element.show" class="item-div" :style="{'margin-top':element.margin+'rem','margin-bottom':element.margin+'rem'}">
                        <div style="width:100%;height:60rem;position: relative;display:flex;justify-content: space-between;padding:0 36rem;">
                            <p>
                                <span class="crile"></span>
                                <span style="color:#34ECFF;font-size:22rem;">班组出勤</span>
                            </p>
                        </div>
                        <div style="width:100%;height:60rem;position: relative;display:flex;align-items: center;">
                            <p style="width:25%;position: relative;text-align: center;padding:0 18rem;">班组</p>
                            <p style="width:25%;position: relative;text-align: center;padding:0 18rem;">人数</p>
                            <p style="width:25%;position: relative;text-align: center;padding:0;">出勤人数</p>
                            <p style="width:25%;position: relative;text-align: center;padding:0 18rem;">出勤率</p>
                        </div>
                        <div style="width:100%;height:420rem;position: relative;overflow: hidden;">
                            <ul :class="{anim:animate==true}">
                                <li v-for="(item,index) in attendTeam" :key="index" style="height:80rem;align-content: center;align-items: center;width: 100%;position: relative;display: flex;">
                                    <p style="width:25%;padding:0 18rem;">
                                        <span class="nowrap" style="display: inline-block;width: 100%;" :title="item.teamsName">{{item.teamsName}}</span>
                                    </p>
                                    <p style="width:25%;padding:0 18rem;">
                                        <img src="../../assets/image/visual/li0.png" style="width:86rem;height:42rem;position: absolute;left: calc( 50% - 43rem );top: -12rem;" />
                                        <span class="nowrap" style="display: inline-block;width: 100%;">{{item.zzCount}}</span>
                                    </p>
                                    <p style="width:25%;padding:0;">
                                        <img src="../../assets/image/visual/li0.png" style="width:86rem;height:42rem;position: absolute;left: calc( 50% - 43rem );top: -12rem;" />
                                        <span class="nowrap" style="display: inline-block;width: 100%;">{{item.cqCount}}</span>
                                    </p>
                                    <p style="width:25%;padding:0 18rem;">
                                        <img src="../../assets/image/visual/li0.png" style="width:86rem;height:42rem;position: absolute;left: calc( 50% - 43rem );top: -12rem;" />
                                        <span class="nowrap" style="display: inline-block;width: 100%;">{{item.lv}}%</span>
                                    </p>
                                </li>
                            </ul>
                        </div>
                    </div>

                    <div v-if="element.index=='5' && element.show" class="item-div" :style="{'margin-top':element.margin+'rem','margin-bottom':element.margin+'rem'}">
                        <div style="width:100%;height:30rem;position: relative;display:flex;justify-content: space-between;padding:0 36rem;">
                            <p>
                                <span class="crile"></span>
                                <span style="color:#34ECFF;font-size:22rem;">合同信息</span>
                            </p>
                            <p style="color:#fff;font-size:20rem;">应签合同{{agreeNum.yqht}}人</p>
                            <p style="color:#fff;font-size:20rem;">已网签{{agreeNum.ywq}}人</p>
                            <p style="color:#fff;font-size:20rem;">未网签{{agreeNum.wxq}}人</p>
                        </div>
                        <div style="width:100%;height:60rem;position: relative;display:flex;align-items: center;margin-top:30rem;">
                            <p style="width:25%;position: relative;text-align: center;padding:0 18rem;">姓名</p>
                            <p style="width:50%;position: relative;text-align: center;padding:0 18rem;">入职时间</p>
                            <p style="width:25%;position: relative;text-align: center;padding:0 18rem;">合同状态</p>
                        </div>
                        <div style="width:100%;height:420rem;position: relative;overflow: hidden;">
                            <ul :class="{anim1:animate1==true}">
                                <li v-for="(item,index) in tableAgree" :key="index" style="height:60rem;align-content: center;align-items: center;width: 100%;position: relative;display: flex;">
                                    <p style="width:25%;padding:0 18rem;">
                                        <span class="nowrap" style="display: inline-block;width: 100%;">{{item.name}}</span>
                                    </p>
                                    <p style="width:50%;padding:0 18rem;">
                                        <span class="nowrap" style="display: inline-block;width: 100%;">{{item.create_date}}</span>
                                    </p>
                                    <p style="width:25%;padding:0 18rem;">
                                        <span v-if="item.status=='已网签'" style="display: inline-block;width: 100%;color:#FFFFFF;">已网签</span>
                                        <span v-else style="display: inline-block;width: 100%;color:#E66E3A;">未网签</span>
                                    </p>
                                </li>
                            </ul>
                        </div>
                    </div> -->
                    <!-- list1 -->
                    <div v-if="element.index=='6' && element.show" class="item-div" :style="{'margin-top':element.margin+'rem','margin-bottom':element.margin+'rem'}" :class="(element.border?'borderCss':'')">
                        <p class="item-title"> 质量安全 </p>
                        <div style="width:100%;height:400rem;position: relative;display:flex;">
                            <div style="width:50%;height:100%;position: relative;display:flex;flex-wrap:wrap;">
                                <p style="width:100%;font-size:20rem;position: relative;height:100rem;display: flex;align-items: flex-end;align-content: center;justify-content: center;">项目检查  {{qsChar.projectAllQsCount}}次</p>
                                <div style="width:100%;height:300rem;position: relative;display:flex;justify-content: center;flex-wrap:wrap;align-content: flex-start;">
                                    <div id="safe1" style="width:100%; height:200rem;"></div>
                                    <div style="width:100%;height:60rem;display:flex;flex-wrap:wrap;align-content: center;justify-content: space-around;">
                                        <p style="margin-top:20rem;text-align: left;">
                                            <span style="width: 18rem;height: 18rem;background: #1299F3;border-radius: 50%;display: inline-block;"></span>
                                            <span style="margin-left:10rem;">符合</span>
                                        </p>
                                        <p style="margin-top:20rem;text-align: left;">
                                            <span style="width: 18rem;height: 18rem;background: #FF9B52;border-radius: 50%;display: inline-block;"></span>
                                            <span style="margin-left:10rem;">待处理</span>
                                        </p>
                                        <p style="margin-top:20rem;text-align: left;">
                                            <span style="width: 18rem;height: 18rem;background: #4EE6B7;border-radius: 50%;display: inline-block;"></span>
                                            <span style="margin-left:10rem;">已处理</span>
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div style="width:50%;height:100%;position: relative;display:flex;flex-wrap:wrap;">
                                <p style="width:100%;font-size:20rem;position: relative;height:100rem;display: flex;align-items: flex-end;align-content: center;justify-content: center;">公司检查  {{qsChar.entAllQsCount}}次</p>
                                <div style="width:100%;height:300rem;position: relative;display:flex;justify-content: center;flex-wrap:wrap;align-content: flex-start;">
                                    <div id="safe2" style="width:100%; height:200rem;"></div>
                                    <div style="width:100%;height:60rem;display:flex;flex-wrap:wrap;align-content: center;justify-content: space-around;">
                                        <p style="margin-top:20rem;text-align: left;">
                                            <span style="width: 18rem;height: 18rem;background: #6E38A8;border-radius: 50%;display: inline-block;"></span>
                                            <span style="margin-left:20rem;">符合</span>
                                        </p>
                                        <p style="margin-top:20rem;text-align: left;">
                                            <span style="width: 18rem;height: 18rem;background: #70BFED;border-radius: 50%;display: inline-block;"></span>
                                            <span style="margin-left:20rem;">待处理</span>
                                        </p>
                                        <p style="margin-top:20rem;text-align: left;">
                                            <span style="width: 18rem;height: 18rem;background: #F47E86;border-radius: 50%;display: inline-block;"></span>
                                            <span style="margin-left:20rem;">已处理</span>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div v-if="element.index=='7' && element.show" class="item-div" :style="{'margin-top':element.margin+'rem','margin-bottom':element.margin+'rem'}" :class="(element.border?'borderCss':'')">
                        <p class="item-title"> 疫情管控 </p>
                        <div style="width:100%;height:400rem;position: relative;margin-top:20rem;padding:0 20rem;">
                            <div id="disease1" style="width:100%; height:100%;"></div>
                        </div>
                        <div style="width:100%;height:400rem;position: relative;margin-top:20rem;padding:0 20rem;">
                            <div id="disease2" style="width:100%; height:100%;"></div>
                        </div>
                    </div>

                    <div v-if="element.index=='8' && element.show" class="item-div" :style="{'margin-top':element.margin+'rem','margin-bottom':element.margin+'rem'}" :class="(element.border?'borderCss':'')">
                        <p class="item-title"> 车辆统计 </p>
                        <div style="width:100%;height:300rem;position: relative;margin-top:20rem;padding:0 20rem;">
                            <div id="car1" style="width:100%; height:100%;"></div>
                        </div>
                    </div>
                    <!-- list4 -->
                    <!-- <div v-if="element.index=='18' && element.show" class="item-div" :style="{'margin-top':element.margin+'rem','margin-bottom':element.margin+'rem'}" :class="(element.border?'borderCss':'')">
                        <p class="item-title"> 高支模监测 </p>
                        <div style="width:100%;height:760rem;position: relative;padding:20rem 40rem;">
                            <div style="width:100%;height:120rem;position: relative;display:flex;align-items: center;">
                                <p style="width:200rem;">位移（米）</p>
                                <div style="width:calc( 100% - 200rem );position: relative;height:32rem;background: linear-gradient(270deg, #91E3F7 0%, #6CB8FB 51%, #468CFF 99%, #468CFF 100%);">
                                    <div :style="{'left':'calc( '+highMod.wyRate1+' - 50rem )'}" style="width:100rem;height:80rem;position: absolute;top:-33rem;display:flex;flex-wrap:wrap;justify-content: center;justify-items: center;">
                                        <p style="width:100%;height:20rem;position: relative;text-align: center;">{{highMod.wyVal1}}</p>
                                        <p style="width:1rem;height:55rem;border-left: 1rem dashed #fff;"></p>
                                    </div>
                                </div>
                            </div>
                            <div style="width:100%;height:120rem;position: relative;display:flex;align-items: center;">
                                <p style="width:200rem;"></p>
                                <div style="width:calc( 100% - 200rem );position: relative;height:32rem;background: linear-gradient(270deg, #91E3F7 0%, #6CB8FB 51%, #468CFF 99%, #468CFF 100%);">
                                    <div :style="{'left':'calc( '+highMod.wyRate2+' - 50rem )'}" style="width:100rem;height:80rem;position: absolute;top:-33rem;display:flex;flex-wrap:wrap;justify-content: center;justify-items: center;">
                                        <p style="width:100%;height:20rem;position: relative;text-align: center;">{{highMod.wyVal2}}</p>
                                        <p style="width:1rem;height:55rem;border-left: 1rem dashed #fff;"></p>
                                    </div>
                                </div>
                            </div>
                            <div style="width:100%;height:120rem;position: relative;display:flex;align-items: center;">
                                <p style="width:200rem;">倾角（°）</p>
                                <div style="width:calc( 100% - 200rem );position: relative;height:32rem;background: linear-gradient(270deg, #FFA0E5 0%, #FF86B8 52%, #FF6C8B 100%);">
                                    <div :style="{'left':'calc( '+highMod.qjRate1+' - 50rem )'}" style="width:100rem;height:80rem;position: absolute;top:-33rem;display:flex;flex-wrap:wrap;justify-content: center;justify-items: center;">
                                        <p style="width:100%;height:20rem;position: relative;text-align: center;">{{highMod.qjVal1}}</p>
                                        <p style="width:1rem;height:55rem;border-left: 1rem dashed #fff;"></p>
                                    </div>
                                </div>
                            </div>
                            <div style="width:100%;height:120rem;position: relative;display:flex;align-items: center;">
                                <p style="width:200rem;"></p>
                                <div style="width:calc( 100% - 200rem );position: relative;height:32rem;background: #7D6CFF;">
                                    <div :style="{'left':'calc( '+highMod.qjRate2+' - 50rem )'}" style="width:100rem;height:80rem;position: absolute;top:-33rem;display:flex;flex-wrap:wrap;justify-content: center;justify-items: center;">
                                        <p style="width:100%;height:20rem;position: relative;text-align: center;">{{highMod.qjVal2}}</p>
                                        <p style="width:1rem;height:55rem;border-left: 1rem dashed #fff;"></p>
                                    </div>
                                </div>
                            </div>
                            <div style="width:100%;height:120rem;position: relative;display:flex;align-items: center;">
                                <p style="width:200rem;">压力（N）</p>
                                <div style="width:calc( 100% - 200rem );position: relative;height:32rem;background: linear-gradient(270deg, #ABA0FF 0%, #9486FF 51%, #7D6CFF 99%, #7D6CFF 100%);">
                                    <div :style="{left:'calc( '+highMod.ylRate1+' - 50rem )'}" style="width:100rem;height:80rem;position: absolute;top:-33rem;display:flex;flex-wrap:wrap;justify-content: center;justify-items: center;">
                                        <p style="width:100%;height:20rem;position: relative;text-align: center;">{{highMod.ylVal1}}</p>
                                        <p style="width:1rem;height:55rem;border-left: 1rem dashed #fff;"></p>
                                    </div>
                                </div>
                            </div>
                            <div style="width:100%;height:120rem;position: relative;display:flex;align-items: center;">
                                <p style="width:200rem;"></p>
                                <div style="width:calc( 100% - 200rem );position: relative;height:32rem;background: linear-gradient(270deg, #ABA0FF 0%, #9486FF 51%, #7D6CFF 99%, #7D6CFF 100%);">
                                    <div :style="{'left':'calc( '+highMod.ylRate2+' - 50rem )'}" style="width:100rem;height:80rem;position: absolute;top:-33rem;display:flex;flex-wrap:wrap;justify-content: center;justify-items: center;">
                                        <p style="width:100%;height:20rem;position: relative;text-align: center;">{{highMod.ylVal2}}</p>
                                        <p style="width:1rem;height:55rem;border-left: 1rem dashed #fff;"></p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div v-if="element.index=='19' && element.show" class="item-div" :style="{'margin-top':element.margin+'rem','margin-bottom':element.margin+'rem'}" :class="(element.border?'borderCss':'')">
                        <p class="item-title"> 混凝土测温 </p>
                        <div style="width:100%;height:50rem;padding-left:30rem;" class="hunlin">
                            
                        </div>
                        <div style="width:100%;height:240rem;padding:10rem 20rem;">
                            <div id="hunlin1" style="width:100%; height:200rem;"></div>
                        </div>
                        <div style="width:100%;height:240rem;padding:10rem 20rem;">
                            <div id="hunlin2" style="width:100%; height:200rem;"></div>
                        </div>
                        <div style="width:100%;height:240rem;padding:10rem 20rem;">
                            <div id="hunlin3" style="width:100%; height:200rem;"></div>
                        </div>
                    </div>

                    <div v-if="element.index=='20' && element.show" class="item-div" :style="{'margin-top':element.margin+'rem','margin-bottom':element.margin+'rem'}" :class="(element.border?'borderCss':'')">
                        <p class="item-title"> BIM </p>
                        <div style="width:100%;height:370rem;position: relative;padding:10rem 20rem;">
                            <iframe width="100%" src='https://720yun.com/t/e8vkne87pdw' frameborder="no" style="border: 0;height: 100%;"></iframe>
                        </div>
                    </div> -->
                </li>
            </draggable>
        </div>
        <div style="width:4720rem;height:2935rem; position: relative;display:flex;flex-wrap:wrap;margin:0;">
            <div style="width:3320rem;height:100%;display:flex;flex-wrap:wrap;">
                <div style="width:100%;height:400rem;padding-left:520rem;display: flex;justify-content: space-around;align-content: center;align-items: center;padding-top: 84rem;">
                    <div style="width:356rem;height:164rem;position: relative;border-radius: 5rem;background: linear-gradient(360deg, #0E4CC7 0%, #0374DE 100%, #0374DE 100%);display:flex;align-content: center;flex-wrap:wrap;">
                        <p style="width:100%;text-align: center;font-size:36rem;">{{proInfo.allDay}}</p>
                        <p style="width:100%;text-align: center;font-size:36rem;">总工期（天）</p>
                        
                    </div>
                    <div style="width:356rem;height:164rem;position: relative;border-radius: 5rem;background: linear-gradient(360deg, #006FC7 0%, #00B6D5 100%, #00B6D5 100%);display:flex;align-content: center;flex-wrap:wrap;">
                        <p style="width:100%;text-align: center;font-size:36rem;">{{proInfo.planDays}}</p>
                        <p style="width:100%;text-align: center;font-size:36rem;">计划进度</p>
                    </div>
                    <div style="width:356rem;height:164rem;position: relative;border-radius: 5rem;background: linear-gradient(360deg, #0C47CF 0%, #5D05D6 100%, #5D05D6 100%);display:flex;align-content: center;flex-wrap:wrap;">
                        <p style="width:100%;text-align: center;font-size:36rem;">{{proInfo.allDay - proInfo.otherDay}}</p>
                        <p style="width:100%;text-align: center;font-size:36rem;">剩余天数（天）</p>
                        
                    </div>
                    <div style="width:356rem;height:164rem;position: relative;border-radius: 5rem;background: linear-gradient(360deg, #260EAA 0%, #0475DB 100%, #0475DB 100%);display:flex;align-content: center;flex-wrap:wrap;">
                        <p style="width:100%;text-align: center;font-size:36rem;">{{proInfo.settlementValue}}</p>
                        <p style="width:100%;text-align: center;font-size:36rem;">进度产值</p>
                    </div>
                </div>
                <div class="list-group-box1" style="width:1400rem;height:2535rem;margin:0;">
                    <draggable class="list-group" tag="ul" :list="list2" group="project1" @change="log" style="background: transparent;padding:0;">
                        <li class="list-group-item" v-for="(element, index) in list2" :key="index">
                            <div v-if="element.index=='9' && element.show" class="item-div" :style="{'margin-top':element.margin+'rem','margin-bottom':element.margin+'rem'}" :class="(element.border?'borderCss':'')">
                                <p class="item-title"> 能耗统计 </p>
                                <div style="width:100%;height:400rem;position: relative;margin-top:20rem;padding:0 20rem;display:flex;">
                                    <div style="width:66%;hegiht:100%;position: relative;">
                                        <div style="width:100%;height:60rem;position: relative;text-align: center;">
                                            <span>用电统计</span>
                                            <el-select v-model="eleYear" placeholder="请选择" style="position:absolute;top:0;right:50rem;">
                                                <el-option
                                                v-for="(item,index) in years"
                                                :key="index"
                                                :label="item.name"
                                                :value="item.value">
                                                </el-option>
                                            </el-select>
                                        </div>
                                        <div id="energy1" style="width:100%; height:340rem;"></div>
                                    </div>
                                    <div style="width:34%;hegiht:100%;position: relative;padding-top:60rem;">
                                        <div id="energy2" style="width:100%; height:340rem;"></div>
                                    </div>
                                </div>
                                <div style="width:100%;height:400rem;position: relative;margin-top:20rem;padding:20rem 20rem 0;display:flex;">
                                    <div style="width:66%;hegiht:100%;position: relative;">
                                        <div style="width:100%;height:60rem;position: relative;text-align: center;">
                                            <span>用水统计</span>
                                            <el-select v-model="waterYear" placeholder="请选择" style="position:absolute;top:0;right:50rem;">
                                                <el-option
                                                v-for="(item,index) in years"
                                                :key="index"
                                                :label="item.name"
                                                :value="item.value">
                                                </el-option>
                                            </el-select>
                                        </div>
                                        <div id="energy3" style="width:100%; height:300rem;"></div>
                                    </div>
                                    <div style="width:34%;hegiht:100%;position: relative;padding-top:30rem;">
                                        <div id="energy4" style="width:100%; height:340rem;"></div>
                                    </div>
                                </div>
                            </div>
                            <div v-if="element.index=='10' && element.show" class="item-div" :style="{'margin-top':element.margin+'rem','margin-bottom':element.margin+'rem'}" :class="(element.border?'borderCss':'')">
                                <p class="item-title"> 塔吊监测 </p>
                                <div style="width:180rem;height:100%;position: absolute;top:0;left:0;background: rgba(19, 145, 218, 0.2);border: 1rem solid #1391DA;overflow: auto;">
                                    <div class="main-left-item" v-for="(item,index) in towerlist" :key="index" :class="{'curTower':towerId==item.id}" @click="changeTower(item)">
                                        <p class="name nowrap" style="width:100%;height:40rem;">{{item.name}}</p>
                                        <p class="state color8" style="width:100%;text-align: right;transform: scale(0.8);margin-top: 6rem;" v-if="item.online=='离线'">离线</p>
                                        <p class="state color10" style="width:100%;text-align: right;transform: scale(0.8);margin-top: 6rem;" v-else-if="item.online=='正常'" >正常</p>
                                        <p class="state color9" style="width:100%;text-align: right;transform: scale(0.8);margin-top: 6rem;" v-else >{{item.online}}</p>
                                    </div>
                                </div>
                                <div style="width:calc( 100% - 180rem );height:320rem;position: relative;margin-left:180rem;">
                                    <div style="width: 100%;height: 100%;position: relative;display: flex;flex-wrap: wrap;">
                                        <div style="width: 40%;height: 100%;position: relative;padding: 20rem 10rem 10rem;display: flex;flex-wrap: wrap;">
                                            <p style="text-align: center;font-size:20rem;height:30rem;width:100%;top: -3px">实时监控</p>
                                            <div style="width:100%;height:calc( 100% - 30rem );padding:10rem 0;">
                                                <p class="real-data-l-item">
                                                    <span style="">设备幅度</span>
                                                    <span style="padding:0 10rem;">{{ towerPart.radius||0 }}m</span>
                                                </p>
                                                <p class="real-data-l-item">
                                                    <span style="">吊钩高度</span>
                                                    <span style="padding:0 10rem;">{{ towerPart.hight||0 }}m</span>
                                                </p>
                                                <p class="real-data-l-item">
                                                    <span style="">额定吊重</span>
                                                    <span style="padding:0 10rem;">{{ towerPart.ratedWeight||0 }}吨</span>
                                                </p>
                                                <p class="real-data-l-item">
                                                    <span style="">塔吊力矩</span>
                                                    <span style="padding:0 10rem;">{{ towerPart.lijupercent||0 }}N</span>
                                                </p>
                                                <p class="real-data-l-item">
                                                    <span style="">吊重&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                                    <span style="padding:0 10rem;">{{ towerPart.loadweightr||0 }}吨</span>
                                                </p>
                                                <p class="real-data-l-item">
                                                    <span style="">前倾角&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                                    <span style="padding:0 10rem;">{{towerPart.fall||0}}度</span>
                                                </p>
                                            </div>
                                        </div>
                                        <div class="real-clock" style="width:25%;">
                                            <p style="text-align: left;padding-left:10rem;font-size:20rem;height:30rem;width:100%;text-align: center;">塔吊回转</p>
                                            <div class="real-clock-con" id="wrap">
                                                <ul id="list">
                                                    <li></li><li></li><li></li><li></li><li></li><li></li>
                                                    <li></li><li></li><li></li><li></li><li></li><li></li>
                                                    <li></li><li></li><li></li><li></li><li></li><li></li>
                                                    <li></li><li></li><li></li><li></li><li></li><li></li>
                                                    <li></li><li></li><li></li><li></li><li></li><li></li>
                                                    <li></li><li></li><li></li><li></li><li></li><li></li>
                                                    <li></li><li></li><li></li><li></li><li></li>
                                                    <li></li><li></li><li></li><li></li><li></li>
                                                    <li></li><li></li><li></li><li></li><li></li><li></li>
                                                    <li></li><li></li><li></li><li></li><li></li><li></li><li></li><li></li>
                                                </ul>
                                                <div class="icon"></div>
                                                <div
                                                    id="clockLine"
                                                    :style="{'-webkit-transform': 'rotate('+towerPart.angle+'deg)'}"
                                                ></div>
                                                <div class="num0">0</div>
                                                <div class="num90">90</div>
                                                <div class="num180">180</div>
                                                <div class="num270">270</div>
                                            </div>
                                        </div>
                                        <div style="width: 33%;height: 100%;position: relative;padding: 10rem;display: flex;flex-wrap: wrap;">
                                            <p style="text-align: center;font-size:20rem;height:30rem;width:100%;">吊钩可视化</p>
                                            <div v-if="cameraData && cameraData.serial" style="width:100%;height:calc( 100% - 30rem );position: relative;">
                                                <iframe width="100%" height="100%" :src='towerVideo' style="border: 0;height: 100%;"></iframe>
                                            </div>
                                            <div v-else style="width:100%;height:calc( 100% - 80rem );position: relative;">
                                                <img src="../../assets/image/monitorBg.png" style="width:100%;height:100%;" />
                                                <p style="width:100%;height:40rem;text-align: center;position: absolute;top:65%;left:0;">暂无视频</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div v-if="element.index=='11' && element.show" class="item-div" :style="{'margin-top':element.margin+'rem','margin-bottom':element.margin+'rem'}" :class="(element.border?'borderCss':'')">
                                <p class="item-title"> 扬尘监测 </p>
                                <div style="width:100%;height:450rem;position: relative;margin-top:20rem;display:flex;">
                                    <div style="width:66%;height:100%;position: relative;">
                                        <div id="dust1" style="width:100%; height:100%;"></div>
                                    </div>
                                    <div style="width:34%;height:100%;position: relative;">
                                        <div id="dust2" style="width:100%; height:100%;"></div>
                                    </div>
                                </div>
                            </div>
                            <div v-if="element.index=='12' && element.show" class="item-div" :style="{'margin-top':element.margin+'rem','margin-bottom':element.margin+'rem'}" :class="(element.border?'borderCss':'')" style="padding:0 20rem;">
                                <p class="item-title">进出口实时人脸考勤</p>
                                <p style="width:100%;height:50rem;position: relative;display: flex;align-content: center;align-items: center;justify-content: flex-start;">{{inOutName}}</p>
                                <div style="width:100%;position: relative;height:620rem;display:flex;">
                                    <div style="width:620rem;height:calc( 100% - 20rem );" v-if="inOutUrl!=''">
                                        <iframe width="100%" height="100%" :src='inOutUrl' style="border: 0;height: 100%;"></iframe>
                                    </div>
                                    <div style="width:620rem;height:calc( 100% - 20rem );background:#ddd;" v-else></div>
                                    <div style="width:700rem;height:97%;position: relative;padding:0 0 0 60rem;display:flex;flex-wrap:wrap;align-content: flex-start;overflow: hidden;">
                                        <div v-for="(item,index) in inOutList" :key="index" style="width:100%;height:165rem;position: relative;margin-bottom: 35rem;display:flex;">
                                            <div style="width:320rem;height:100%;background:rgb(134 234 255 / 8%);display:flex;padding:10rem;justify-content: space-between;">
                                                <div style="width:85rem;height:100%;position: relative;display:flex;flex-wrap:wrap;">
                                                    <img :src="item.photoImg" style="width:100%;height:100rem;position: relative;" />
                                                    <p style="width:100%;text-align: center;">抓拍人脸</p>
                                                </div>
                                                <div style="width:140rem;height:100%;position: relative;">
                                                    <el-progress type="circle" :percentage="parseFloat(item.contrast)"></el-progress>
                                                </div>
                                                <div style="width:85rem;height:100%;position: relative;display:flex;flex-wrap:wrap;">
                                                    <img :src="item.uploadImg" style="width:100%;height:100rem;position: relative;" />
                                                    <p style="width:100%;text-align: center;">比对人脸</p>
                                                </div>
                                            </div>
                                            <div style="width:320rem;height:100%;position: relative;display:flex;flex-wrap:wrap;align-content: space-around;padding-left:30rem;">
                                                <p style="width:100%;position: relative;text-align: left;">姓名：{{item.name}}</p>
                                                <p style="width:100%;position: relative;text-align: left;">时间：{{item.time}}</p>
                                                <p style="width:100%;position: relative;text-align: left;display:flex;">安康码：
                                                    <img :src="item.anSrc" style="width:46rem;height:46rem;" />
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-if="element.index=='21' && element.show" class="item-div" :style="{'margin-top':element.margin+'rem','margin-bottom':element.margin+'rem'}" :class="(element.border?'borderCss':'')">
                                <p class="item-title"> 卸料平台 </p>
                                <div style="width:180rem;height:100%;position: absolute;top:0;left:0;background: rgba(19, 145, 218, 0.2);border: 1rem solid #1391DA;overflow: auto;">
                                    <div class="main-left-item" v-for="(item,index) in unloadList" :key="index" :class="{'curUnload':unloadId==item.verifyCode}" @click="changeTower(item)">
                                        <p class="name nowrap" style="width:100%;height:35rem;">{{item.unloadName}}</p>
                                        <p class="state color8" style="width:100%;text-align: right;" v-if="item.status=='0'">离线</p>
                                        <p class="state color10" style="width:100%;text-align: right;" v-else-if="item.status=='1'" >在线</p>
                                    </div>
                                </div>
                                <div style="width:calc( 100% - 180rem );height:505rem;position: relative;margin-left:180rem;">
                                    <p style="width:100%;height:60rem;position: relative;display:flex;">
                                        <span style="width: 60%;text-align: left;padding-left: 20rem;">实时数据</span>
                                        <span style="font-size:14rem;transform: scale(0.8);">{{unloadInfo.updateDate}}</span>
                                    </p>
                                    <div style="width:100%;height:160rem;position: relative;display:flex;">
                                        <div style="width:33%;height:100%;position: relative;display:flex;flex-wrap:wrap;">
                                            <p style="width:100%;height:30rem;font-size:14rem;transform: scale(0.8);text-align: left;">设备号：{{unloadInfo.verifyCode}}</p>
                                            <p class="nowrap" style="width:100%;height:50rem;font-size:14rem;transform: scale(0.8);text-align: left;">设备名称：{{unloadInfo.unloadName}}</p>
                                            <p style="width:100%;height:30rem;font-size:14rem;transform: scale(0.8);text-align: left;top: -10rem;">设备电量：{{unloadInfo.electricQuantity}}%</p>
                                        </div>
                                        <div style="width:33%;height:100%;position: relative;">
                                            <div id="unload1" style="width:130%;height:130%;position: relative;top:-15%;left:-15%;"></div>
                                            <p style="width:100%;height:30rem;top: -50rem;transform: scale(0.5);">
                                                <span style="padding:5rem 10rem;color:#FE0000;background:rgb(240 240 240 / 0.4);font-size:14rem;">偏置值：{{unloadInfo.bias}}</span>
                                            </p>
                                        </div>
                                        <div style="width:33%;height:100%;position: relative;">
                                            <div id="unload3" style="width:130%;height:130%;position: relative;top:-15%;left:-15%;"></div>
                                            <p style="width:100%;height:30rem;top: -50rem;transform: scale(0.5);">
                                                <span style="padding:5rem 10rem;color:#FE0000;background:rgb(240 240 240 / 0.4);font-size:14rem;">报警：{{unloadInfo.alarmWeight}}吨</span>
                                            </p>
                                        </div>
                                    </div>
                                    <div style="width:100%;height:240rem;">
                                        <div class="unload-date" style="width:100%;height:40rem;position: relative;text-align: left;padding-left:10rem;">
                                            <el-date-picker
                                                v-model="unloadTime"
                                                style="transform: scale(0.8);left: -12rem;width: 200rem;"
                                                type="month"
                                                value-format="yyyy-MM"
                                                placeholder="选择日期">
                                            </el-date-picker>
                                        </div>
                                        <div style="width:100%;height:40rem;position: relative;display:flex;align-items: center;margin-top:0rem;">
                                            <p style="width:20%;position: relative;text-align: center;padding:0;">设备号</p>
                                            <p style="width:20%;position: relative;text-align: center;padding:0;">偏置值</p>
                                            <p style="width:20%;position: relative;text-align: center;padding:0;">预警重量</p>
                                            <p style="width:20%;position: relative;text-align: center;padding:0;">报警重量</p>
                                            <p style="width:20%;position: relative;text-align: center;padding:0;">监测时间</p>
                                        </div>
                                        <div style="width:100%;height:200rem;position: relative;overflow: hidden;">
                                            <ul :class="{anim5:animate5==true}">
                                                <li v-for="(item,index) in unloadLog" :key="index" style="height:50rem;align-content: center;align-items: center;width: 100%;position: relative;display: flex;">
                                                    <p style="width:20%;padding:0;">
                                                        <span class="nowrap" style="display: inline-block;width: 100%;">{{item.verifyCode}}</span>
                                                    </p>
                                                    <p style="width:20%;padding:0;">
                                                        <span class="nowrap" style="display: inline-block;width: 100%;">{{item.bias}}</span>
                                                    </p>
                                                    <p style="width:20%;padding:0;">
                                                        <span class="nowrap" style="display: inline-block;width: 100%;">{{item.earlyWarningWeight}}</span>
                                                    </p>
                                                    <p style="width:20%;padding:0;">
                                                        <span class="nowrap" style="display: inline-block;width: 100%;">{{item.alarmWeight}}</span>
                                                    </p>
                                                    <p style="width:20%;padding:0;">
                                                        <span class="nowrap" style="display: inline-block;width: 100%;">{{item.time}}</span>
                                                    </p>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- lsit3 -->
                            <!-- <div v-if="element.index=='13' && element.show" class="item-div" :style="{'margin-top':element.margin+'rem','margin-bottom':element.margin+'rem'}" :class="(element.border?'borderCss':'')">
                                <p class="item-title"> 设备运行监测 </p>
                                <div class="item-div" style="margin-top:64rem;">
                                    <p class="item-head-p">
                                        <span></span>
                                        <span class="b-line">考勤机</span>
                                        <span class="b-line">塔吊设备</span>
                                        <span class="b-line">视频监控</span>
                                        <span class="b-line">升降机设备</span>
                                        <span class="b-line">能耗设备</span>
                                        <span class="b-line">车辆抓拍</span>
                                    </p>
                                    <div class="item1-con" style="padding:0;">
                                        <div class="device-item">
                                            <p>总</p>
                                            <p class="b-line" v-for="item in equipStatusList" :key="item.index">{{item.total}}</p>
                                        </div>
                                        <div class="device-item1">
                                            <p>在线</p>
                                            <p v-for="item in equipStatusList" :key="item.index">
                                                <img src="../../assets/image/vis/dev-bg.gif" style="width:70rem;height:70rem;" />
                                                <span class="item-span" style="left:0;">{{item.online}}</span>
                                            </p>
                                        </div>
                                        <div class="device-item1">
                                            <p>离线</p>
                                            <p v-for="item in equipStatusList" :key="item.index">
                                                <img src="../../assets/image/vis/dev-bg1.png" style="width:80rem;height:80rem;" />
                                                <span class="item-span" style="left:0;top:0;">{{item.offline}}</span>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-if="element.index=='14' && element.show" class="item-div" :style="{'margin-top':element.margin+'rem','margin-bottom':element.margin+'rem'}" :class="(element.border?'borderCss':'')">
                                <p class="item-title"> 监控预警 </p>
                                <div style="width:100%;height:600rem;position: relative;padding:0 10rem;overflow: hidden;">
                                    <ul :class="{anim3:animate3==true}">
                                        <li v-for="(item,index) in qsList" :key="index" style="width:100%;height:200rem;position: relative;padding:10rem;display:flex;">
                                            <img :src="item.imagePath" style="width:220rem;height:180rem;" />
                                            <div style="width:260rem;height:100%;display:flex;padding:10rem 20rem;align-items: center;">
                                                {{item.tsStr}}
                                            </div>
                                            <div style="width:calc( 50% - 240rem );height:100%;display:flex;flex-wrap: wrap;">
                                                <p style="width:100%;display: flex;justify-content: flex-start;align-items: center;">处理状态：
                                                    <span style="color:#E6A23C;" v-if="item.checkStatus=='未处理'">{{item.checkStatus}}</span>
                                                    <span style="color:#4B7FCD;" v-else>{{item.checkStatus}}</span>
                                                </p>
                                                <p style="width:100%;display: flex;justify-content: flex-start;align-items: center;">发现地点：{{item.channelName}}</p>
                                                <p style="width:100%;display: flex;justify-content: flex-start;align-items: center;">发现时间：{{item.happenDate}}</p>
                                            </div>
                                            <div style="width:calc( 50% - 240rem );height:100%;display:flex;flex-wrap: wrap;">
                                                <p style="width:100%;display: flex;justify-content: flex-start;align-items: center;">处理人：{{item.handlerName||'--'}}</p>
                                                <p style="width:100%;display: flex;justify-content: flex-start;align-items: center;">处理信息：{{item.handlerMsg||'--'}}</p>
                                                <p style="width:100%;display: flex;justify-content: flex-start;align-items: center;"></p>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div v-if="element.index=='15' && element.show" class="item-div" :style="{'margin-top':element.margin+'rem','margin-bottom':element.margin+'rem'}" :class="(element.border?'borderCss':'')">
                                <p class="item-title"> 安康码管控系统 </p>
                                <div class="num-box" style="width: 100%;height: 100rem;position: relative;padding:0 10rem;display: flex;">
                                    <div class="num-box-item" style="width: 25%;height: 100%;position: relative;cursor: pointer;text-align: center;">
                                        <div class="txt" style="width:140rem;height:100%;position: relative;background:#597EF0;border-radius: 5rem;margin: 0 auto;">
                                            <p style="width:100%;padding-left:20rem;text-align: left;color:#fff;">{{ankangNum.registered}}</p>
                                            <p style="width:100%;padding-left:20rem;text-align: left;color:#fff;">今日入场</p>
                                        </div>
                                    </div>
                                    <div class="num-box-item" style="text-align: center;">
                                        <div class="txt" style="width:140rem;height:100%;position: relative;background:#0CCF93;border-radius: 5rem;margin: 0 auto;">
                                            <p style="width:100%;padding-left:20rem;text-align: left;color:#fff;">{{ankangNum.green}}</p>
                                            <p style="width:100%;padding-left:20rem;text-align: left;color:#fff;">正常绿码</p>
                                        </div>
                                    </div>
                                    <div class="num-box-item" style="text-align: center;">
                                        <div class="txt" style="width:140rem;height:100%;position: relative;background:#F8DA2A;border-radius: 5rem;margin: 0 auto;">
                                            <p style="width:100%;padding-left:20rem;text-align: left;color:#fff;">{{ankangNum.yellow}}</p>
                                            <p style="width:100%;padding-left:20rem;text-align: left;color:#fff;">异常黄码</p>
                                        </div>
                                    </div>
                                    <div class="num-box-item" style="text-align: center;">
                                        <div class="txt" style="width:140rem;height:100%;position: relative;background:#F9693B;border-radius: 5rem;margin: 0 auto;">
                                            <p style="width:100%;padding-left:20rem;text-align: left;color:#fff;">{{ankangNum.red}}</p>
                                            <p style="width:100%;padding-left:20rem;text-align: left;color:#fff;">异常红码</p>
                                        </div>
                                    </div>
                                </div>
                                <div style="width:100%;height:50rem;position: relative;display:flex;align-items: center;margin-top:30rem;">
                                    <p style="width:20%;position: relative;text-align: center;padding:0 18rem;">姓名</p>
                                    <p style="width:20%;position: relative;text-align: center;padding:0 18rem;">照片</p>
                                    <p style="width:40%;position: relative;text-align: center;padding:0 18rem;">采集时间</p>
                                    <p style="width:20%;position: relative;text-align: center;padding:0 18rem;">安康码</p>
                                </div>
                                <div class="second-body" style="height:400rem;">
                                    <div class="table-head-list" style="height:100%;overflow: hidden;">
                                        <ul :class="{anim2:animate2==true}">
                                            <li class="table-li" v-for="item in ankangList" :key="item.id" style="height:70rem;">
                                                <p style="width:20%;padding:0 18rem;">{{item.personName}}</p>
                                                <p style="width:20%;padding:0 18rem;">
                                                    <img :src="item.idcardPhoto" style="height:60rem;" />
                                                </p>
                                                <p style="width:40%;padding:0 18rem;">
                                                    <span >{{item.dates}}</span>
                                                </p>
                                                <p style="width:20%;padding:0 18rem;">
                                                    <img :src="item.codeImg" style="height:60rem;" />
                                                </p>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                            <div v-if="element.index=='16' && element.show" class="item-div" :style="{'margin-top':element.margin+'rem','margin-bottom':element.margin+'rem'}" :class="(element.border?'borderCss':'')">
                                <p class="item-title"> 升降机监测 </p>
                                <div style="width:100%;height:370rem;position: relative;display:flex;padding:0 20rem;">
                                    <div style="width:34%;height:100%;display:flex;flex-wrap:wrap;">
                                        <p style="width:100%;height:50rem;position: relative;padding:10rem 20rem;text-align: left;">实时监控</p>
                                        <p style="width:100%;height:30rem;position: relative;display:flex;justify-content: space-around;align-items: center;">
                                            <span>额定吊重：{{liftPart.weightReay}}kg</span>
                                            <span>额定高度：{{liftPart.height}}m</span>
                                        </p>
                                        <p style="width:100%;height:30rem;position: relative;text-align: center;">实时速度：{{liftPart.speed}}m/s</p>
                                        <div style="width:100%;height:160rem;position: relative;text-align: center;">
                                            <img src="../../assets/image/ele-stop.png" style="height:160rem;width:125rem;" />
                                        </div>
                                    </div>
                                    <div style="width:66%;height:100%;">
                                        <p style="width:100%;height:50rem;position: relative;padding:10rem 20rem;text-align:center;">设备状态</p>
                                        <div style="width:100%;height:320rem;position: relative;display:flex;flex-wrap:wrap;">
                                            <div style="width:100%;height:80rem;position: relative;display:flex;align-items: center;">
                                                <p style="width:150rem;height:40rem;display:flex;display: flex;justify-content: center;align-items: center;">实时重量</p>
                                                <p style="width:100rem;height:40rem;background:url(../../assets/image/visual/li1.png);background-size:100% 100%;display: flex;justify-content: center;align-items: center;">
                                                    <img src="../../assets/image/visual/li1.png" style="width:100rem;height:40rem;position: absolute;top: 0;left: 0;" />
                                                    <span>{{liftPart.weight}}吨</span>
                                                </p>
                                                <p style="width:calc( 33% - 50rem );height:40rem;display: flex;justify-content: center;align-items: center;">前面</p>
                                                <p style="width:calc( 33% - 50rem );height:40rem;display: flex;justify-content: center;align-items: center;">
                                                    <span v-if="liftPart.systemStatusForelockStatus=='1'" class="color6">预警</span>
                                                    <span v-else-if="liftPart.systemStatusForelockStatus=='2'" style="color:red;">报警</span>
                                                    <span v-else class="color10">正常</span>
                                                </p>
                                                <p style="width:calc( 33% - 50rem );height:40rem;display: flex;justify-content: center;align-items: center;">预警次数  {{liftPart.msqm}}</p>
                                            </div>
                                            <div style="width:100%;height:80rem;position: relative;display:flex;align-items: center;">
                                                <p style="width:150rem;height:40rem;display:flex;display: flex;justify-content: center;align-items: center;">重量百分比</p>
                                                <p style="width:100rem;height:40rem;background:url(../../assets/image/visual/li1.png);background-size:100% 100%;display: flex;justify-content: center;align-items: center;">
                                                    <img src="../../assets/image/visual/li1.png" style="width:100rem;height:40rem;position: absolute;top: 0;left: 0;" />
                                                    <span>{{liftPart.weightPercent}}%</span>
                                                </p>
                                                <p style="width:calc( 33% - 50rem );height:40rem;display: flex;justify-content: center;align-items: center;">后门</p>
                                                <p style="width:calc( 33% - 50rem );height:40rem;display: flex;justify-content: center;align-items: center;">
                                                    <span v-if="liftPart.systemStatusBehindlockStatus=='1'" class="color6">预警</span>
                                                    <span v-else-if="liftPart.systemStatusBehindlockStatus=='2'" style="color:red;">报警</span>
                                                    <span v-else class="color10">正常</span>
                                                </p>
                                                <p style="width:calc( 33% - 50rem );height:40rem;display: flex;justify-content: center;align-items: center;">预警次数  {{liftPart.mshm}}</p>
                                            </div>
                                            <div style="width:100%;height:80rem;position: relative;display:flex;align-items: center;">
                                                <p style="width:150rem;height:40rem;display:flex;display: flex;justify-content: center;align-items: center;">实时高度</p>
                                                <p style="width:100rem;height:40rem;background:url(../../assets/image/visual/li1.png);background-size:100% 100%;display: flex;justify-content: center;align-items: center;">
                                                    <img src="../../assets/image/visual/li1.png" style="width:100rem;height:40rem;position: absolute;top: 0;left: 0;" />
                                                    <span>{{liftPart.height}}米</span>
                                                </p>
                                                <p style="width:calc( 33% - 50rem );height:40rem;display: flex;justify-content: center;align-items: center;">姿态状态</p>
                                                <p style="width:calc( 33% - 50rem );height:40rem;display: flex;justify-content: center;align-items: center;">
                                                    <span v-if="liftPart.systemStatusTilt=='1'" class="color6">预警</span>
                                                    <span v-else-if="liftPart.systemStatusTilt=='2'" style="color:red;">报警</span>
                                                    <span v-else class="color10">正常</span>
                                                </p>
                                                <p style="width:calc( 33% - 50rem );height:40rem;display: flex;justify-content: center;align-items: center;">预警次数  {{liftPart.qxyj}}</p>
                                            </div>
                                            <div style="width:100%;height:80rem;position: relative;display:flex;align-items: center;">
                                                <p style="width:150rem;height:40rem;display:flex;display: flex;justify-content: center;align-items: center;">高度百分比</p>
                                                <p style="width:100rem;height:40rem;background:url(../../assets/image/visual/li1.png);background-size:100% 100%;display: flex;justify-content: center;align-items: center;">
                                                    <img src="../../assets/image/visual/li1.png" style="width:100rem;height:40rem;position: absolute;top: 0;left: 0;" />
                                                    <span>{{liftPart.heightPercent}}%</span>
                                                </p>
                                                <p style="width:calc( 33% - 50rem );height:40rem;display: flex;justify-content: center;align-items: center;">重量状态</p>
                                                <p style="width:calc( 33% - 50rem );height:40rem;display: flex;justify-content: center;align-items: center;">
                                                    <span v-if="liftPart.systemStatusWeight=='1'" class="color6">预警</span>
                                                    <span v-else-if="liftPart.systemStatusWeight=='2'" style="color:red;">报警</span>
                                                    <span v-else class="color10">正常</span>
                                                </p>
                                                <p style="width:calc( 33% - 50rem );height:40rem;display: flex;justify-content: center;align-items: center;">预警次数  {{liftPart.zlyj}}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div v-if="element.index=='17' && element.show" class="item-div" :style="{'margin-top':element.margin+'rem','margin-bottom':element.margin+'rem'}" :class="(element.border?'borderCss':'')">
                                <p class="item-title"> BIM交互管理 </p>
                                <div style="width:100%;height:580rem;position: relative;padding:20rem 40rem;">
                                    <img src="../../assets/image/visual/bim1.png" style="width:100%;height:100%;" />
                                </div>
                            </div> -->
                        </li>
                    </draggable>
                </div>
                <div class="list-group-box1" style="width:1920rem;height:2535rem;margin:0;">
                    <div style="width:100%;height:1135rem;position: relative;padding:0 20rem;background: rgba(13, 25, 57, 0.45);border: 2rem solid #707070;">
                        <p class="item-title"> 安全帽统计 </p>
                        <div style="width:100%;height:1010rem;">
                            <baidu-map class="map-box" :center="center" :zoom="12" @ready="handler" @click="getClickInfo">
                                <bm-marker v-for="(item,index) in points" @click="clickHandler(item)" :key="index" :position="item.position" :rotation='item.angle' :icon="{url: require('../../assets/image/vis/worker.png'), size: {width: 50, height: 50}}">
                                </bm-marker>
                            </baidu-map>
                        </div>
                        <!-- <div style="width:100%;height:300rem;display:flex;justify-content: space-between;align-items: center;">
                            <div style="width:500rem;height:280rem;">
                                <p style="width:100%;height:30rem;">安全帽定位VF</p>
                                <div></div>
                            </div>
                            <div style="width:500rem;height:280rem;">
                                <p style="width:100%;height:30rem;">安全帽定位VF</p>
                                <div></div>
                            </div>
                            <div style="width:500rem;height:280rem;">
                                <p style="width:100%;height:30rem;">安全帽定位VF</p>
                                <div></div>
                            </div>
                        </div> -->
                    </div>
                    <div style="width:100%;height:1400rem;position: relative;background: rgba(13, 25, 57, 0.45);border: 2rem solid #707070;">
                        <p class="item-title"> 现场监控 </p>
                        <div style="width:100%;height:70rem;">
                            <el-pagination
                                @size-change="handleSizeChange"
                                @current-change="handleCurrentChange"
                                :current-page="currentPage"
                                :page-sizes="[6]"
                                layout="total, sizes, prev, pager, next"
                                :total="totalItems"
                            ></el-pagination>
                        </div>
                        <div style="width:100%;height:1200rem;position: relative;padding:20rem;display: flex;flex-wrap: wrap;align-content: flex-start;justify-content: flex-start;">
                            <div class="monitorbox-item" v-for="(item,index) in monitorList" :key="index">
                                <div class="item-monitor">
                                    <iframe width="100%" height="100%" :src='item.showUrl' style="border: 0;height: 100%;"></iframe>
                                </div>
                                <p class="item-info">
                                    <span class="name nowrap">{{item.name}}</span>
                                    <img v-if="item.type=='1'" src="../../assets/image/visual/gun.png" />
                                    <img v-else-if="item.type=='2'" src="../../assets/image/visual/ptz.png" />
                                    <span style="margin-right: 20rem;cursor: pointer;" @click="toDetail(item.serial,item.channelNo)">操作</span>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div style="width:1400rem;height:100%;padding-top:150rem;">
                <draggable class="list-group" tag="ul" :list="list3" group="project1" @change="log" style="background: transparent;padding:0;">
                    <li class="list-group-item" v-for="(element, index) in list3" :key="index">
                        <!-- list2 -->
                        <div v-if="element.index=='9' && element.show" class="item-div" :style="{'margin-top':element.margin+'rem','margin-bottom':element.margin+'rem'}" :class="(element.border?'borderCss':'')">
                            <p class="item-title"> 能耗统计 </p>
                            <div style="width:100%;height:400rem;position: relative;margin-top:20rem;padding:0 20rem;display:flex;">
                                <div style="width:66%;hegiht:100%;position: relative;">
                                    <div style="width:100%;height:60rem;position: relative;text-align: center;">
                                        <span>用电统计</span>
                                        <el-select v-model="eleYear" placeholder="请选择" style="position:absolute;top:0;right:50rem;">
                                            <el-option
                                            v-for="(item,index) in years"
                                            :key="index"
                                            :label="item.name"
                                            :value="item.value">
                                            </el-option>
                                        </el-select>
                                    </div>
                                    <div id="energy1" style="width:100%; height:340rem;"></div>
                                </div>
                                <div style="width:34%;hegiht:100%;position: relative;padding-top:60rem;">
                                    <div id="energy2" style="width:100%; height:340rem;"></div>
                                </div>
                            </div>
                            <div style="width:100%;height:400rem;position: relative;margin-top:20rem;padding:20rem 20rem 0;display:flex;">
                                <div style="width:66%;hegiht:100%;position: relative;">
                                    <div style="width:100%;height:60rem;position: relative;text-align: center;">
                                        <span>用水统计</span>
                                        <el-select v-model="waterYear" placeholder="请选择" style="position:absolute;top:0;right:50rem;">
                                            <el-option
                                            v-for="(item,index) in years"
                                            :key="index"
                                            :label="item.name"
                                            :value="item.value">
                                            </el-option>
                                        </el-select>
                                    </div>
                                    <div id="energy3" style="width:100%; height:300rem;"></div>
                                </div>
                                <div style="width:34%;hegiht:100%;position: relative;padding-top:30rem;">
                                    <div id="energy4" style="width:100%; height:340rem;"></div>
                                </div>
                            </div>
                        </div>
                        <div v-if="element.index=='10' && element.show" class="item-div" :style="{'margin-top':element.margin+'rem','margin-bottom':element.margin+'rem'}" :class="(element.border?'borderCss':'')">
                            <p class="item-title"> 塔吊监测 </p>
                            <div style="width:180rem;height:100%;position: absolute;top:0;left:0;background: rgba(19, 145, 218, 0.2);border: 1rem solid #1391DA;overflow: auto;">
                                <div class="main-left-item" v-for="(item,index) in towerlist" :key="index" :class="{'curTower':towerId==item.id}" @click="changeTower(item)">
                                    <p class="name nowrap" style="width:100%;height:40rem;">{{item.name}}</p>
                                    <p class="state color8" style="width:100%;text-align: right;transform: scale(0.8);margin-top: 6rem;" v-if="item.online=='离线'">离线</p>
                                    <p class="state color10" style="width:100%;text-align: right;transform: scale(0.8);margin-top: 6rem;" v-else-if="item.online=='正常'" >正常</p>
                                    <p class="state color9" style="width:100%;text-align: right;transform: scale(0.8);margin-top: 6rem;" v-else >{{item.online}}</p>
                                    <!-- <p class="num nowrap">设备编号：{{item.deviceId}}</p> -->
                                </div>
                            </div>
                            <div style="width:calc( 100% - 180rem );height:320rem;position: relative;margin-left:174rem;">
                                <div style="width: 100%;height: 100%;position: relative;display: flex;flex-wrap: wrap;">
                                    <div style="width: 40%;height: 100%;position: relative;padding: 20rem 10rem 10rem;display: flex;flex-wrap: wrap;">
                                        <p style="text-align: center;font-size:20rem;height:30rem;width:100%;top: -3px">实时监控</p>
                                        <div style="width:100%;height:calc( 100% - 30rem );padding:10rem 0;">
                                            <p class="real-data-l-item">
                                                <span style="">设备幅度</span>
                                                <span style="padding:0 10rem;">{{ towerPart.radius||0 }}m</span>
                                            </p>
                                            <p class="real-data-l-item">
                                                <span style="">吊钩高度</span>
                                                <span style="padding:0 10rem;">{{ towerPart.hight||0 }}m</span>
                                            </p>
                                            <p class="real-data-l-item">
                                                <span style="">额定吊重</span>
                                                <span style="padding:0 10rem;">{{ towerPart.ratedWeight||0 }}吨</span>
                                            </p>
                                            <p class="real-data-l-item">
                                                <span style="">塔吊力矩</span>
                                                <span style="padding:0 10rem;">{{ towerPart.lijupercent||0 }}N</span>
                                            </p>
                                            <p class="real-data-l-item">
                                                <span style="">吊重&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                                <span style="padding:0 10rem;">{{ towerPart.loadweightr||0 }}吨</span>
                                            </p>
                                            <p class="real-data-l-item">
                                                <span style="">前倾角&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                                <span style="padding:0 10rem;">{{towerPart.fall||0}}度</span>
                                            </p>
                                        </div>
                                    </div>
                                    <div class="real-clock" style="width:25%;">
                                        <p style="text-align: left;padding-left:10rem;font-size:20rem;height:30rem;width:100%;text-align: center;">塔吊设备回转</p>
                                        <div class="real-clock-con" id="wrap">
                                            <ul id="list">
                                                <li></li><li></li><li></li><li></li><li></li><li></li>
                                                <li></li><li></li><li></li><li></li><li></li><li></li>
                                                <li></li><li></li><li></li><li></li><li></li><li></li>
                                                <li></li><li></li><li></li><li></li><li></li><li></li>
                                                <li></li><li></li><li></li><li></li><li></li><li></li>
                                                <li></li><li></li><li></li><li></li><li></li><li></li>
                                                <li></li><li></li><li></li><li></li><li></li>
                                                <li></li><li></li><li></li><li></li><li></li>
                                                <li></li><li></li><li></li><li></li><li></li><li></li>
                                                <li></li><li></li><li></li><li></li><li></li><li></li><li></li><li></li>
                                            </ul>
                                            <div class="icon"></div>
                                            <div
                                                id="clockLine"
                                                :style="{'-webkit-transform': 'rotate('+towerPart.angle+'deg)'}"
                                            ></div>
                                            <div class="num0">0</div>
                                            <div class="num90">90</div>
                                            <div class="num180">180</div>
                                            <div class="num270">270</div>
                                        </div>
                                    </div>
                                    <div style="width: 33%;height: 100%;position: relative;padding: 10rem;display: flex;flex-wrap: wrap;">
                                        <p style="text-align: left;padding-left:10rem;font-size:20rem;height:30rem;width:100%;">吊钩可视化</p>
                                        <div v-if="cameraData && cameraData.serial" style="width:100%;height:calc( 100% - 80rem );position: relative;">
                                            <iframe width="100%" height="100%" :src='towerVideo' style="border: 0;height: 100%;"></iframe>
                                        </div>
                                        <div v-else style="width:100%;height:calc( 100% - 80rem );position: relative;">
                                            <img src="../../assets/image/monitorBg.png" style="width:100%;height:100%;" />
                                            <p style="width:100%;height:40rem;text-align: center;position: absolute;top:65%;left:0;">暂无视频</p>
                                        </div>
                                        <p class="item-info" v-if="cameraData && cameraData.name">
                                            <span class="name nowrap">{{cameraData.name}}</span>
                                            <img v-if="cameraData.type=='1'" src="../../assets/image/gun.png" />
                                            <img v-else-if="cameraData.type=='2'" src="../../assets/image/ptz.png" />
                                            <span style="margin-right: 20rem;cursor: pointer;" @click="toDetail(cameraData.serial,cameraData.channelNo)">操作</span>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div v-if="element.index=='11' && element.show" class="item-div" :style="{'margin-top':element.margin+'rem','margin-bottom':element.margin+'rem'}" :class="(element.border?'borderCss':'')">
                            <p class="item-title"> 扬尘监测 </p>
                            <div style="width:100%;height:450rem;position: relative;margin-top:20rem;display:flex;">
                                <div style="width:66%;height:100%;position: relative;">
                                    <div id="dust1" style="width:100%; height:100%;"></div>
                                </div>
                                <div style="width:34%;height:100%;position: relative;">
                                    <div id="dust2" style="width:100%; height:100%;"></div>
                                </div>
                            </div>
                        </div>
                        <div v-if="element.index=='12' && element.show" class="item-div" :style="{'margin-top':element.margin+'rem','margin-bottom':element.margin+'rem'}" :class="(element.border?'borderCss':'')" style="padding:0 20rem;">
                            <p class="item-title">进出口实时人脸考勤</p>
                            <p style="width:100%;height:50rem;position: relative;display: flex;align-content: center;align-items: center;justify-content: flex-start;">{{inOutName}}</p>
                            <div style="width:100%;position: relative;height:620rem;display:flex;">
                                <div style="width:620rem;height:calc( 100% - 20rem );" v-if="inOutUrl!=''">
                                    <iframe width="100%" height="100%" :src='inOutUrl' style="border: 0;height: 100%;"></iframe>
                                </div>
                                <div style="width:620rem;height:calc( 100% - 20rem );background:#ddd;" v-else></div>
                                <div style="width:700rem;height:97%;position: relative;padding:0 0 0 60rem;display:flex;flex-wrap:wrap;align-content: flex-start;overflow: hidden;">
                                    <div v-for="(item,index) in inOutList" :key="index" style="width:100%;height:165rem;position: relative;margin-bottom: 35rem;display:flex;">
                                        <div style="width:320rem;height:100%;background:rgb(134 234 255 / 8%);display:flex;padding:10rem;justify-content: space-between;">
                                            <div style="width:85rem;height:100%;position: relative;display:flex;flex-wrap:wrap;">
                                                <img :src="item.photoImg" style="width:100%;height:100rem;position: relative;" />
                                                <p style="width:100%;text-align: center;">抓拍人脸</p>
                                            </div>
                                            <div style="width:140rem;height:100%;position: relative;">
                                                <el-progress type="circle" :percentage="parseFloat(item.contrast)"></el-progress>
                                            </div>
                                            <div style="width:85rem;height:100%;position: relative;display:flex;flex-wrap:wrap;">
                                                <img :src="item.uploadImg" style="width:100%;height:100rem;position: relative;" />
                                                <p style="width:100%;text-align: center;">比对人脸</p>
                                            </div>
                                        </div>
                                        <div style="width:320rem;height:100%;position: relative;display:flex;flex-wrap:wrap;align-content: space-around;padding-left:30rem;">
                                            <p style="width:100%;position: relative;text-align: left;">姓名：{{item.name}}</p>
                                            <p style="width:100%;position: relative;text-align: left;">时间：{{item.time}}</p>
                                            <p style="width:100%;position: relative;text-align: left;display:flex;">安康码：
                                                <img :src="item.anSrc" style="width:46rem;height:46rem;" />
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- lsit3 -->
                        <div v-if="element.index=='13' && element.show" class="item-div" :style="{'margin-top':element.margin+'rem','margin-bottom':element.margin+'rem'}" :class="(element.border?'borderCss':'')">
                            <p class="item-title"> 设备运行监测 </p>
                            <div class="item-div" style="margin-top:64rem;">
                                <p class="item-head-p">
                                    <span></span>
                                    <!-- <span class="b-line">人证采集机</span> -->
                                    <span class="b-line">考勤机</span>
                                    <span class="b-line">塔吊设备</span>
                                    <span class="b-line">视频监控</span>
                                    <span class="b-line">升降机</span>
                                    <!-- <span class="b-line">高支模设备</span>
                                    <span class="b-line">测温设备</span> -->
                                    <span class="b-line">能耗设备</span>
                                    <span class="b-line">车辆抓拍</span>
                                </p>
                                <div class="item1-con" style="padding:0;">
                                    <div class="device-item">
                                        <p>总</p>
                                        <p class="b-line" v-for="item in equipStatusList" :key="item.index">{{item.total}}</p>
                                    </div>
                                    <div class="device-item1">
                                        <p>在线</p>
                                        <p v-for="item in equipStatusList" :key="item.index">
                                            <img src="../../assets/image/vis/dev-bg.gif" style="width:70rem;height:70rem;" />
                                            <span class="item-span" style="left:0;">{{item.online}}</span>
                                        </p>
                                    </div>
                                    <div class="device-item1">
                                        <p>离线</p>
                                        <p v-for="item in equipStatusList" :key="item.index">
                                            <img src="../../assets/image/vis/dev-bg1.png" style="width:80rem;height:80rem;" />
                                            <span class="item-span" style="left:0;top:0;">{{item.offline}}</span>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-if="element.index=='14' && element.show" class="item-div" :style="{'margin-top':element.margin+'rem','margin-bottom':element.margin+'rem'}" :class="(element.border?'borderCss':'')">
                            <p class="item-title"> 监控预警 </p>
                            <div style="width:100%;height:600rem;position: relative;padding:0 10rem;overflow: hidden;">
                                <ul>
                                    <li v-for="(item,index) in qsList" :key="index" style="width:100%;height:200rem;position: relative;padding:10rem;display:flex;">
                                        <img :src="item.imagePath" style="width:220rem;height:180rem;" />
                                        <div style="width:260rem;height:100%;display:flex;padding:10rem 20rem;align-items: center;">
                                            {{item.tsStr}}
                                        </div>
                                        <div style="width:calc( 50% - 240rem );height:100%;display:flex;flex-wrap: wrap;">
                                            <p style="width:100%;display: flex;justify-content: flex-start;align-items: center;">处理状态：
                                                <span style="color:#E6A23C;" v-if="item.checkStatus=='未处理'">{{item.checkStatus}}</span>
                                                <span style="color:#4B7FCD;" v-else>{{item.checkStatus}}</span>
                                            </p>
                                            <p style="width:100%;display: flex;justify-content: flex-start;align-items: center;">发现地点：{{item.channelName}}</p>
                                            <p style="width:100%;display: flex;justify-content: flex-start;align-items: center;">发现时间：{{item.happenDate}}</p>
                                        </div>
                                        <div style="width:calc( 50% - 240rem );height:100%;display:flex;flex-wrap: wrap;">
                                            <p style="width:100%;display: flex;justify-content: flex-start;align-items: center;">处理人：{{item.handlerName||'--'}}</p>
                                            <p style="width:100%;display: flex;justify-content: flex-start;align-items: center;">处理信息：{{item.handlerMsg||'--'}}</p>
                                            <p style="width:100%;display: flex;justify-content: flex-start;align-items: center;"></p>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div v-if="element.index=='15' && element.show" class="item-div" :style="{'margin-top':element.margin+'rem','margin-bottom':element.margin+'rem'}" :class="(element.border?'borderCss':'')">
                            <p class="item-title"> 安康码管控系统 </p>
                            <div class="num-box" style="width: 100%;height: 100rem;position: relative;padding:0 10rem;display: flex;">
                                <div class="num-box-item" style="width: 25%;height: 100%;padding:0;position: relative;cursor: pointer;text-align: center;">
                                    <div class="txt" style="width:210rem;height:100%;align-items: flex-start;position: relative;background:#597EF0;border-radius: 5rem;margin: 0 auto;">
                                        <p style="width:100%;padding-left:20rem;text-align: left;color:#fff;top: -10rem;">{{ankangNum.registered}}</p>
                                        <p style="width:100%;text-align: left;color:#fff;top: -28rem;">今日入场</p>
                                    </div>
                                </div>
                                <div class="num-box-item" style="text-align: center;padding:0;">
                                    <div class="txt" style="width:210rem;height:100%;align-items: flex-start;position: relative;background:#0CCF93;border-radius: 5rem;margin: 0 auto;">
                                        <p style="width:100%;padding-left:20rem;text-align: left;color:#fff;top: -10rem;">{{ankangNum.green}}</p>
                                        <p style="width:100%;text-align: left;color:#fff;top: -28rem;">正常绿码</p>
                                    </div>
                                </div>
                                <div class="num-box-item" style="text-align: center;padding:0;">
                                    <div class="txt" style="width:210rem;height:100%;align-items: flex-start;position: relative;background:#F8DA2A;border-radius: 5rem;margin: 0 auto;">
                                        <p style="width:100%;padding-left:20rem;text-align: left;color:#fff;top: -10rem;">{{ankangNum.yellow}}</p>
                                        <p style="width:100%;text-align: left;color:#fff;top: -28rem;">异常黄码</p>
                                    </div>
                                </div>
                                <div class="num-box-item" style="text-align: center;padding:0;">
                                    <div class="txt" style="width:210rem;height:100%;align-items: flex-start;position: relative;background:#F9693B;border-radius: 5rem;margin: 0 auto;">
                                        <p style="width:100%;padding-left:20rem;text-align: left;color:#fff;top: -10rem;">{{ankangNum.red}}</p>
                                        <p style="width:100%;text-align: left;color:#fff;top: -28rem;">历史红码</p>
                                    </div>
                                </div>
                            </div>
                            <div style="width:100%;height:40rem;position: relative;display:flex;align-items: center;margin-top:10rem;">
                                <p style="width:20%;position: relative;text-align: center;padding:0 18rem;">姓名</p>
                                <p style="width:20%;position: relative;text-align: center;padding:0 18rem;">照片</p>
                                <p style="width:40%;position: relative;text-align: center;padding:0 18rem;">采集时间</p>
                                <p style="width:20%;position: relative;text-align: center;padding:0 18rem;">安康码</p>
                            </div>
                            <div class="second-body" style="height:200rem;">
                                <div class="table-head-list" style="height:100%;overflow: hidden;">
                                    <ul :class="{anim2:animate2==true}">
                                        <li class="table-li" v-for="item in ankangList" :key="item.id" style="height:70rem;">
                                            <p style="width:20%;padding:0 18rem;">{{item.personName}}</p>
                                            <p style="width:20%;padding:0 18rem;">
                                                <img :src="item.idcardPhoto" style="height:60rem;" />
                                            </p>
                                            <p style="width:40%;padding:0 18rem;">
                                                <span >{{item.dates}}</span>
                                            </p>
                                            <p style="width:20%;padding:0 18rem;">
                                                <img :src="item.codeImg" style="height:60rem;" />
                                            </p>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>

                        <div v-if="element.index=='16' && element.show" class="item-div" :style="{'margin-top':element.margin+'rem','margin-bottom':element.margin+'rem'}" :class="(element.border?'borderCss':'')">
                            <p class="item-title"> 升降机监测 </p>
                            <div style="width:100%;height:370rem;position: relative;display:flex;padding:0 20rem;">
                                <div style="width:34%;height:100%;display:flex;flex-wrap:wrap;">
                                    <!-- <p style="width:100%;height:30rem;position: relative;padding:5rem;text-align: left;">实时监控</p> -->
                                    <p style="width:100%;height:30rem;position: relative;display:flex;justify-content:flex-start;align-items: center;">
                                        <span>额定吊重:{{liftPart.weightReay}}kg</span>
                                        <span>额定高度:{{liftPart.height}}m</span>
                                    </p>
                                    <p style="width:100%;height:30rem;position: relative;text-align: center;">实时速度：{{liftPart.speed}}m/s</p>
                                    <div style="width:100%;height:140rem;position: relative;text-align: center;">
                                        <img src="../../assets/image/ele-stop.png" style="height:140rem;width:100rem;" />
                                    </div>
                                </div>
                                <div style="width:66%;height:100%;">
                                    <!-- <p style="width:100%;height:40rem;position: relative;padding:10rem 20rem;text-align:center;">设备状态</p> -->
                                    <div style="width:100%;height:360rem;position: relative;display:flex;flex-wrap:wrap;">
                                        <div style="width:100%;height:60rem;position: relative;display:flex;align-items: center;">
                                            <p style="width:200rem;height:40rem;display:flex;display: flex;justify-content: center;align-items: center;transform: scale(0.6);">实时重量</p>
                                            <p style="width:100rem;height:40rem;background:url(../../assets/image/visual/li1.png);background-size:100% 100%;display: flex;justify-content: center;align-items: center;">
                                                <img src="../../assets/image/visual/li1.png" style="width:100rem;height:40rem;position: absolute;top: 0;left: 0;" />
                                                <span>{{liftPart.weight}}吨</span>
                                            </p>
                                            <p style="width:calc( 33% - 50rem );height:40rem;display: flex;justify-content: center;align-items: center;transform: scale(0.8);">前面</p>
                                            <p style="width:calc( 33% - 80rem );height:40rem;display: flex;justify-content: center;align-items: center;transform: scale(0.8);">
                                                <span v-if="liftPart.systemStatusForelockStatus=='1'" class="color6">预警</span>
                                                <span v-else-if="liftPart.systemStatusForelockStatus=='2'" style="color:red;">报警</span>
                                                <span v-else class="color10">正常</span>
                                            </p>
                                            <p style="width:calc( 33% - 20rem );height:40rem;display: flex;justify-content: center;align-items: center;transform: scale(0.8);">预警次数  {{liftPart.msqm}}</p>
                                        </div>
                                        <div style="width:100%;height:60rem;position: relative;display:flex;align-items: center;">
                                            <p style="width:200rem;height:40rem;display:flex;display: flex;justify-content: center;align-items: center;transform: scale(0.6);">重量百分比</p>
                                            <p style="width:100rem;height:40rem;background:url(../../assets/image/visual/li1.png);background-size:100% 100%;display: flex;justify-content: center;align-items: center;">
                                                <img src="../../assets/image/visual/li1.png" style="width:100rem;height:40rem;position: absolute;top: 0;left: 0;" />
                                                <span>{{liftPart.weightPercent}}%</span>
                                            </p>
                                            <p style="width:calc( 33% - 50rem );height:40rem;display: flex;justify-content: center;align-items: center;transform: scale(0.8);">后门</p>
                                            <p style="width:calc( 33% - 80rem );height:40rem;display: flex;justify-content: center;align-items: center;transform: scale(0.8);">
                                                <span v-if="liftPart.systemStatusBehindlockStatus=='1'" class="color6">预警</span>
                                                <span v-else-if="liftPart.systemStatusBehindlockStatus=='2'" style="color:red;">报警</span>
                                                <span v-else class="color10">正常</span>
                                            </p>
                                            <p style="width:calc( 33% - 20rem );height:40rem;display: flex;justify-content: center;align-items: center;transform: scale(0.8);">预警次数  {{liftPart.mshm}}</p>
                                        </div>
                                        <div style="width:100%;height:60rem;position: relative;display:flex;align-items: center;">
                                            <p style="width:200rem;height:40rem;display:flex;display: flex;justify-content: center;align-items: center;transform: scale(0.6);">实时高度</p>
                                            <p style="width:100rem;height:40rem;background:url(../../assets/image/visual/li1.png);background-size:100% 100%;display: flex;justify-content: center;align-items: center;">
                                                <img src="../../assets/image/visual/li1.png" style="width:100rem;height:40rem;position: absolute;top: 0;left: 0;" />
                                                <span>{{liftPart.height}}米</span>
                                            </p>
                                            <p style="width:calc( 33% - 50rem );height:40rem;display: flex;justify-content: center;align-items: center;transform: scale(0.8);">姿态状态</p>
                                            <p style="width:calc( 33% - 80rem );height:40rem;display: flex;justify-content: center;align-items: center;transform: scale(0.8);">
                                                <span v-if="liftPart.systemStatusTilt=='1'" class="color6">预警</span>
                                                <span v-else-if="liftPart.systemStatusTilt=='2'" style="color:red;">报警</span>
                                                <span v-else class="color10">正常</span>
                                            </p>
                                            <p style="width:calc( 33% - 20rem );height:40rem;display: flex;justify-content: center;align-items: center;transform: scale(0.8);">预警次数  {{liftPart.qxyj}}</p>
                                        </div>
                                        <div style="width:100%;height:60rem;position: relative;display:flex;align-items: center;">
                                            <p style="width:200rem;height:40rem;display:flex;display: flex;justify-content: center;align-items: center;transform: scale(0.6);">高度百分比</p>
                                            <p style="width:100rem;height:40rem;background:url(../../assets/image/visual/li1.png);background-size:100% 100%;display: flex;justify-content: center;align-items: center;">
                                                <img src="../../assets/image/visual/li1.png" style="width:100rem;height:40rem;position: absolute;top: 0;left: 0;" />
                                                <span>{{liftPart.heightPercent}}%</span>
                                            </p>
                                            <p style="width:calc( 33% - 50rem );height:40rem;display: flex;justify-content: center;align-items: center;transform: scale(0.8);">重量状态</p>
                                            <p style="width:calc( 33% - 80rem );height:40rem;display: flex;justify-content: center;align-items: center;transform: scale(0.8);">
                                                <span v-if="liftPart.systemStatusWeight=='1'" class="color6">预警</span>
                                                <span v-else-if="liftPart.systemStatusWeight=='2'" style="color:red;">报警</span>
                                                <span v-else class="color10">正常</span>
                                            </p>
                                            <p style="width:calc( 33% - 20rem );height:40rem;display: flex;justify-content: center;align-items: center;transform: scale(0.8);">预警次数  {{liftPart.zlyj}}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div v-if="element.index=='17' && element.show" class="item-div" :style="{'margin-top':element.margin+'rem','margin-bottom':element.margin+'rem'}" :class="(element.border?'borderCss':'')">
                            <p class="item-title"> BIM交互管理 </p>
                            <div style="width:100%;height:580rem;position: relative;padding:20rem 40rem;">
                                <img src="../../assets/image/visual/bim1.png" style="width:100%;height:100%;" />
                            </div>
                        </div>
                    </li>
                </draggable>
            </div>
        </div>

        <div class="list-group-box1">
            <draggable class="list-group" tag="ul" :list="list4" group="project" @change="log" style="background:transparent;">
                <li class="list-group-item" v-for="(element, index) in list4" :key="index">
                    <!-- list0 -->
                    <div v-if="element.index=='1' && element.show" class="item-div" :style="{'margin-top':element.margin+'rem','margin-bottom':element.margin+'rem'}">
                        <div style="width:100%;height:30rem;position: relative;display:flex;justify-content: space-between;padding:0 36rem;">
                            <p>
                                <span class="crile"></span>
                                <span style="color:#34ECFF;font-size:22rem;">今日出勤</span>
                                <span style="color:#34ECFF;font-size:22rem;margin-left:50rem;">{{attend.allTeamsCount}}</span>
                            </p>
                        </div>
                        <div style="width:100%;height:60rem;position: relative;display:flex;align-items: center;margin-top:30rem;">
                            <p style="width:25%;position: relative;text-align: center;padding:0 18rem;"></p>
                            <p style="width:50%;position: relative;text-align: center;padding:0 18rem;">出勤人数</p>
                            <p style="width:25%;position: relative;text-align: center;padding:0 18rem;">出勤率</p>
                        </div>
                        <div style="width:100%;height:300rem;position: relative;overflow: hidden;">
                            <ul>
                                <li style="height:80rem;align-content: center;align-items: center;width: 100%;position: relative;display: flex;">
                                    <p style="width:25%;padding:0 18rem;">
                                        <span class="nowrap" style="display: inline-block;width: 100%;">管理人员</span>
                                    </p>
                                    <p style="width:50%;padding:0 18rem;">
                                        <img src="../../assets/image/visual/li0.png" style="width:86rem;height:42rem;position: absolute;left: calc( 50% - 43rem );top: -12rem;" />
                                        <span class="nowrap" style="display: inline-block;width: 100%;">{{attend.manageCount}}</span>
                                    </p>
                                    <p style="width:25%;padding:0 18rem;">
                                        <img src="../../assets/image/visual/li0.png" style="width:86rem;height:42rem;position: absolute;left: calc( 50% - 43rem );top: -12rem;" />
                                        <span class="nowrap" style="display: inline-block;width: 100%;">{{attend.manageRate}}%</span>
                                    </p>
                                </li>
                                <li style="height:80rem;align-content: center;align-items: center;width: 100%;position: relative;display: flex;">
                                    <p style="width:25%;padding:0 18rem;">
                                        <span class="nowrap" style="display: inline-block;width: 100%;">建筑工人</span>
                                    </p>
                                    <p style="width:50%;padding:0 18rem;">
                                        <img src="../../assets/image/visual/li1.png" style="width:86rem;height:42rem;position: absolute;left: calc( 50% - 43rem );top: -12rem;" />
                                        <span class="nowrap" style="display: inline-block;width: 100%;">{{attend.workersCount}}</span>
                                    </p>
                                    <p style="width:25%;padding:0 18rem;">
                                        <img src="../../assets/image/visual/li1.png" style="width:86rem;height:42rem;position: absolute;left: calc( 50% - 43rem );top: -12rem;" />
                                        <span class="nowrap" style="display: inline-block;width: 100%;">{{attend.workersRate}}%</span>
                                    </p>
                                </li>
                                <li style="height:80rem;align-content: center;align-items: center;width: 100%;position: relative;display: flex;">
                                    <p style="width:25%;padding:0 18rem;">
                                        <span class="nowrap" style="display: inline-block;width: 100%;">特种人员</span>
                                    </p>
                                    <p style="width:50%;padding:0 18rem;">
                                        <img src="../../assets/image/visual/li0.png" style="width:86rem;height:42rem;position: absolute;left: calc( 50% - 43rem );top: -12rem;" />
                                        <span class="nowrap" style="display: inline-block;width: 100%;">{{attend.specialCount}}</span>
                                    </p>
                                    <p style="width:25%;padding:0 18rem;">
                                        <img src="../../assets/image/visual/li0.png" style="width:86rem;height:42rem;position: absolute;left: calc( 50% - 43rem );top: -12rem;" />
                                        <span class="nowrap" style="display: inline-block;width: 100%;">{{attend.specialRate}}%</span>
                                    </p>
                                </li>
                            </ul>
                        </div>
                    </div>
                    
                    <div v-if="element.index=='2' && element.show" class="item-div" :style="{'margin-top':element.margin+'rem','margin-bottom':element.margin+'rem'}">
                        <div style="width:100%;height:30rem;position: relative;display:flex;justify-content: space-between;padding:0 36rem;">
                            <p>
                                <span class="crile"></span>
                                <span style="color:#34ECFF;font-size:22rem;">在场人员</span>
                                <span style="color:#34ECFF;font-size:22rem;margin-left:50rem;">{{persent.allTeamsCount}}</span>
                            </p>
                        </div>
                        <div style="width:100%;height:60rem;position: relative;display:flex;align-items: center;margin-top:30rem;">
                            <p style="width:25%;position: relative;text-align: center;padding:0 18rem;"></p>
                            <p style="width:50%;position: relative;text-align: center;padding:0 18rem;">出勤人数</p>
                            <p style="width:25%;position: relative;text-align: center;padding:0 18rem;">出勤率</p>
                        </div>
                        <div style="width:100%;height:300rem;position: relative;overflow: hidden;">
                            <ul>
                                <li style="height:80rem;align-content: center;align-items: center;width: 100%;position: relative;display: flex;">
                                    <p style="width:25%;padding:0 18rem;">
                                        <span class="nowrap" style="display: inline-block;width: 100%;">管理人员</span>
                                    </p>
                                    <p style="width:50%;padding:0 18rem;">
                                        <img src="../../assets/image/visual/li0.png" style="width:86rem;height:42rem;position: absolute;left: calc( 50% - 43rem );top: -12rem;" />
                                        <span class="nowrap" style="display: inline-block;width: 100%;">{{persent.manageCount}}</span>
                                    </p>
                                    <p style="width:25%;padding:0 18rem;">
                                        <img src="../../assets/image/visual/li0.png" style="width:86rem;height:42rem;position: absolute;left: calc( 50% - 43rem );top: -12rem;" />
                                        <span class="nowrap" style="display: inline-block;width: 100%;">{{persent.manageRate}}%</span>
                                    </p>
                                </li>
                                <li style="height:80rem;align-content: center;align-items: center;width: 100%;position: relative;display: flex;">
                                    <p style="width:25%;padding:0 18rem;">
                                        <span class="nowrap" style="display: inline-block;width: 100%;">建筑工人</span>
                                    </p>
                                    <p style="width:50%;padding:0 18rem;">
                                        <img src="../../assets/image/visual/li1.png" style="width:86rem;height:42rem;position: absolute;left: calc( 50% - 43rem );top: -12rem;" />
                                        <span class="nowrap" style="display: inline-block;width: 100%;">{{persent.workersCount}}</span>
                                    </p>
                                    <p style="width:25%;padding:0 18rem;">
                                        <img src="../../assets/image/visual/li1.png" style="width:86rem;height:42rem;position: absolute;left: calc( 50% - 43rem );top: -12rem;" />
                                        <span class="nowrap" style="display: inline-block;width: 100%;">{{persent.workersRate}}%</span>
                                    </p>
                                </li>
                                <li style="height:80rem;align-content: center;align-items: center;width: 100%;position: relative;display: flex;">
                                    <p style="width:25%;padding:0 18rem;">
                                        <span class="nowrap" style="display: inline-block;width: 100%;">特种人员</span>
                                    </p>
                                    <p style="width:50%;padding:0 18rem;">
                                        <img src="../../assets/image/visual/li0.png" style="width:86rem;height:42rem;position: absolute;left: calc( 50% - 43rem );top: -12rem;" />
                                        <span class="nowrap" style="display: inline-block;width: 100%;">{{persent.specialCount}}</span>
                                    </p>
                                    <p style="width:25%;padding:0 18rem;">
                                        <img src="../../assets/image/visual/li0.png" style="width:86rem;height:42rem;position: absolute;left: calc( 50% - 43rem );top: -12rem;" />
                                        <span class="nowrap" style="display: inline-block;width: 100%;">{{persent.specialRate}}%</span>
                                    </p>
                                </li>
                            </ul>
                        </div>
                    </div>

                    <div v-if="element.index=='3' && element.show" class="item-div" :style="{'margin-top':element.margin+'rem','margin-bottom':element.margin+'rem'}">
                        <div style="width:100%;height:30rem;position: relative;display:flex;justify-content: space-between;padding:0 36rem;">
                            <p>
                                <span class="crile"></span>
                                <span style="color:#34ECFF;font-size:22rem;">人员动态</span>
                            </p>
                        </div>
                        <div style="width:100%;height:100rem;position: relative;display:flex;padding:0 36rem;align-items: center;">
                            <p style="font-size:18rem;color:#fff;padding-left:30rem;">累计采集{{syn.zs}}人</p>
                            <p style="font-size:18rem;color:#fff;padding-left:50rem;">实名占比{{syn.smRate}}</p>
                        </div>
                        <div style="width:100%;height:360rem;position: relative;display:flex;">
                            <div style="width: 50%;height: 100%;">
                                <div id="myChart1" style="width:100%; height:100%"></div>
                            </div>
                            <div class="first-gress-con" style="width: 50%;height: 100%;position: relative;display: flex;flex-wrap: wrap;">
                                <p style="color:#fff;display:flex;align-items: flex-end;padding-left:20rem;">在职人员（{{syn.zz}}/{{syn.zs}}）</p>
                                <p style="width: 100%;position: relative;height: 20rem;"><el-progress :percentage="parseFloat(syn.zzLv)" :stroke-width="20"></el-progress></p>
                                <p style="color:#fff;display:flex;align-items: flex-end;padding-left:20rem;">未在职人员（{{syn.wzz}}/{{syn.zs}}）</p>
                                <p style="width: 100%;position: relative;height: 20rem;"><el-progress :percentage="parseFloat(syn.wzzLv)" :stroke-width="20" color="#FF9F20"></el-progress></p>
                                <p style="color:#fff;display:flex;align-items: flex-end;padding-left:20rem;">未实名人员（{{syn.lz}}/{{syn.zs}}）</p>
                                <p style="width: 100%;position: relative;height: 20rem;"><el-progress :percentage="parseFloat(syn.lzLv)" :stroke-width="20" color="#E66E3A"></el-progress></p>
                            </div>
                        </div>
                    </div>

                    <div v-if="element.index=='4' && element.show" class="item-div" :style="{'margin-top':element.margin+'rem','margin-bottom':element.margin+'rem'}">
                        <div style="width:100%;height:60rem;position: relative;display:flex;justify-content: space-between;padding:0 36rem;">
                            <p>
                                <span class="crile"></span>
                                <span style="color:#34ECFF;font-size:22rem;">班组出勤</span>
                            </p>
                        </div>
                        <div style="width:100%;height:60rem;position: relative;display:flex;align-items: center;">
                            <p style="width:25%;position: relative;text-align: center;padding:0 18rem;">班组</p>
                            <p style="width:25%;position: relative;text-align: center;padding:0 18rem;">人数</p>
                            <p style="width:25%;position: relative;text-align: center;padding:0;">出勤人数</p>
                            <p style="width:25%;position: relative;text-align: center;padding:0 18rem;">出勤率</p>
                        </div>
                        <div style="width:100%;height:420rem;position: relative;overflow: hidden;">
                            <ul :class="{anim:animate==true}">
                                <li v-for="(item,index) in attendTeam" :key="index" style="height:80rem;align-content: center;align-items: center;width: 100%;position: relative;display: flex;">
                                    <p style="width:25%;padding:0 18rem;">
                                        <span class="nowrap" style="display: inline-block;width: 100%;" :title="item.teamsName">{{item.teamsName}}</span>
                                    </p>
                                    <p style="width:25%;padding:0 18rem;">
                                        <img src="../../assets/image/visual/li0.png" style="width:86rem;height:42rem;position: absolute;left: calc( 50% - 43rem );top: -12rem;" />
                                        <span class="nowrap" style="display: inline-block;width: 100%;">{{item.zzCount}}</span>
                                    </p>
                                    <p style="width:25%;padding:0;">
                                        <img src="../../assets/image/visual/li0.png" style="width:86rem;height:42rem;position: absolute;left: calc( 50% - 43rem );top: -12rem;" />
                                        <span class="nowrap" style="display: inline-block;width: 100%;">{{item.cqCount}}</span>
                                    </p>
                                    <p style="width:25%;padding:0 18rem;">
                                        <img src="../../assets/image/visual/li0.png" style="width:86rem;height:42rem;position: absolute;left: calc( 50% - 43rem );top: -12rem;" />
                                        <span class="nowrap" style="display: inline-block;width: 100%;">{{item.lv}}%</span>
                                    </p>
                                </li>
                            </ul>
                        </div>
                    </div>

                    <div v-if="element.index=='5' && element.show" class="item-div" :style="{'margin-top':element.margin+'rem','margin-bottom':element.margin+'rem'}">
                        <div style="width:100%;height:30rem;position: relative;display:flex;justify-content: space-between;padding:0 36rem;">
                            <p>
                                <span class="crile"></span>
                                <span style="color:#34ECFF;font-size:22rem;">合同信息</span>
                            </p>
                            <p style="color:#fff;font-size:20rem;">应签合同{{agreeNum.yqht}}人</p>
                            <p style="color:#fff;font-size:20rem;">已网签{{agreeNum.ywq}}人</p>
                            <p style="color:#fff;font-size:20rem;">未网签{{agreeNum.wxq}}人</p>
                        </div>
                        <div style="width:100%;height:60rem;position: relative;display:flex;align-items: center;margin-top:30rem;">
                            <p style="width:25%;position: relative;text-align: center;padding:0 18rem;">姓名</p>
                            <p style="width:50%;position: relative;text-align: center;padding:0 18rem;">入职时间</p>
                            <p style="width:25%;position: relative;text-align: center;padding:0 18rem;">合同状态</p>
                        </div>
                        <div style="width:100%;height:420rem;position: relative;overflow: hidden;">
                            <ul :class="{anim1:animate1==true}">
                                <li v-for="(item,index) in tableAgree" :key="index" style="height:60rem;align-content: center;align-items: center;width: 100%;position: relative;display: flex;">
                                    <p style="width:25%;padding:0 18rem;">
                                        <span class="nowrap" style="display: inline-block;width: 100%;">{{item.name}}</span>
                                    </p>
                                    <p style="width:50%;padding:0 18rem;">
                                        <span class="nowrap" style="display: inline-block;width: 100%;">{{item.create_date}}</span>
                                    </p>
                                    <p style="width:25%;padding:0 18rem;">
                                        <span v-if="item.status=='已网签'" style="display: inline-block;width: 100%;color:#FFFFFF;">已网签</span>
                                        <span v-else style="display: inline-block;width: 100%;color:#E66E3A;">未网签</span>
                                    </p>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <!-- list1 -->
                    <div v-if="element.index=='6' && element.show" class="item-div" :style="{'margin-top':element.margin+'rem','margin-bottom':element.margin+'rem'}" :class="(element.border?'borderCss':'')">
                        <p class="item-title"> 质量安全 </p>
                        <div style="width:100%;height:400rem;position: relative;display:flex;">
                            <div style="width:50%;height:100%;position: relative;display:flex;flex-wrap:wrap;">
                                <p style="width:100%;font-size:20rem;position: relative;height:100rem;display: flex;align-items: flex-end;align-content: center;justify-content: center;">项目检查  {{qsChar.projectAllQsCount}}次</p>
                                <div style="width:100%;height:300rem;position: relative;display:flex;justify-content: center;">
                                    <div id="safe1" style="width:240rem; height:240rem:"></div>
                                    <div style="width:calc( 100% - 300rem );height:260rem;display:flex;flex-wrap:wrap;align-content: center;">
                                        <p style="width:100%;margin-top:30rem;text-align: left;">
                                            <span style="width: 18rem;height: 18rem;background: #1299F3;border-radius: 50%;display: inline-block;"></span>
                                            <span style="margin-left:20rem;">符合</span>
                                        </p>
                                        <p style="width:100%;margin-top:20rem;text-align: left;">
                                            <span style="width: 18rem;height: 18rem;background: #FF9B52;border-radius: 50%;display: inline-block;"></span>
                                            <span style="margin-left:20rem;">待处理</span>
                                        </p>
                                        <p style="width:100%;margin-top:20rem;text-align: left;">
                                            <span style="width: 18rem;height: 18rem;background: #4EE6B7;border-radius: 50%;display: inline-block;"></span>
                                            <span style="margin-left:20rem;">已处理</span>
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div style="width:50%;height:100%;position: relative;display:flex;flex-wrap:wrap;">
                                <p style="width:100%;font-size:20rem;position: relative;height:100rem;display: flex;align-items: flex-end;align-content: center;justify-content: center;">公司检查  {{qsChar.entAllQsCount}}次</p>
                                <div style="width:100%;height:300rem;position: relative;display:flex;justify-content: center;">
                                    <div id="safe2" style="width:240rem; height:240rem:"></div>
                                    <div style="width:calc( 100% - 300rem );height:260rem;display:flex;flex-wrap:wrap;align-content: center;">
                                        <p style="width:100%;margin-top:30rem;text-align: left;">
                                            <span style="width: 18rem;height: 18rem;background: #6E38A8;border-radius: 50%;display: inline-block;"></span>
                                            <span style="margin-left:20rem;">符合</span>
                                        </p>
                                        <p style="width:100%;margin-top:20rem;text-align: left;">
                                            <span style="width: 18rem;height: 18rem;background: #70BFED;border-radius: 50%;display: inline-block;"></span>
                                            <span style="margin-left:20rem;">待处理</span>
                                        </p>
                                        <p style="width:100%;margin-top:20rem;text-align: left;">
                                            <span style="width: 18rem;height: 18rem;background: #F47E86;border-radius: 50%;display: inline-block;"></span>
                                            <span style="margin-left:20rem;">已处理</span>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div v-if="element.index=='7' && element.show" class="item-div" :style="{'margin-top':element.margin+'rem','margin-bottom':element.margin+'rem'}" :class="(element.border?'borderCss':'')">
                        <p class="item-title"> 疫情管控 </p>
                        <div style="width:100%;height:400rem;position: relative;margin-top:20rem;padding:0 20rem;">
                            <div id="disease1" style="width:100%; height:100%;"></div>
                        </div>
                        <div style="width:100%;height:400rem;position: relative;margin-top:20rem;padding:0 20rem;">
                            <div id="disease2" style="width:100%; height:100%;"></div>
                        </div>
                    </div>

                    <div v-if="element.index=='8' && element.show" class="item-div" :style="{'margin-top':element.margin+'rem','margin-bottom':element.margin+'rem'}" :class="(element.border?'borderCss':'')">
                        <p class="item-title"> 车辆统计 </p>
                        <div style="width:100%;height:300rem;position: relative;margin-top:20rem;padding:0 20rem;">
                            <div id="car1" style="width:100%; height:100%;"></div>
                        </div>
                    </div>
                    <!-- list4 -->
                    <div v-if="element.index=='18' && element.show" class="item-div" :style="{'margin-top':element.margin+'rem','margin-bottom':element.margin+'rem'}" :class="(element.border?'borderCss':'')">
                        <p class="item-title"> 高支模监测 </p>
                        <div style="width:100%;height:760rem;position: relative;padding:20rem 40rem;">
                            <div style="width:100%;height:120rem;position: relative;display:flex;align-items: center;">
                                <p style="width:200rem;">位移（米）</p>
                                <div style="width:calc( 100% - 200rem );position: relative;height:32rem;background: linear-gradient(270deg, #91E3F7 0%, #6CB8FB 51%, #468CFF 99%, #468CFF 100%);">
                                    <div :style="{'left':'calc( '+highMod.wyRate1+' - 50rem )'}" style="width:100rem;height:80rem;position: absolute;top:-33rem;display:flex;flex-wrap:wrap;justify-content: center;justify-items: center;">
                                        <p style="width:100%;height:20rem;position: relative;text-align: center;">{{highMod.wyVal1}}</p>
                                        <p style="width:1rem;height:55rem;border-left: 1rem dashed #fff;"></p>
                                    </div>
                                </div>
                            </div>
                            <div style="width:100%;height:120rem;position: relative;display:flex;align-items: center;">
                                <p style="width:200rem;"></p>
                                <div style="width:calc( 100% - 200rem );position: relative;height:32rem;background: linear-gradient(270deg, #91E3F7 0%, #6CB8FB 51%, #468CFF 99%, #468CFF 100%);">
                                    <div :style="{'left':'calc( '+highMod.wyRate2+' - 50rem )'}" style="width:100rem;height:80rem;position: absolute;top:-33rem;display:flex;flex-wrap:wrap;justify-content: center;justify-items: center;">
                                        <p style="width:100%;height:20rem;position: relative;text-align: center;">{{highMod.wyVal2}}</p>
                                        <p style="width:1rem;height:55rem;border-left: 1rem dashed #fff;"></p>
                                    </div>
                                </div>
                            </div>
                            <div style="width:100%;height:120rem;position: relative;display:flex;align-items: center;">
                                <p style="width:200rem;">倾角（°）</p>
                                <div style="width:calc( 100% - 200rem );position: relative;height:32rem;background: linear-gradient(270deg, #FFA0E5 0%, #FF86B8 52%, #FF6C8B 100%);">
                                    <div :style="{'left':'calc( '+highMod.qjRate1+' - 50rem )'}" style="width:100rem;height:80rem;position: absolute;top:-33rem;display:flex;flex-wrap:wrap;justify-content: center;justify-items: center;">
                                        <p style="width:100%;height:20rem;position: relative;text-align: center;">{{highMod.qjVal1}}</p>
                                        <p style="width:1rem;height:55rem;border-left: 1rem dashed #fff;"></p>
                                    </div>
                                </div>
                            </div>
                            <div style="width:100%;height:120rem;position: relative;display:flex;align-items: center;">
                                <p style="width:200rem;"></p>
                                <div style="width:calc( 100% - 200rem );position: relative;height:32rem;background: #7D6CFF;">
                                    <div :style="{'left':'calc( '+highMod.qjRate2+' - 50rem )'}" style="width:100rem;height:80rem;position: absolute;top:-33rem;display:flex;flex-wrap:wrap;justify-content: center;justify-items: center;">
                                        <p style="width:100%;height:20rem;position: relative;text-align: center;">{{highMod.qjVal2}}</p>
                                        <p style="width:1rem;height:55rem;border-left: 1rem dashed #fff;"></p>
                                    </div>
                                </div>
                            </div>
                            <div style="width:100%;height:120rem;position: relative;display:flex;align-items: center;">
                                <p style="width:200rem;">压力（N）</p>
                                <div style="width:calc( 100% - 200rem );position: relative;height:32rem;background: linear-gradient(270deg, #ABA0FF 0%, #9486FF 51%, #7D6CFF 99%, #7D6CFF 100%);">
                                    <div :style="{left:'calc( '+highMod.ylRate1+' - 50rem )'}" style="width:100rem;height:80rem;position: absolute;top:-33rem;display:flex;flex-wrap:wrap;justify-content: center;justify-items: center;">
                                        <p style="width:100%;height:20rem;position: relative;text-align: center;">{{highMod.ylVal1}}</p>
                                        <p style="width:1rem;height:55rem;border-left: 1rem dashed #fff;"></p>
                                    </div>
                                </div>
                            </div>
                            <div style="width:100%;height:120rem;position: relative;display:flex;align-items: center;">
                                <p style="width:200rem;"></p>
                                <div style="width:calc( 100% - 200rem );position: relative;height:32rem;background: linear-gradient(270deg, #ABA0FF 0%, #9486FF 51%, #7D6CFF 99%, #7D6CFF 100%);">
                                    <div :style="{'left':'calc( '+highMod.ylRate2+' - 50rem )'}" style="width:100rem;height:80rem;position: absolute;top:-33rem;display:flex;flex-wrap:wrap;justify-content: center;justify-items: center;">
                                        <p style="width:100%;height:20rem;position: relative;text-align: center;">{{highMod.ylVal2}}</p>
                                        <p style="width:1rem;height:55rem;border-left: 1rem dashed #fff;"></p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div v-if="element.index=='19' && element.show" class="item-div" :style="{'margin-top':element.margin+'rem','margin-bottom':element.margin+'rem'}" :class="(element.border?'borderCss':'')">
                        <p class="item-title"> 混凝土测温 </p>
                        <!-- <div style="width:100%;height:50rem;padding-left:30rem;display:flex;align-items: center;" class="hunlin">
                            <p style="width:25%;position: relative;text-align: center;padding:0 18rem;">设备名称</p>
                            <p style="width:15%;position: relative;text-align: center;padding:0 18rem;">监测类型</p>
                            <p style="width:25%;position: relative;text-align: center;padding:0 18rem;">温度</p>
                            <p style="width:35%;position: relative;text-align: center;padding:0 18rem;">时间</p>
                            
                        </div> -->
                        <div style="width:100%;height:240rem;padding:10rem 20rem;overflow: hidden;">
                            <div id="hunlin1" style="width:100%; height:200rem;"></div>
                            <!-- <ul :class="{anim1:animate4==true}">
                                <li v-for="(item,index) in mixedList" :key="index" style="height:60rem;align-content: center;align-items: center;width: 100%;position: relative;display: flex;">
                                    <p style="width:25%;padding:0 18rem;">
                                        <span class="nowrap" style="display: inline-block;width: 100%;">{{item.name}}</span>
                                    </p>
                                    <p style="width:15%;padding:0 18rem;">
                                        <span v-if="item.tsSersorType=='1'" class="nowrap" style="display: inline-block;width: 100%;">上孔位</span>
                                        <span v-else-if="item.tsSersorType=='2'" class="nowrap" style="display: inline-block;width: 100%;">中孔位</span>
                                        <span v-else-if="item.tsSersorType=='3'" class="nowrap" style="display: inline-block;width: 100%;">下孔位</span>
                                        <span v-else-if="item.tsSersorType=='4'" class="nowrap" style="display: inline-block;width: 100%;">警报</span>
                                        <span v-else-if="item.tsSersorType=='5'" class="nowrap" style="display: inline-block;width: 100%;">外置</span>
                                    </p>
                                    <p style="width:25%;padding:0 18rem;">
                                        <span v-if="item.isWarn" style="display: inline-block;width: 100%;color:#FFFFFF;">{{item.nowValue}}</span>
                                        <span v-else style="display: inline-block;width: 100%;color:#E66E3A;">{{item.nowValue}}</span>
                                    </p>
                                    <p style="width:35%;padding:0 18rem;">
                                        <span class="nowrap" style="display: inline-block;width: 100%;">{{item.updateDate}}</span>
                                    </p>
                                </li>
                            </ul> -->
                        </div>
                        <div style="width:100%;height:240rem;padding:10rem 20rem;">
                            <div id="hunlin2" style="width:100%; height:200rem;"></div>
                        </div>
                        <div style="width:100%;height:240rem;padding:10rem 20rem;">
                            <div id="hunlin3" style="width:100%; height:200rem;"></div>
                        </div>
                    </div>

                    <div v-if="element.index=='20' && element.show" class="item-div" :style="{'margin-top':element.margin+'rem','margin-bottom':element.margin+'rem'}" :class="(element.border?'borderCss':'')">
                        <p class="item-title"> BIM </p>
                        <div style="width:100%;height:370rem;position: relative;padding:10rem 20rem;">
                            <iframe width="100%" src='https://720yun.com/t/e8vkne87pdw' frameborder="no" style="border: 0;height: 100%;"></iframe>
                        </div>
                    </div>
                    <div v-if="element.index=='22' && element.show" class="item-div" :style="{'margin-top':element.margin+'rem','margin-bottom':element.margin+'rem'}" :class="(element.border?'borderCss':'')">
                        <p class="item-title"> 螺帽监测 </p>
                        <div style="width:180rem;height:100%;position: absolute;top:0;left:0;background: rgba(19, 145, 218, 0.2);border: 1rem solid #1391DA;overflow: auto;">
                            <div class="main-left-item" v-for="(item,index) in nutHostList" :key="index" :class="{'curUnload':nutId==item.id}" @click="changeTower(item)">
                                <p class="name nowrap" style="width:100%;height:35rem;">{{item.name}}</p>
                                <p class="state color8" style="width:100%;text-align: right;" v-if="item.online=='离线'">离线</p>
                                <p class="state color10" style="width:100%;text-align: right;" v-else-if="item.online=='在线'" >在线</p>
                            </div>
                        </div>
                        <div style="width:calc( 100% - 180rem );height:460rem;position: relative;margin-left:180rem;">
                            <p style="width:100%;height:60rem;position: relative;display:flex;">
                                <span>实时数据</span>
                                <span style="font-size:14rem;transform: scale(0.8);">{{nutInfo.updateDate}}</span>
                            </p>
                            <div style="width:100%;height:175rem;position: relative;display:flex;">
                                <div style="width:64%;height:100%;position: relative;display:flex;flex-wrap:wrap;">
                                    <p style="width:100%;height:30rem;font-size:14rem;transform: scale(0.8);text-align: left;">设备号:{{nutInfo.deviceId}}</p>
                                    <p style="width:100%;height:30rem;font-size:14rem;transform: scale(0.8);text-align: left;">名称:{{nutInfo.name}}</p>
                                    <p style="width:100%;height:30rem;font-size:14rem;transform: scale(0.8);text-align: left;">螺帽:{{nutInfo.sums}}个 预警<span style="color:#BE1313;">{{nutInfo.warningSum}}</span></p>
                                </div>
                                <div style="width:33%;height:100%;position: relative;">
                                    <img src="../../assets/image/round1.png" style="max-width:100%;" />
                                    <div style="position: absolute;top: 0;left: -5%;width: 110%;padding-top: 30rem;height: 100%;display: flex;flex-wrap: wrap;align-content: center;">
                                        <p style="width:100%;text-align: center;transform: scale(0.7);">监测时长</p>
                                        <p style="width: 100%;text-align: center;transform: scale(0.7);top: -16rem;">{{nutInfo.dayLen}}天</p>
                                    </div>
                                </div>
                            </div>
                            <div style="width:100%;height:240rem;">
                                <div class="unload-date" style="width:100%;height:40rem;position: relative;text-align: left;padding-left:10rem;">
                                    <el-date-picker
                                        v-model="nutTime"
                                        style="transform: scale(0.8);left: -50rem;"
                                        type="month"
                                        value-format="yyyy-MM"
                                        placeholder="选择日期">
                                    </el-date-picker>
                                </div>
                                <div style="width:100%;height:80rem;position: relative;display:flex;align-items: center;margin-top:0rem;">
                                    <p style="width:40%;position: relative;text-align: center;padding:0;">监测时间</p>
                                    <p style="width:30%;position: relative;text-align: center;padding:0;">监测点</p>
                                    <p style="width:30%;position: relative;text-align: center;padding:0;">设备号</p>
                                </div>
                                <div style="width:100%;height:180rem;position: relative;overflow: hidden;">
                                    <ul :class="{anim6:animate6==true}">
                                        <li v-for="(item,index) in nutLog" :key="index" style="height:60rem;align-content: center;align-items: center;width: 100%;position: relative;display: flex;">
                                            <p style="width:40%;padding:0;">
                                                <span class="nowrap" style="display: inline-block;width: 100%;">{{item.connectDate}}</span>
                                            </p>
                                            <p style="width:30%;padding:0;">
                                                <span class="nowrap" style="display: inline-block;width: 100%;">{{item.name}}</span>
                                            </p>
                                            <p style="width:30%;padding:0;">
                                                <span class="nowrap" style="display: inline-block;width: 100%;">{{item.nutHostId}}</span>
                                            </p>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </li>
            </draggable>
            <i class="el-icon-s-tools" style="color:#fff;position: absolute;right: -50rem;top: -50rem;font-size: 50rem;cursor: pointer;" @click="showDialogFun"></i>
        </div>

        <el-dialog
            title="提示"
            :visible.sync="ctrlVis"
            width="3000rem"
            :lock-scroll="false"
            custom-class="bigVitalDia"
            style="height:100%;"
        >
            <div style="width:100%;height:auto;position: relative;">
                <div style="width:100%;height:80rem;position: relative;display:flex;">
                    <p style="width:15%;text-align: center;">适配（像素）</p>
                    <p style="width:20%;text-align: center;">名称</p>
                    <p style="width:15%;text-align: center;">间距（像素）</p>
                    <p style="width:25%;text-align: center;">边框</p>
                    <p style="width:25%;text-align: center;">状态</p>
                </div>
                <ul>
                    <li v-for="(item,index) in modularList" :key="index" style="width:100%;height:100rem;display:flex;">
                        <p style="width:15%;text-align: center;">{{item.width}}</p>
                        <p style="width:20%;text-align: center;">{{item.name}}</p>
                        <p style="width:15%;text-align: center;">
                            <el-input v-model="item.margin" type="number" placeholder=""></el-input>
                        </p>
                        <p style="width:25%;text-align: center;">
                            <el-radio-group v-model="item.border">
                                <el-radio :label="false">隐藏</el-radio>
                                <el-radio :label="true">显示</el-radio>
                            </el-radio-group>
                        </p>
                        <p style="width:25%;text-align: center;">
                            <el-radio-group v-model="item.show">
                                <el-radio :label="true">开启</el-radio>
                                <el-radio :label="false">关闭</el-radio>
                            </el-radio-group>
                        </p>
                    </li>
                </ul>
                <div style="margin-top:30rem;">
                    <el-button @click="ctrlVis = false" style="margin-right:20rem;">取 消</el-button>
                    <el-button @click="refreshCtl" style="margin-left:20rem;">确 定</el-button>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import draggable from "vuedraggable"
import HighCharts from 'highcharts'
import util from '../../untils/util'
import myHttp from '../../untils/port'
import base from '../../untils/base'
export default {
    components: {
        draggable
    },
    data(){
        return{
            timeout:300000, //普通
            timeout1:600000,//班组出勤+合同
            drag: false,
            proNameSize:'30',
            list0:[
                {name:'今日出勤',index:"1",order:0,margin:20,show:true,width:860,border:false},
                {name:'在场人员',index:"2",order:1,margin:20,show:true,width:860,border:false},
                {name:'人员动态',index:"3",order:2,margin:20,show:true,width:860,border:false},
                {name:'班组出勤',index:"4",order:3,margin:20,show:true,width:860,border:false},
                {name:'合同信息',index:"5",order:4,margin:50,show:true,width:860,border:false},
            ],
            list1:[
                {name:'质量安全',index:"6",order:0,margin:0,show:true,width:860,border:true},
                {name:'疫情管控',index:"7",order:1,margin:20,show:true,width:860,border:true},
                {name:'车辆统计',index:"8",order:2,margin:20,show:true,width:860,border:true},
            ],
            list2:[
                {name:'能耗统计',index:"9",order:0,margin:0,show:true,width:1400,border:true},
                {name:'塔吊监测',index:"10",order:1,margin:0,show:true,width:1400,border:true},
                {name:'扬尘监测',index:"11",order:2,margin:0,show:true,width:1400,border:true},
                {name:'进出口实时人脸考勤',index:"12",order:2,margin:0,show:true,width:1400,border:true},
                {name:'卸料平台',index:"21",order:2,margin:20,show:false,width:860,border:true},
            ],
            list3:[
                {name:'设备运行监测',index:"13",order:0,margin:0,show:true,width:1400,border:true},
                {name:'监控预警',index:"14",order:1,margin:0,show:true,width:1400,border:true},
                {name:'安康码管控系统',index:"15",order:2,margin:0,show:true,width:1400,border:true},
                {name:'升降机监测',index:"16",order:3,margin:0,show:true,width:1400,border:true},
                {name:'BIM交互管理',index:"17",order:4,margin:0,show:true,width:1400,border:true},
            ],
            list4:[
                {name:'高支模监测',index:"18",order:0,margin:0,show:true,width:860,border:true},
                {name:'混凝土测温',index:"19",order:1,margin:20,show:true,width:860,border:true},
                {name:'BIM',index:"20",order:2,margin:20,show:true,width:860,border:true},
                {name:'螺帽监测',index:"22",order:2,margin:20,show:true,width:860,border:true},
            ],
            allList:[  //页面操作弹出框
                {name:'劳务统计',index:"1",margin:20,show:true,width:860,border:true},
                {name:'质量安全',index:"6",margin:0,show:true,width:860,border:true},
                {name:'疫情管控',index:"7",margin:20,show:true,width:860,border:true},
                {name:'车辆统计',index:"8",margin:20,show:true,width:860,border:true},
                {name:'能耗统计',index:"9",margin:0,show:true,width:1400,border:true},
                {name:'塔吊监测',index:"10",margin:0,show:true,width:1400,border:true},
                {name:'扬尘监测',index:"11",margin:0,show:true,width:1400,border:true},
                {name:'进出口实时人脸考勤',index:"12",margin:0,show:true,width:1400,border:true},
                {name:'设备运行监测',index:"13",margin:0,show:true,width:1400,border:true},
                {name:'监控预警',index:"14",margin:0,show:true,width:1400,border:true},
                {name:'安康码管控系统',index:"15",margin:0,show:true,width:1400,border:true},
                {name:'升降机监测',index:"16",margin:0,show:true,width:1400,border:true},
                {name:'BIM交互管理',index:"17",margin:0,show:true,width:1400,border:true},
                {name:'高支模监测',index:"18",margin:0,show:true,width:860,border:true},
                {name:'混凝土测温',index:"19",margin:20,show:true,width:860,border:true},
                {name:'BIM',index:"20",margin:20,show:true,width:860,border:true},
                {name:'卸料平台',index:"21",order:2,margin:20,show:true,width:1400,border:true},
                {name:'螺帽监测',index:"22",order:2,margin:20,show:true,width:860,border:true},
            ],
            equipStatusList:[  //设备运行监测
                // {total:'0',online:'0',offline:'0'},
                {total:'0',online:'0',offline:'0'},
                {total:'0',online:'0',offline:'0'},
                {total:'0',online:'0',offline:'0'},
                {total:'0',online:'0',offline:'0'},
                // {total:'0',online:'0',offline:'0'},
                // {total:'0',online:'0',offline:'0'},
                {total:'0',online:'0',offline:'0'},
                {total:'0',online:'0',offline:'0'},
            ],
            codeNum:{ //安康码数据
                registered:0,
                green:0,
                yellow:0,
                red:0
            },
            codeList:[
                {id:'0',personName:'测试',idcardPhoto:require('../../assets/image/project.png'),dates:'2020-11-09',codeImg:require('../../assets/image/anKang-gress.png')}
            ],
            years:[
                {name:'2019',value:'2019'},
                {name:'2020',value:'2020'},
                {name:'2021',value:'2021'},
                {name:'2022',value:'2022'},
                {name:'2023',value:'2023'},
                {name:'2023',value:'2023'},
            ],
            eleYear:new Date().getFullYear(), //能耗统计-电-年
            waterYear:new Date().getFullYear(), //能耗统计-水-年
            towerlist:[],//塔吊列表
            ysToken:'',//获取监控token
            towerVideo:'',//塔吊监控地址
            towerPart:{}, //当前塔吊信息
            // allPart:{},//当前塔吊信息
            towerId:'',//当前塔吊id
            cameraData:{},//塔吊监控
            //地图
            map:undefined,
            center: {
                lng: 117.285033,
                lat: 31.86515
            },
            BMap:undefined,
            curIndex:undefined,//当前地图展示的gps
            points:[],//坐标集
            //监控
            monitorList:[], //监控列表
            currentPage: 1,
            pageSize: 6,
            totalItems: 0,
            groupId:'',//项目id
            attend:{   //今日出勤
                manageCount:0, //管理人员
                manageRate:0,
                workersCount:0,//工人
                workersRate:0,
                specialCount:0,//特种人员
                specialRate:0,
                allTeamsCount:0,
            },
            persent:{ //在场人员
                manageCount:0, //管理人员
                manageRate:0,
                workersCount:0,//工人
                workersRate:0,
                specialCount:0,//特种人员
                specialRate:0,
                allTeamsCount:0,
            },
            syn:{ //人员动态
                zz:0,   //在职
                lz:0,   //离职
                wzz:0,  //未入职
                wsm:0,  //未实名
                sm:0,   //采集人数
                zs:0,   //总人数
                smRate:0,//实名率
                zzLv:0,  //在职比例
                wzzLv:0, //未在职比例
                lzLv:0, //未实名比例
            },
            attendTeam:[],//班组出勤
            agreeNum:{wxq:0,yqht:0,ywq:0,wlv:0,ylv:0},//合同
            tableAgree:[],//合同列表
            qsChar:{  //
                entAllQsCount: 0,
                entNoProblemCount: 0,
                entPendingCount: 0,
                entProblemCount: 0,
                entProcessedCount: 0,
                projectAllQsCount: 0,
                projectNoProblemCount: 0,
                projectPendingCount: 0,
                projectProblemCount: 0,
                projectProcessedCount: 0,
            },
            waterPie:[0,0,0,0],//能耗统计-水-季度数据
            ankangList:[ //安康码列表
            ],
            ankangNum:{ //安康码数据
                registered:0,
                green:0,
                yellow:0,
                red:0
            },
            liftPart:{
                weightReay:0,
                height:0,
                speed:0,
                speedStatus:'',
                weight:0,
                weightPercent:0,
                height:0,
                heightPercent:0,
                systemStatusForelockStatus:'',
                msqm:0,
                systemStatusTilt:'',
                qxyj:0,
                systemStatusWeight:'',
                zlyj:0
            },
            enYear1:'',
            qsList:[], //监控预警列表
            highMod:{  //高支模
                wyVal1:0,
                wyRate1:'0%',
                wyVal2:0,
                wyRate2:'0%',
                qjVal1:0,
                qjRate1:'0%',
                qjVal2:0,
                qjRate2:'0%',
                ylVal1:0,
                ylRate1:'0%',
                ylVal2:0,
                ylRate2:'0%'
            },
            inOutUrl:'',//进出口监控视频
            inOutName:'正门人行通道入口',//进出口监控视频名称
            proInfo:{
                allDay: 0,
                name: "",
                otherDay: 0,
                planDays: 0,
                settlementTotal: 0,
                settlementValue: 0,
            },//项目信息
            websocket:undefined,//推送websocket
            inOutList:[],//进出口人员列表
            ctrlVis:false,//弹出框
            modularList:[],//模板列表（用于弹出框展示）
            //滚动
            animate:false,
            animate1:false,
            animate2:false,
            animate3:false,
            animate4:false,
            animate5:false,
            animate6:false,
            timer1:undefined,
            timer2:undefined,
            timer3:undefined,
            timer4:undefined,
            timer5:undefined,
            timer6:undefined,
            //定时器集合
            pageTimer:{}, //定义计算器全局变量
            curTime:util.myTime.getAllTime(),//当前时间
            //混凝土
            mixedList:[],
            //卸料平台
            unloadTime:util.myTime.getCurMonth(),
            unloadList:[],
            unloadId:'',//卸料设备序列号
            unloadInfo:{},
            unloadLog:[],//卸料日志
            moduleExeit:false,//判断是否存在模块保存
            //螺帽
            nutHostList:[],//螺帽主机
            nutId:'',//当前螺帽主机id
            nutInfo:{},//信息
            nutLog:[],//日志列表
            nutTime:util.myTime.getCurMonth(),
        }
    },
    created(){
        var that = this
        for(var each in this.pageTimer){
            window.clearTimeout(this.pageTimer[each]);
        }
        this.pageTimer['timer0'] = setInterval(function(){
            that.curTime = util.myTime.getAllTime()
        },1000)
    },
    mounted(){
        this.groupId = util.session.get('groupId')
        this.getMonitorToken()
        if(this.timer1){
            window.clearInterval(this.timer1)
        }
        if(this.timer2){
            window.clearInterval(this.timer2)
        }
        if(this.timer3){
            window.clearInterval(this.timer3)
        }
        if(this.timer4){
            window.clearInterval(this.timer4)
        }
        if(this.timer5){
            window.clearInterval(this.timer5)
        }
        if(this.timer6){
            window.clearInterval(this.timer6)
        }
        this.getSortList()
        
        this.setHcaht() //人员动态
        this.setSafeChat() //质量安全
        // this.setDisease() //疫情防控
        this.setDiseaseMonth() //疫情防控-月（初始）
        this.setDiseaseWeek() //疫情防控-周（初始）
        this.setCarLine() //车辆统计
        // this.setEngData() //能耗统计
        // this.setDust()//扬尘监测
        this.setHunlin()//混凝土
        this.attendData() //今日出勤
        this.getPresent()  //在场人员
        this.getDynPerson()  //人员动态-数据
        this.teamAttend() //班组出勤
        this.getAgree()  //合同信息
        this.getQsData()  //质量安全
        this.getDiseaseMonth()  //疫情管控 - 月
        this.getDiseaseWeek()   //疫情管控 - 周
        this.getCarData()  //车辆统计
        this.getProjectInfo()  //项目信息
        this.getWaterLine() //能耗 - 水-年
        this.getWaterPie() //能耗 - 水 -季度
        this.getEleLine() //能耗 - 电-年
        this.getElePie() //能耗 -电-季度
        this.getTowerList()  //塔吊监测 - 塔吊列表
        this.getDustLine()  //扬尘监测 - line
        this.getDustPie()  //扬尘监测 - pie
        this.getMenVideo()  //进出口人脸考勤
        this.getMonitorList()  //现场监控
        this.getMacType() //设备运行状态
        this.getQsList()  //监控预警
        this.getAnkang()  //安康码列表
        this.getLiftData() //升降机数据
        this.getModulus()  //高支模数据
        this.getConcreteData() //混凝土测温
        this.initWebsocket()//
        this.getUnloadList()//卸料设备列表
        this.setUnloadGauge()//卸料平台
        this.getNutHost() //螺帽主机列表

    },
    methods:{
        //获取展示模块数据
        getSortList(){
            var that = this
            myHttp.selectHomePage({
                groupId:this.groupId,
                type:'3'
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var data = resp.data.data.HomePage
                    if(data){
                        var list = JSON.parse(data.numerical)
                        console.log(list)
                        that.list0 = that.filterModult(that.list0,list,0)
                        that.list1 = that.filterModult(that.list1,list,1)
                        that.list2 = that.filterModult(that.list2,list,2)
                        that.list3 = that.filterModult(that.list3,list,3)
                        that.list4 = that.filterModult(that.list4,list,4)
                        that.moduleExeit = true
                        //重新赋值
                        for(var i=0;i<list.length;i++){
                            for(var j=0;j<list[i].length;j++){
                                for(var k=0;k<that.allList.length;k++){
                                    if(list[i][j].index==that.allList[k].index){
                                        that.allList[k].margin =  list[i][j].margin
                                        that.allList[k].show =  list[i][j].show
                                        that.allList[k].border =  list[i][j].border
                                    }
                                }
                            }
                        }
                    }
                }
            })
        },
        //对新模块进行兼容
        filterModult(list,all,col){
            for(var i=0;i<all.length;i++){
                for(var j=0;j<all[i].length;j++){
                    for(var k=0;k<list.length;k++){
                        if(list[k].index==all[i][j].index){
                            list[k].isExit =true
                        }
                    }
                }
            }
            for(var i=0;i<list.length;i++){
                if(!list[i].isExit){
                    all[col].push(list[i])
                }
            }
            return all[col]
        },
        //获取监控视频token
        getMonitorToken(){
            var that = this
            myHttp.getYsToken({
              projectId: this.groupId
            }).then(function(resp){
                if(resp.data.code=='200'){
                    that.ysToken = resp.data.data.accessToken||''
                    //that.showUrl = '/monitor/view/one.html?serial='+serial+'&channel='+channel+'&token='+ysToken
                }
            })
        },
        //今日出勤数据
        attendData(){
            var that = this
            myHttp.dayAttendance({
                projectId:this.groupId
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var data = resp.data.data || {}
                    data.manageRate = !data.manageAll||data.manageAll==0 ?0:(parseInt(data.manageCount)/parseInt(data.manageAll)*100).toFixed(2)
                    data.workersRate = !data.workersAll||data.workersAll==0 ?0:(parseInt(data.workersCount)/parseInt(data.workersAll)*100).toFixed(2)
                    data.specialRate = !data.specialAll||data.specialAll==0 ?0:(parseInt(data.specialCount)/parseInt(data.specialAll)*100).toFixed(2)
                    that.attend = data
                    
                }
                //定时刷新
                that.pageTimer["timer1"] = setTimeout(function(){
                    that.attendData()
                },that.timeout)
            })
        },
        //在场人员
        getPresent(){
            var that = this
            myHttp.dayInAttendance({
                projectId:this.groupId
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var data = resp.data.data || {}
                    data.manageRate = !data.manageAll||data.manageAll==0 ?0:(parseInt(data.manageCount)/parseInt(data.manageAll)*100).toFixed(2)
                    data.workersRate = !data.workersAll||data.workersAll==0 ?0:(parseInt(data.workersCount)/parseInt(data.workersAll)*100).toFixed(2)
                    data.specialRate = !data.specialAll||data.specialAll==0 ?0:(parseInt(data.specialCount)/parseInt(data.specialAll)*100).toFixed(2)
                    that.persent = data
                }
                //定时刷新
                that.pageTimer["timer2"] = setTimeout(function(){
                    that.getPresent()
                },that.timeout)
            })
        },
        //人员动态 - 数据
        getDynPerson(){
            var that = this
            myHttp.personDynamic({
                projectId:this.groupId
            }).then(function(resp){
                var data = resp.data.data || {}
                data.smRate = data.zs && data.zs!='0'?(parseInt(data.sm)/parseInt(data.zs)*100).toFixed(1)+'%':'0%'
                data.zzLv = data.zs && data.zs!='0'?(parseInt(data.zz)/parseInt(data.zs)*100).toFixed(1)+'%':'0%'
                data.wzzLv = data.zs && data.zs!='0'?(parseInt(data.wzz)/parseInt(data.zs)*100).toFixed(1)+'%':'0%'
                data.lzLv = data.zs && data.zs!='0'?(parseInt(data.lz)/parseInt(data.zs)*100).toFixed(1)+'%':'0%'
                that.syn = data
                that.setHcaht()
                //定时刷新
                that.pageTimer["timer3"] = setTimeout(function(){
                    that.getDynPerson()
                },that.timeout)
            })
        },
        //人员动态
        setHcaht(){
            var zz = !this.syn.zz||this.syn.zz == 0?0:this.syn.zz
            var lz = !this.syn.lz||this.syn.lz == 0?0:this.syn.lz
            var wzz = !this.syn.wzz||this.syn.wzz == 0?0:this.syn.wzz
            var option = {
                tooltip: {
                trigger: 'item',
                formatter: '{a} <br/>{b}: {c} ({d}%)',
                },
                graphic: {
                    type: 'text',
                    left: 'center',
                    // top: 'center',
                    z: 2,
                    style: {
                        text: '累计统计 \n '+this.syn.zs+'人',
                        x: 100,
                        y: 40,
                        textAlign: 'center',
                        fill: '#ffffff',
                        width: 30,
                        height: 30,
                        lineWidth:40,
                        fontSize: '100%',
                        fontWeight: 'bold',
                    },
                },
                series: [
                {
                    name: '累计人数',
                    type: 'pie',
                    radius: ['50%', '80%'],
                    hoverAnimation: false,
                    avoidLabelOverlap: false,
                    itemStyle: {
                        normal: {
                            color: function (params) {
                                var colorList = ['#228FFE','#F7B61C', '#F45E23', '#238FFE']
                                return colorList[params.dataIndex]
                            },
                        },
                    },
                    label: {
                        normal: {
                            show: true,
                            position: 'outside',
                            formatter: '{b}\n{c}',
                            textStyle: {
                                fontSize: '0',
                                fontWeight: 'bold',
                            },
                            emphasis: {
                                show: true,
                            },
                        },
                    },
                    labelLine: {
                        show: false,
                        length:8 ,
                        length2:8,
                    },
                    data: [
                        { value: zz, name: '在职' },
                        { value: lz, name: '离职' },
                        { value: wzz, name: '未入职' },
                    ],
                },
                ],
            }
            if(document.getElementById('myChart1')){
                var myChart1 = this.$echarts.init(document.getElementById('myChart1'))
                myChart1.setOption(option);
            }
            
        },

        //班组出勤
        teamAttend(){
            var that = this
            myHttp.getAttendNewHome({
                projectId:this.groupId,
                date:util.myTime.getCurTime()
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var list = resp.data.data.list||[]
                    for(var i=0;i<list.length;i++){
                        list[i].lv = list[i].zzCount==0?'0.0':(parseInt(list[i].cqCount)/parseInt(list[i].zzCount)*100).toFixed(1)
                    }
                    that.attendTeam = list
                    if(that.timer1){
                        window.clearInterval(that.timer1)
                    }
                    that.timer1 = setInterval(that.scroll,1300) // 班组考勤滚动
                    
                }
                //定时刷新
                that.pageTimer["timer4"] = setTimeout(function(){
                    that.teamAttend()
                },that.timeout1)
            })
        },

        //获取合同信息
        getAgree(){
            var that = this
            myHttp.findTeamsPerContract({
                projectId:this.groupId
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var list = resp.data.data.list||[]
                    that.agreeNum.wxq = resp.data.data.wxq
                    that.agreeNum.yqht = resp.data.data.yqht
                    that.agreeNum.ywq = resp.data.data.ywq
                    var wlv = that.agreeNum.yqht==0?0:(parseInt(that.agreeNum.wxq)/parseInt(that.agreeNum.yqht)*10).toFixed(0)
                    var ylv = that.agreeNum.yqht==0?0:(parseInt(that.agreeNum.ywq)/parseInt(that.agreeNum.yqht)*10).toFixed(0)
                    
                    that.agreeicon1 = []
                    that.agreeicon2 = []
                    for(var i=0;i<wlv;i++){
                        that.agreeicon1.push(i)
                    }
                    for(var j=0;j<ylv;j++){
                        that.agreeicon2.push(i)
                    }
                    that.tableAgree = list
                    if(that.timer2){
                        window.clearInterval(that.timer2)
                    }
                    that.timer2 = setInterval(that.scroll1,1800) // 合同滚动
                }
                //定时刷新
                that.pageTimer["timer5"] = setTimeout(function(){
                    that.getAgree()
                },that.timeout1)
                
            })
        },

        //获取质量安全-数据
        getQsData(){
            var that = this
            myHttp.selectProjectQsCount({
                projectId:this.groupId
            }).then(function(resp){
                // console.log(resp)
                if(resp.data.code=='200'){
                    var data = resp.data.data||that.qsChar
                    that.qsChar = data
                    that.setSafeChat()
                }
                //定时刷新
                that.pageTimer["timer6"] = setTimeout(function(){
                    that.getQsData()
                },that.timeout)
            })
        },
        //质量安全
        setSafeChat(){
            var data1 = !this.qsChar.entPendingCount || this.qsChar.entPendingCount==0?0.0001:this.qsChar.entPendingCount
            var data2 = !this.qsChar.projectProcessedCount || this.qsChar.projectProcessedCount==0?0.0001:this.qsChar.projectProcessedCount
            var data3 = !this.qsChar.projectNoProblemCount || this.qsChar.projectNoProblemCount==0?0.0001:this.qsChar.projectNoProblemCount
            var option1 = {
                title: {
                    text: '',
                    subtext: '',
                    left: 'center'
                },
                tooltip: {
                    trigger: 'item',
                    formatter: '{a} <br/>{b} : {c} ({d}%)'
                },
                legend: {
                    show:false,
                    type: 'scroll',
                    orient: 'vertical',
                    right: 10,
                    top: 20,
                    bottom: 20,
                    data: ['待处理','已处理','符合'],
                },
                series: [
                    {
                        name: '项目检查',
                        type: 'pie',
                        radius: '80%',
                        center: ['50%', '50%'],
                        label: {
                            position: 'inner',
                            formatter:'{d}%',
                            fontSize:'100%'
                        },
                        itemStyle: {
                            normal: {
                                color: function (params) {
                                    var colorList = ['#FF9B52','#4EE6B7', '#1299F3']
                                    return colorList[params.dataIndex]
                                },
                            },
                        },
                        data: [
                            {name:'待处理',value:parseInt(data1)},
                            {name:'已处理',value:parseInt(data2)},
                            {name:'符合',value:parseInt(data3)},
                        ],
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: 'rgba(0, 0, 0, 0.5)'
                            }
                        }
                    }
                ]
            }
            if(document.getElementById('safe1')){
                var safe1 = this.$echarts.init(document.getElementById('safe1'))
                safe1.setOption(option1)
            }
            
            //公司
            var data4 = !this.qsChar.entPendingCount || this.qsChar.entPendingCount==0?0:this.qsChar.entPendingCount
            var data5 = !this.qsChar.entProcessedCount || this.qsChar.entProcessedCount==0?0:this.qsChar.entProcessedCount
            var data6 = !this.qsChar.entNoProblemCount || this.qsChar.entNoProblemCount==0?0:this.qsChar.entNoProblemCount
            var option2 = {
                title: {
                    text: '',
                    subtext: '',
                    left: 'center'
                },
                tooltip: {
                    trigger: 'item',
                    formatter: '{a} <br/>{b} : {c} ({d}%)'
                },
                legend: {
                    show:false,
                    type: 'scroll',
                    orient: 'vertical',
                    right: 10,
                    top: 20,
                    bottom: 20,
                    data: ['待处理','已处理','符合'],
                },
                series: [
                    {
                        name: '公司检查',
                        type: 'pie',
                        radius: '80%',
                        center: ['50%', '50%'],
                        label: {
                            position: 'inner',
                            formatter:'{d}%',
                            fontSize:'100%'
                        },
                        itemStyle: {
                            normal: {
                                color: function (params) {
                                    var colorList = ['#70BFED','#F47E86', '#6E38A8']
                                    return colorList[params.dataIndex]
                                },
                            },
                        },
                        data: [
                            {name:'待处理',value:parseInt(data4)},
                            {name:'已处理',value:parseInt(data5)},
                            {name:'符合',value:parseInt(data6)},
                        ],
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: 'rgba(0, 0, 0, 0.5)'
                            }
                        }
                    }
                ]
            }
            if(document.getElementById('safe2')){
                var safe2 = this.$echarts.init(document.getElementById('safe2'))
                safe2.setOption(option2)
            }
            
            
        },

        //获取疫情-月
        getDiseaseMonth(){
            var that = this
            myHttp.month12AnKangCode({
                projectId:this.groupId
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var data = resp.data.data
                    var obj = {
                        green:[],
                        yellow:[],
                        red:[],
                        sum:0
                    }
                    obj.sum = data.sum
                    for(var i=0;i<data.green.length;i++){
                        obj.green.push(parseInt(data.green[i].sums))
                        obj.yellow.push(parseInt(data.yellow[i].sums))
                        obj.red.push(parseInt(data.red[i].sums))
                    }
                    that.setDiseaseMonth(obj)
                }
                //定时刷新
                that.pageTimer["timer7"] = setTimeout(function(){
                    that.getDiseaseMonth()
                },that.timeout)
            })
        },
        //获取疫情 - 周
        getDiseaseWeek(){
            var that = this
            myHttp.word7AnKangCode({
                projectId:this.groupId
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var data = resp.data.data
                    var obj = {
                        green:[],
                        yellow:[],
                        red:[],
                        sum:0
                    }
                    obj.sum = data.sum
                    for(var i=0;i<data.green.length;i++){
                        obj.green.push(parseInt(data.green[i].sums))
                        obj.yellow.push(parseInt(data.yellow[i].sums))
                        obj.red.push(parseInt(data.red[i].sums))
                    }
                    that.setDiseaseWeek(obj)
                }
                //定时刷新
                that.pageTimer["timer8"] = setTimeout(function(){
                    that.getDiseaseWeek()
                },that.timeout)
            })
        },
        //疫情防控-月
        setDiseaseMonth(data){
            data = data?data:{
                green:[0,0,0,0,0,0,0,0,0,0,0,0],
                red:[0,0,0,0,0,0,0,0,0,0,0,0],
                yellow:[0,0,0,0,0,0,0,0,0,0,0,0],
                sum:0
            }
            if(document.getElementById('disease1')){
                var chart = HighCharts.chart('disease1', {
                    chart: {
                        type: 'spline',
                        backgroundColor:'transparent',
                        spacing:[0,0,0,0],
                    },
                    title: {
                        text: '累计统计登录人数 '+data.sum,
                        style:{
                            color:'#ffffff'
                        },
                        y:10,
                        x:50,
                        align:'left',
                    },
                    legend: {
                        align: 'right',
                        verticalAlign: 'top',
                        y: 0,
                        floating: true,
                        borderWidth: 0,
                        itemStyle:{
                            fontWeight:'500',
                            color:'#fff',
                            fontSize:'10rem'
                        },
                        symbolWidth:5,
                    },
                    xAxis: {
                        // type: 'datetime',
                        categories: ['1', '2', '3', '4', '5', '6','7', '8', '9', '10', '11', '12'],
                        title: {
                            text: '（月）',
                            style:{
                                color:'#ffffff'
                            },
                            align:'high'
                        },
                        labels:{
                            style:{
                                color:"#ffffff",
                                fontSize:'16rem',
                            }
                        },
                        lineColor:'#707070',
                    },
                    colors: ['#09AB2C', '#FCDD27', '#D30000', '#036', '#000'],
                    yAxis: {
                        title: {
                            text: '(人)',
                            style:{
                                color:'#ffffff'
                            },
                            align:'high'
                        },
                        min: 0,
                        labels:{
                            style:{
                                color:"#ffffff",
                                fontSize:'16rem',
                            }
                        },
                        lineColor:'#707070',
                        gridLineColor:'#707070',
                    },
                    plotOptions: {
                        spline: {
                            marker: {
                                enabled: false
                            }
                        },
                        
                    },
                    series: [{
                        name: '正常绿码',
                        data: data.green
                    }, {
                        name: '异常黄码',
                        data: data.yellow
                    }, {
                        name: '异常红码',
                        data: data.red
                    }]
                });
            } 
            
        },
        //疫情防控 - 周
        setDiseaseWeek(data){
            data = data?data:{
                green:[0,0,0,0,0,0,0],
                red:[0,0,0,0,0,0,0],
                yellow:[0,0,0,0,0,0,0],
                sum:0
            }
            if(document.getElementById('disease2')){
                var chart = HighCharts.chart('disease2', {
                    chart: {
                        type: 'line',
                        backgroundColor:'transparent',
                        spacing:[0,0,0,0],
                    },
                    title: {
                        text: '本周统计登录人数 '+data.sum,
                        style:{
                            color:'#ffffff'
                        },
                        y:10,
                        x:50,
                        align:'left',
                    },
                    legend: {
                        align: 'right',
                        verticalAlign: 'top',
                        y: 0,
                        floating: true,
                        borderWidth: 0,
                        itemStyle:{
                            fontWeight:'500',
                            color:'#fff',
                            fontSize:'12rem'
                        },
                        symbolWidth:5,
                    },
                    xAxis: {
                        // type: 'datetime',
                        categories: ['周一', '周二', '周三', '周四', '周五', '周六','周日'],
                        title: {
                            text: '（月）',
                            style:{
                                color:'#ffffff'
                            },
                            align:'high'
                        },
                        labels:{
                            style:{
                                color:"#ffffff",
                                fontSize:'16rem',
                            }
                        },
                        lineColor:'#707070',
                    },
                    colors: ['#09AB2C', '#FCDD27', '#D30000', '#036', '#000'],
                    yAxis: {
                        title: {
                            text: '(人)',
                            style:{
                                color:'#ffffff'
                            },
                            align:'high'
                        },
                        min: 0,
                        labels:{
                            style:{
                                color:"#ffffff",
                                fontSize:'16rem',
                            }
                        },
                        lineColor:'#707070',
                        gridLineColor:'#707070',
                    },
                    plotOptions: {
                        spline: {
                            marker: {
                                enabled: false
                            }
                        }
                    },
                    series: [{
                        name: '正常绿码',
                        data: data.green
                    }, {
                        name: '异常黄码',
                        data: data.yellow
                    }, {
                        name: '异常红码',
                        data: data.red
                    }]
                });
            }
        },

        //获取车辆管理 - 数据
        getCarData(){
            var that = this
            var year = new Date().getFullYear();
            myHttp.selectOneYearCarInOutInfo({
                projectId: this.groupId,
                year:year
            }).then(function(resp) {
                if (resp.data.code == '200') {
                    var carCount = resp.data.data.inOut || []
                    var tempInOut =resp.data.data.tempInOut ||[]
                    var arr1 = []
                    var arr2 = []
                    if(carCount.length>0){
                        for (var i = 0; i < carCount.length; i++) {
                            arr1.push(carCount[i].count)
                        }
                    }else{
                        arr1 = [0,0,0,0,0,0,0,0,0,0,0,0]
                    }
                    if(tempInOut.length>0){
                        for (var i = 0; i < tempInOut.length; i++) {
                            arr2.push(tempInOut[i].count)
                        }
                    }else{
                        arr2 = [0,0,0,0,0,0,0,0,0,0,0,0]
                    }
                    that.setCarLine(arr1,arr2)
                }
                //定时刷新
                that.pageTimer["timer9"] = setTimeout(function(){
                    that.getCarData()
                },that.timeout)
            },function() {})
        },
        //车辆管理
        setCarLine(arr1,arr2){
            arr1 = arr1?arr1:[0,0,0,0,0,0,0,0,0,0,0,0]
            arr2 = arr2?arr2:[0,0,0,0,0,0,0,0,0,0,0,0]
            if(document.getElementById('car1')){
                var chart = HighCharts.chart('car1', {
                    chart: {
                        type: 'spline',
                        backgroundColor:'transparent',
                        spacing:[10,0,10,0],
                    },
                    title: {
                        text: '',
                        style:{
                            color:'#ffffff'
                        },
                        
                    },
                    legend: {
                        align: 'right',
                        verticalAlign: 'top',
                        y: -30,
                        floating: true,
                        borderWidth: 0,
                        itemStyle:{
                            fontWeight:'500',
                            color:'#fff',
                        },
                    },
                    xAxis: {
                        // type: 'datetime',
                        categories: ['一月', '二月', '三月', '四月', '五月', '六月','七月','八月','九月','十月','十一月','十二月'],
                        labels:{
                            style:{
                                color:"#ffffff",
                                fontSize:'16rem',
                            }
                        },
                        lineColor:'#707070',
                    },
                    colors: ['#32B7E9', '#00D69C'],
                    yAxis: {
                        title: {
                            text: '',
                        },
                        min: 0,
                        labels:{
                            style:{
                                color:"#ffffff",
                                fontSize:'16rem',
                            }
                        },
                        lineColor:'#707070',
                        gridLineColor:'#707070',
                    },
                    plotOptions: {
                        spline: {
                            marker: {
                                enabled: false
                            }
                        }
                    },
                    series: [{
                        name: '登记',
                        data: arr1
                    }, {
                        name: '临时',
                        data: arr2
                    }]
                });
            }
            
        },

        /**项目信息 ************************************/
        getProjectInfo(){
            var that = this
            myHttp.getProjectInfo({
                id:this.groupId
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var data = resp.data.data.project
                    that.proInfo = data
                    that.proNameSize = data.name.length>14?parseInt(736/parseInt(data.name.length+10)):'30'
                    console.log(data)
                }
            })
        },

        //获取能耗-电-line
        getEleLine(){
            var that = this
            myHttp.selectWaterElectricityRecord({
                groupId:this.groupId,
                date:this.eleYear,
                type:'2'
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var list = resp.data.data.List||[]
                    var obj = []
                    if(list.length>0){
                        for(var i=0;i<list.length;i++){
                            obj.push(parseFloat(list[i].useOf))
                        }
                    }else{
                        obj = [0,0,0,0,0,0,0,0,0,0,0,0]
                    }
                    that.setEngData1(obj)
                }
                //定时刷新
                that.pageTimer["timer10"] = setTimeout(function(){
                    that.getEleLine()
                },that.timeout)
            })
        },
        //获取能耗-电-pie
        getElePie(){
            var that = this
            myHttp.selectWaterByQuarter({
                projectId:this.groupId,
                year:this.eleYear,
                type:'2'
            }).then(function(resp){
                // console.log(resp)
                if(resp.data.code=='200'){
                    var list = resp.data.data.yearWater||[]
                    var elePie = []
                    if(list.length>0){
                        elePie.push(parseFloat(list[0].allCalculateUseOf))
                        elePie.push(parseFloat(list[1].allCalculateUseOf))
                        elePie.push(parseFloat(list[2].allCalculateUseOf))
                        elePie.push(parseFloat(list[3].allCalculateUseOf))
                    }else{
                        elePie=[0,0,0,0]
                    }
                    that.setEngData2(elePie)
                }
                //定时刷新
                that.pageTimer["timer11"] = setTimeout(function(){
                    that.getElePie()
                },that.timeout)
            })
        },
        //获取能耗-水-line
        getWaterLine(){
            var that = this
            myHttp.selectWaterElectricityRecord({
                groupId:this.groupId,
                date:this.waterYear,
                type:'1'
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var list = resp.data.data.List||[]
                    var obj = []
                    for(var i=0;i<list.length;i++){
                        obj.push(parseFloat(list[i].useOf))
                    }
                    that.setEngData3(obj)
                }
                //定时刷新
                that.pageTimer["timer12"] = setTimeout(function(){
                    that.getWaterLine()
                },that.timeout)
            })
        },
        //获取能耗-水-pie
        getWaterPie(){
            var that = this
            myHttp.selectWaterByQuarter({
                projectId:this.groupId,
                year:this.waterYear,
                type:'1'
            }).then(function(resp){
                // console.log(resp)
                if(resp.data.code=='200'){
                    var list = resp.data.data.yearWater||[]
                    that.waterPie = []
                    that.waterPie.push(parseFloat(list[0].allCalculateUseOf))
                    that.waterPie.push(parseFloat(list[1].allCalculateUseOf))
                    that.waterPie.push(parseFloat(list[2].allCalculateUseOf))
                    that.waterPie.push(parseFloat(list[3].allCalculateUseOf))
                    that.setEngData4()
                }
                //定时刷新
                that.pageTimer["timer13"] = setTimeout(function(){
                    that.getWaterPie()
                },that.timeout)
            })
        },
        //能耗统计 - 电 -line
        setEngData1(list){
            list = list?list:[0,0,0,0,0,0,0,0,0,0,0,0]
            if(document.getElementById('energy1')){
                HighCharts.chart('energy1', {
                    chart: {
                        type: 'spline',
                        backgroundColor:'transparent',
                        spacing:[10,0,10,0],
                    },
                    title: {
                        text: '',
                    },
                    legend: {
                        enabled: false
                    },
                    xAxis: {
                        // type: 'datetime',
                        categories: ['一月', '二月', '三月', '四月', '五月', '六月','七月','八月','九月','十月','十一月','十二月'],
                        title: {
                            text: '',
                            style:{
                                color:'#ffffff'
                            },
                            align:'high'
                        },
                        labels:{
                            style:{
                                color:"#ffffff",
                                fontSize:'16rem',
                            }
                        },
                        // lineColor:'#ffffff',
                        lineWidth: 0,
                        minorGridLineWidth: 0,
                        lineColor: 'transparent'
                    },
                    tooltip: {
                        headerFormat: '<span style="font-size:10rem"></span><table>',
                        pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
                        '<td style="padding:0"><b>{point.y:.1f} 吨</b></td></tr>',
                        footerFormat: '</table>',
                        shared: true,
                        useHTML: true
                    },
                    colors: ['#238FFE', '#FCDD27', '#D30000', '#036', '#000'],
                    yAxis: {
                        title: {
                            text: '（单位：千瓦时）',
                            style:{
                                color:'#ffffff',
                                fontSize:'12rem'
                            },
                            align:'high'
                        },
                        min: 0,
                        labels:{
                            style:{
                                color:"#ffffff",
                                fontSize:'16rem',
                            }
                        },
                        // lineColor:'#707070',
                    },
                    plotOptions: {
                        spline: {
                            marker: {
                                enabled: true
                            }
                        },
                        
                    },
                    series: [{
                        name: '用电统计',
                        data: list
                    }]
                });
            }
            
        },
        //能耗统计 - 电 -pie
        setEngData2(list){
            list = list?list:[0,0,0,0]
            var eleTotal = list[0]+list[1]+list[2]+list[3]
            var option = {
                tooltip: {
                trigger: 'item',
                formatter: '{a} <br/>{b}: {c} ({d}%)',
                },
                graphic: {
                    type: 'text',
                    left: 'center',
                    // top: 'center',
                    z: 2,
                    style: {
                        text: '总用电量 \n\n '+eleTotal+'千瓦时',
                        x: 100,
                        y: 35,
                        textAlign: 'center',
                        fill: '#ffffff',
                        width: 30,
                        height: 30,
                        fontSize: '100%',
                        fontWeight: 'bold',
                    },
                },
                series: [
                {
                    name: '用电统计',
                    type: 'pie',
                    radius: ['42%', '64%'],
                    hoverAnimation: false,
                    avoidLabelOverlap: false,
                    // labelLine:{  
                    //     normal:{  
                            
                    //     }  
                    // }, 
                    itemStyle: {
                        normal: {
                            color: function (params) {
                                var colorList = ['#64EBA8', '#F47E86', '#00FFFF', '#238FFE']
                                return colorList[params.dataIndex]
                            },
                        },
                    },
                    label: {
                        normal: {
                                show: true,
                                position: 'outside',
                                formatter: '{b}\n{c}千瓦时',
                                textStyle: {
                                fontSize: '100%',
                                fontWeight: 'bold',
                            },
                            emphasis: {
                                show: true,
                            },
                        },
                    },
                    emphasis: {
                        label: {
                            show: true,
                            fontSize: '100%',
                            fontWeight: 'bold',
                        },
                    },
                    labelLine: {
                        show: true,
                        length:8 ,
                        length2:8,
                    },
                    data: [
                        { value: list[0], name: '一季度' },
                        { value: list[1], name: '二季度' },
                        { value: list[2], name: '三季度' },
                        { value: list[3], name: '四季度' },
                    ],
                },
                ],
            }
            if(document.getElementById('energy2')){
                var energy2 = this.$echarts.init(document.getElementById('energy2'))
                energy2.setOption(option);
            }
            
        },
        //能耗统计 - 水 -line
        setEngData3(obj){
            obj = obj?obj:[0,0,0,0,0,0,0,0,0,0,0,0]
            if(document.getElementById('energy3')){
                HighCharts.chart('energy3',{
                    chart: {
                        type: 'column',
                        backgroundColor:'transparent',
                        spacing:[20,0,10,0],
                    },
                    title: {
                        text: ''
                    },
                    subtitle: {
                        text: ''
                    },
                    legend: {
                        enabled: false
                    },
                    xAxis: {
                        categories: [
                            '一月','二月','三月','四月','五月','六月','七月','八月','九月','十月','十一月','十二月'
                        ],
                        crosshair: true,
                        title: {
                            text: '',
                            style:{
                                color:'#ffffff'
                            },
                            align:'high'
                        },
                        labels:{
                            style:{
                                color:"#ffffff",
                                fontSize:'16rem',
                            }
                        },
                    },
                    yAxis: {
                        title: {
                            text: '（单位：吨）',
                            style:{
                                color:'#ffffff',
                                fontSize:'12rem'
                            },
                            align:'high'
                        },
                        min: 0,
                        labels:{
                            style:{
                                color:"#ffffff",
                                fontSize:'16rem',
                            }
                        },
                        
                    },
                    colors: ['#11C0FF', '#00D69C'],
                    tooltip: {
                        headerFormat: '<span style="font-size:10rem"></span><table>',
                        pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
                        '<td style="padding:0"><b>{point.y:.1f} 吨</b></td></tr>',
                        footerFormat: '</table>',
                        shared: true,
                        useHTML: true
                    },
                    plotOptions: {
                        column: {
                            borderWidth: 0
                        }
                    },
                    series: [{
                        name: '用水量',
                        data: obj
                    }]
                });
            }
            
        },
        setEngData4(){
            var waterTotal = this.waterPie[0]+this.waterPie[1]+this.waterPie[2]+this.waterPie[3]
            var option = {
                tooltip: {
                    trigger: 'item',
                    formatter: '{a} <br/>{b}: {c} ({d}%)',
                },
                graphic: {
                    type: 'text',
                    left: 'center',
                    // top: 'center',
                    z: 2,
                    style: {
                        text: '总用水量 \n\n '+waterTotal+'吨',
                        x: 100,
                        y: 35,
                        textAlign: 'center',
                        fill: '#ffffff',
                        width: 30,
                        height: 30,
                        fontSize: '100%',
                        fontWeight: 'bold',
                    },
                },
                series: [
                {
                    name: '用水统计',
                    type: 'pie',
                    radius: ['42%', '64%'],
                    hoverAnimation: false,
                    avoidLabelOverlap: false,
                    itemStyle: {
                    normal: {
                        color: function (params) {
                            var colorList = ['#F45E23', '#70BFED', '#6E38A8', '#FABE4A']
                            return colorList[params.dataIndex]
                        },
                    },
                    },
                    label: {
                    normal: {
                            show: true,
                            position: 'outside',
                            formatter: '{b}\n{c}吨',
                            textStyle: {
                            fontSize: '100%',
                            fontWeight: 'bold',
                        },
                        emphasis: {
                            show: true,
                        },
                    },
                    },
                    emphasis: {
                        label: {
                            show: true,
                            fontSize: '100%',
                            fontWeight: 'bold',
                        },
                    },
                    labelLine: {
                        show: true,
                        length:8 ,
                        length2:8,
                    },
                    data: [
                        { value: this.waterPie[0], name: '一季度' },
                        { value: this.waterPie[1], name: '二季度' },
                        { value: this.waterPie[2], name: '三季度' },
                        { value: this.waterPie[3], name: '四季度' },
                    ],
                },
                ],
            }
            if(document.getElementById('energy4')){
                var energy4 = this.$echarts.init(document.getElementById('energy4'))
                energy4.setOption(option);
            }
            
        },
        
        //塔吊列表
        getTowerList(){
            var that = this
            myHttp.getTowerListByPage({
                projectId:this.groupId
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var list = resp.data.data.towerList||[]
                    for(var i=0;i<list.length;i++){
                        if(list[i].machType=='3'){
                            list[i].online = list[i].connectedStatus && ''!=list[i].connectedStatus?list[i].connectedStatus:'离线'
                        }else{
                            if(list[i].status=='0'){
                                list[i].online = '离线'
                            }else if(list[i].status=='1'){
                                list[i].online = '在线'
                            }else{
                               list[i].online = '异常'
                            }
                        }
                        
                    }
                    that.towerlist = list
                    if(list.length>0 && that.towerId==''){
                        that.towerId = list[0].id
                        // that.deviceId = list[0].deviceId
                    }
                    if(that.towerId!=''){
                        that.getRealInfo()
                    }
                }
            })
        },
        //点击塔吊
        changeTower(row){
            this.towerId = row.id
            this.getRealInfo()
        },
        getRealInfo(){
            var that = this
            myHttp.getTowerInfoByPage({
                id:this.towerId,
                v:new Date().getTime()
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var data = resp.data.data.tower||{}
                    data.angle = data.angle && ''!=data.angle?data.angle:0
                    that.towerPart = data
                    that.cameraData = data.camera
                    if(data.camera){
                        that.towerVideo = '/monitor/view/one.html?serial='+data.camera.serial+'&channel='+data.camera.channelNo+'&token='+that.ysToken
                    }
                }
                //定时刷新
                that.pageTimer["timer14"] = setTimeout(function(){
                    that.getRealInfo()
                },that.timeout)
            })
        },

        //扬尘监测 - 24小时
        getDustLine(){
            var that = this
            myHttp.get24HourStatisByProjectId({
                projectId: this.groupId
            }).then(function(resp) {
                var list = resp.data.data.dustList || []
                var pm2 = [],
                    pm10 = [],
                    noise = [],
                    temperature = []
                for (var i = 0; i < list.length; i++) {
                    pm2.push(list[i].pm2 || 0)
                    pm10.push(list[i].pm10 || 0)
                    noise.push(list[i].noise || 0)
                    temperature.push(list[i].temperature || 0)
                }
                that.setDustLine(pm2, pm10, noise, temperature)
                //定时刷新
                that.pageTimer["timer15"] = setTimeout(function(){
                    that.getDustLine()
                },that.timeout)
            })
        },
        //扬尘监测 - PM2.5监测
        getDustPie(){
            var that = this
            myHttp.getPM2ByProjectId({
                projectId: this.groupId
            }).then(function(resp) {
                var data = resp.data.data.pm25
                var all = parseInt(data.cha) + parseInt(data.you) + parseInt(data.liang)
                data.all = all
                that.setDustPie(data)
                //定时刷新
                that.pageTimer["timer16"] = setTimeout(function(){
                    that.getDustPie()
                },that.timeout)
            })
        },
        setDustLine(pm2,pm10,noise,temperature){
            pm2 = pm2.length>0?pm2:[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]
            pm10 = pm10.length>0?pm10:[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]
            noise = noise.length>0?noise:[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]
            temperature = temperature.length>0?temperature:[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]
            var option = {
                title: {
                    text: ''
                },
                legend: {
                    data: ['PM2.5', 'PM10', '噪音(dB)', '温度(℃)'],
                    textStyle:{
                        color:'#fff',
                        fontSize:'100%'
                    },
                    itemWidth :5,
                    itemHeight:5, 
                    right:'5%',
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    top:'20%',
                    containLabel: true
                },
                xAxis: [
                    {
                        type: 'category',
                        boundaryGap: false,
                        data: ['00:00','01:00','02:00','03:00','04:00','05:00','06:00','07:00','08:00','09:00','10:00','11:00','12:00','13:00','14:00','15:00','16:00','17:00','18:00','19:00','20:00','21:00','22:00','23:00'],
                        nameTextStyle:{
                            color:'#fff'
                        },
                        axisLine:{
                            lineStyle:{
                                color:'#fff'
                            }
                        }
                    }
                ],
                color: ['#29AC5D', '#FF854E', '#892FD5', '#5473E8'],
                yAxis: [
                    {
                        type: 'value',
                        axisLine:{
                            lineStyle:{
                                color:'#fff'
                            }
                        },
                        name: '',
                    }
                ],
                series: [
                    {
                        name: 'PM2.5',
                        type: 'line',
                        stack: '总量',
                        areaStyle: {},
                        data: pm2
                    },
                    {
                        name: 'PM10',
                        type: 'line',
                        stack: '总量',
                        areaStyle: {},
                        data: pm10
                    },
                    {
                        name: '噪音(dB)',
                        type: 'line',
                        stack: '总量',
                        areaStyle: {},
                        data: noise
                    },
                    {
                        name: '温度(℃)',
                        type: 'line',
                        stack: '总量',
                        areaStyle: {},
                        data: temperature
                    }
                ]
            }
            if(document.getElementById('dust1')){
                var dust1 = this.$echarts.init(document.getElementById('dust1'))
                dust1.setOption(option)
            }
            
        },
        setDustPie(data){
            data = data?data:{all:0,you:0,liang:0,cha:0}
            var option = {
                tooltip: {
                    trigger: 'item',
                    formatter: '{a} <br/>{b}: {c} ({d}%)'
                },
                graphic: {
                    type: 'text',
                    left: 'center',
                    top: 'center',
                    z: 2,
                    style: {
                        text: data.all+'天',
                        x: 100,
                        y: 100,
                        textAlign: 'center',
                        fill: '#ffffff',
                        height: 30,
                        fontSize: '100%',
                        fontWeight: 'bold'
                    }
                },
                legend: {
                    orient: 'vertical',
                    x: 'right',
                    data: ['优', '良', '轻度'],
                    textStyle:{
                        color:'#fff',
                        fontSize:'100%',
                    },
                    itemWidth :5,
                    itemHeight:5, 
                },
                series: [
                {
                    name: '环境监测',
                    type: 'pie',
                    radius: ['55%', '75%'],
                    hoverAnimation: false,
                    itemStyle: {
                    normal: {
                        color: function(params) {
                        var colorList = ['#6CA2F4', '#78DD7A', '#C3C423']
                        return colorList[params.dataIndex]
                        }
                    }
                    },
                    avoidLabelOverlap: false,
                    label: {
                    normal: {
                        show: false
                    }
                    },
                    labelLine: {
                    show: false
                    },
                    data: [
                    { value: data.you, name: '优' },
                    { value: data.liang, name: '良' },
                    { value: data.cha, name: '轻度' }
                    ]
                }
                ]
            }
            if(document.getElementById('dust2')){
                var page = this.$echarts.init(document.getElementById('dust2'))
                page.setOption(option)
            }
            
        },

        /**进出口实时人脸 *****************************************/
        getMenVideo(){
            var that = this
            myHttp.selectCameraByUseType({
                projectId:this.groupId,
                useType:'3'
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var list = resp.data.data.Camera
                    if(list.length>0){
                        that.inOutName = list[0].name
                        that.inOutUrl = '/monitor/view/one.html?serial='+list[0].serial+'&channel='+list[0].channelNo+'&token='+that.ysToken
                    }
                }
                
            })
        },

        /**展示地图****************************************** */
        //地图展示
        handler({ BMap, map }) {
            this.map = map
            this.BMap = BMap
            this.map.enableScrollWheelZoom();
            map.addControl(new BMap.ScaleControl());
            var styleJson = [{
                "featureType": "land",
                "elementType": "geometry",
                "stylers": {
                    "visibility": "on",
                    "color": "#2F5FE9ff"
                }
            }, {
                "featureType": "water",
                "elementType": "geometry",
                "stylers": {
                    "visibility": "on",
                    "color": "#113549ff"
                }
            }, {
                "featureType": "green",
                "elementType": "geometry",
                "stylers": {
                    "visibility": "on",
                    "color": "#0e1b30ff"
                }
            }, {
                "featureType": "building",
                "elementType": "geometry",
                "stylers": {
                    "visibility": "on"
                }
            }, {
                "featureType": "building",
                "elementType": "geometry.fill",
                "stylers": {
                    "color": "#ffffffb3"
                }
            }, {
                "featureType": "building",
                "elementType": "geometry.stroke",
                "stylers": {
                    "color": "#dadadab3"
                }
            }, {
                "featureType": "subwaystation",
                "elementType": "geometry",
                "stylers": {
                    "visibility": "on",
                    "color": "#b15454B2"
                }
            }, {
                "featureType": "education",
                "elementType": "geometry",
                "stylers": {
                    "visibility": "on",
                    "color": "#e4f1f1ff"
                }
            }, {
                "featureType": "medical",
                "elementType": "geometry",
                "stylers": {
                    "visibility": "on",
                    "color": "#f0dedeff"
                }
            }, {
                "featureType": "scenicspots",
                "elementType": "geometry",
                "stylers": {
                    "visibility": "on",
                    "color": "#e2efe5ff"
                }
            }, {
                "featureType": "highway",
                "elementType": "geometry",
                "stylers": {
                    "visibility": "on",
                    "weight": 4
                }
            }, {
                "featureType": "highway",
                "elementType": "geometry.fill",
                "stylers": {
                    "color": "#2F5FE9ff"
                }
            }, {
                "featureType": "highway",
                "elementType": "geometry.stroke",
                "stylers": {
                    "color": "#fed669ff"
                }
            }, {
                "featureType": "highway",
                "elementType": "labels",
                "stylers": {
                    "visibility": "on"
                }
            }, {
                "featureType": "highway",
                "elementType": "labels.text.fill",
                "stylers": {
                    "color": "#8f5a33ff"
                }
            }, {
                "featureType": "highway",
                "elementType": "labels.text.stroke",
                "stylers": {
                    "color": "#ffffffff"
                }
            }, {
                "featureType": "highway",
                "elementType": "labels.icon",
                "stylers": {
                    "visibility": "on"
                }
            }, {
                "featureType": "arterial",
                "elementType": "geometry",
                "stylers": {
                    "visibility": "on",
                    "weight": 2
                }
            }, {
                "featureType": "arterial",
                "elementType": "geometry.fill",
                "stylers": {
                    "color": "#d8d8d8ff"
                }
            }, {
                "featureType": "arterial",
                "elementType": "geometry.stroke",
                "stylers": {
                    "color": "#ffeebbff"
                }
            }, {
                "featureType": "arterial",
                "elementType": "labels",
                "stylers": {
                    "visibility": "on"
                }
            }, {
                "featureType": "arterial",
                "elementType": "labels.text.fill",
                "stylers": {
                    "color": "#525355ff"
                }
            }, {
                "featureType": "arterial",
                "elementType": "labels.text.stroke",
                "stylers": {
                    "color": "#ffffffff"
                }
            }, {
                "featureType": "local",
                "elementType": "geometry",
                "stylers": {
                    "visibility": "on",
                    "weight": 1
                }
            }, {
                "featureType": "local",
                "elementType": "geometry.fill",
                "stylers": {
                    "color": "#d8d8d8ff"
                }
            }, {
                "featureType": "local",
                "elementType": "geometry.stroke",
                "stylers": {
                    "color": "#ffffffff"
                }
            }, {
                "featureType": "local",
                "elementType": "labels",
                "stylers": {
                    "visibility": "on"
                }
            }, {
                "featureType": "local",
                "elementType": "labels.text.fill",
                "stylers": {
                    "color": "#979c9aff"
                }
            }, {
                "featureType": "local",
                "elementType": "labels.text.stroke",
                "stylers": {
                    "color": "#ffffffff"
                }
            }, {
                "featureType": "railway",
                "elementType": "geometry",
                "stylers": {
                    "visibility": "on",
                    "weight": 1
                }
            }, {
                "featureType": "railway",
                "elementType": "geometry.fill",
                "stylers": {
                    "color": "#123c52ff"
                }
            }, {
                "featureType": "railway",
                "elementType": "geometry.stroke",
                "stylers": {
                    "color": "#12223dff"
                }
            }, {
                "featureType": "subway",
                "elementType": "geometry",
                "stylers": {
                    "visibility": "on",
                    "weight": 1
                }
            }, {
                "featureType": "subway",
                "elementType": "geometry.fill",
                "stylers": {
                    "color": "#2F5FE9ff"
                }
            }, {
                "featureType": "subway",
                "elementType": "geometry.stroke",
                "stylers": {
                    "color": "#2F5FE9ff"
                }
            }, {
                "featureType": "subway",
                "elementType": "labels",
                "stylers": {
                    "visibility": "on"
                }
            }, {
                "featureType": "subway",
                "elementType": "labels.text.fill",
                "stylers": {
                    "color": "#979c9aff"
                }
            }, {
                "featureType": "subway",
                "elementType": "labels.text.stroke",
                "stylers": {
                    "color": "#ffffffff"
                }
            }, {
                "featureType": "continent",
                "elementType": "labels",
                "stylers": {
                    "visibility": "on"
                }
            }, {
                "featureType": "continent",
                "elementType": "labels.icon",
                "stylers": {
                    "visibility": "on"
                }
            }, {
                "featureType": "continent",
                "elementType": "labels.text.fill",
                "stylers": {
                    "color": "#333333ff"
                }
            }, {
                "featureType": "continent",
                "elementType": "labels.text.stroke",
                "stylers": {
                    "color": "#ffffffff"
                }
            }, {
                "featureType": "city",
                "elementType": "labels.icon",
                "stylers": {
                    "visibility": "on"
                }
            }, {
                "featureType": "city",
                "elementType": "labels",
                "stylers": {
                    "visibility": "on"
                }
            }, {
                "featureType": "city",
                "elementType": "labels.text.fill",
                "stylers": {
                    "color": "#454d50ff"
                }
            }, {
                "featureType": "city",
                "elementType": "labels.text.stroke",
                "stylers": {
                    "color": "#ffffffff"
                }
            }, {
                "featureType": "town",
                "elementType": "labels.icon",
                "stylers": {
                    "visibility": "on"
                }
            }, {
                "featureType": "town",
                "elementType": "labels",
                "stylers": {
                    "visibility": "on"
                }
            }, {
                "featureType": "town",
                "elementType": "labels.text.fill",
                "stylers": {
                    "color": "#454d50ff"
                }
            }, {
                "featureType": "town",
                "elementType": "labels.text.stroke",
                "stylers": {
                    "color": "#ffffffff"
                }
            }, {
                "featureType": "road",
                "elementType": "geometry.fill",
                "stylers": {
                    "color": "#2F5FE9ff " //  #12223dff
                }
            }, {
                "featureType": "poilabel",
                "elementType": "labels",
                "stylers": {
                    "visibility": "on"
                }
            }, {
                "featureType": "districtlabel",
                "elementType": "labels",
                "stylers": {
                    "visibility": "off"
                }
            }, {
                "featureType": "road",
                "elementType": "geometry",
                "stylers": {
                    "visibility": "on"
                }
            }, {
                "featureType": "road",
                "elementType": "labels",
                "stylers": {
                    "visibility": "off"
                }
            }, {
                "featureType": "road",
                "elementType": "geometry.stroke",
                "stylers": {
                    "color": "#ffffff00"
                }
            }, {
                "featureType": "district",
                "elementType": "labels",
                "stylers": {
                    "visibility": "off"
                }
            }, {
                "featureType": "poilabel",
                "elementType": "labels.icon",
                "stylers": {
                    "visibility": "off"
                }
            }, {
                "featureType": "poilabel",
                "elementType": "labels.text.fill",
                "stylers": {
                    "color": "#2dc4bbff"
                }
            }, {
                "featureType": "poilabel",
                "elementType": "labels.text.stroke",
                "stylers": {
                    "color": "#ffffff00"
                }
            }, {
                "featureType": "manmade",
                "elementType": "geometry",
                "stylers": {
                    "color": "#12223dff"
                }
            }, {
                "featureType": "districtlabel",
                "elementType": "labels.text.stroke",
                "stylers": {
                    "color": "#ffffffff"
                }
            }, {
                "featureType": "entertainment",
                "elementType": "geometry",
                "stylers": {
                    "color": "#ffffffff"
                }
            }, {
                "featureType": "shopping",
                "elementType": "geometry",
                "stylers": {
                    "color": "#12223dff"
                }
            }];
            setTimeout(function(){
                map.setMapStyle({styleJson:styleJson});
            },500)
            this.getProLocation()
            this.getGpsList()
        },
        //获取定位
        getProLocation(){
            var that = this
            myHttp.getProjectById({
                id:this.groupId
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var data = resp.data.data.project
                    if(data){
                        if(data.gpsPoint && data.gpsPoint!=''){
                            var point = data.gpsPoint.split(',')
                            that.center = {
                                lng:point[0],
                                lat:point[1]
                            }
                        }
                    }
                }
            })
        },
        //获取安全帽定位数据
        getGpsList(){
            var that = this
            myHttp.selectMaxDateGpsRecord({
                projectId:this.groupId
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var list = resp.data.data.gpsList||[]
                    var result = []
                    var viewPoints = []
                    for(var i=0;i<list.length;i++){
                        if(list[i].latitude&&list[i].latitude!=''&&list[i].longitude&&list[i].longitude!=''){
                            list[i].position = {lng: parseFloat(list[i].longitude), lat: parseFloat(list[i].latitude)}
                            result.push(list[i])
                            viewPoints.push(list[i].position)
                        }
                    }
                    that.points = result
                    that.map.setViewport(viewPoints);
                }
                //定时刷新
                that.pageTimer["timer17"] = setTimeout(function(){
                    that.getGpsList()
                },that.timeout)
            })
        },
        //地图点击
        getClickInfo(e){
            if(!this.curIndex){
                var allOverlay = this.map.getOverlays();
                for(var i=0;i<allOverlay.length;i++){
                    if(allOverlay[i].toString()=="[object Overlay]"){
                        this.map.removeOverlay(allOverlay[i]);
                    }
                }
            }
            this.infoWindowClose()
        },
        //关闭
        infoWindowClose(){
            this.curIndex = undefined
        },
        //点击定位人员
        clickHandler(e){
            this.curIndex = e
            this.showMapMarker(e)
        },
        //展示地图数据
        showMapMarker(obj){
            var _selt = this
            // 复杂的自定义覆盖物
            function ComplexCustomOverlay(point,obj){
                this._point = point;
                this._option = obj
            }
            ComplexCustomOverlay.prototype = new BMap.Overlay();
            ComplexCustomOverlay.prototype.initialize = function(map){
                this._map = map;
                var option = this._option;
                var div = this._div = document.createElement("div");
                div.style.position = "absolute";
                div.style.zIndex = BMap.Overlay.getZIndex(this._point.lat);
                div.style.height = "200rem";
                div.style.width = "500rem";
                div.style.background = "rgba(19, 46, 140, 0.8)";
                div.style.borderRadius = "5rem";
                div.style.padding = "10rem";
                div.style.cursor = 'pointer'
                var that = this;

                //图片
                // var imgDiv = document.createElement("img");
                // imgDiv.style.position = "relative";
                // imgDiv.style.width = "180rem";
                // imgDiv.style.height = "150rem";
                // imgDiv.style.marginBottom = "10rem";
                // var imgs = option.photoFile
                // var img = option.photoFile&&option.photoFile!=''?base.httpCtx+option.photoFile:''
                // if(img==''){
                //     imgDiv.src = require('../../assets/image/zanwutupian.png')
                // }else{
                //     imgDiv.src = img
                // }
                // div.appendChild(imgDiv);

                //姓名
                var nameText = document.createElement("p");
                nameText.style.position = "relative";
                nameText.style.width = "100%";
                nameText.style.height = "60rem";
                nameText.style.fontSize = "12rem";
                nameText.style.color = "rgba(255, 255, 255, 1)";
                nameText.style.whiteSpace = "nowrap";
                nameText.style.textOverflow = "ellipsis";
                nameText.style.overflow = "hidden";
                nameText.innerHTML = '姓名：' + option.personName||'';
                // nameText.title = option.personName||'';
                div.appendChild(nameText);

                // sn
                var progressText = document.createElement("p");
                progressText.style.position = "relative";
                progressText.style.width = "100%";
                progressText.style.height = "60rem";
                progressText.style.fontSize = "12rem";
                progressText.style.color = "rgba(255, 255, 255, 1)";
                progressText.innerHTML = '序列号：'+ option.sn||'';
                div.appendChild(progressText);

                //超速
                var addrText = document.createElement("p");
                addrText.style.position = "relative";
                addrText.style.width = "100%";
                addrText.style.height = "60rem";
                addrText.style.fontSize = "12rem";
                addrText.style.color = "rgba(255, 255, 255, 1)";
                addrText.style.whiteSpace = "nowrap";
                addrText.style.textOverflow = "ellipsis";
                addrText.style.overflow = "hidden";
                addrText.title = option.address||'';
                // var result = '无'
                // if(option.warnField=='2'){
                //     result = '超速'
                // }
                // else{
                //     result = option.speed&&option.speed!=''?option.speed:0
                // }
                addrText.innerHTML = '时间：'+option.updateDate||'';
                div.appendChild(addrText);

                //跳转
                // var trap = document.createElement('a');
                // trap.style.position = "relative";
                // trap.style.width = "100%";
                // trap.style.height = "30rem";
                // trap.style.fontSize = "12rem";
                // trap.style.lineHeight = '2vh';
                // trap.style.color = "rgba(255, 255, 255, 1)";
                // trap.href = '/trailOne/'+option.id
                // trap.innerHTML = '轨迹查看'
                // div.appendChild(trap);

                div.onclick = function(){}

                map.getPanes().labelPane.appendChild(div);
                
                return div;
            }
            ComplexCustomOverlay.prototype.draw = function(){
                var map = this._map;
                var pixel = map.pointToOverlayPixel(this._point);
                // console.log(pixel)
                this._div.style.left = (pixel.x + 20) + 'px' ;
                this._div.style.top  = pixel.y  + 'px' ;
            }
            var allOverlay = this.map.getOverlays();
            for(var i=0;i<allOverlay.length;i++){
                if(allOverlay[i].toString()=="[object Overlay]"){
                    this.map.removeOverlay(allOverlay[i]);
                }
            }
            var gpsLi = obj.position;
            var myCompOverlay = new ComplexCustomOverlay(new BMap.Point(gpsLi.lng, gpsLi.lat),obj);
            this.map.addOverlay(myCompOverlay);
        },


        /**监控 **********************************************************/
        handleSizeChange(val) {
            this.pageSize = val
            this.handleCurrentChange(this.currentPage)
        },
        handleCurrentChange(val) {
            this.currentPage = val
            this.currentChangePage()
        },
        // 监控当前页码
        currentChangePage(list) {
            this.getMonitorList()
        },
        //获取监控列表
        getMonitorList(){
            var that = this
            myHttp.getCameraPageListByProjectId({
                projectId:this.groupId,
                pageNum:this.currentPage,
                pageSize:this.pageSize
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var list = resp.data.data.PageInfo.list||[];
                    for(var i=0;i<list.length;i++){
                        list[i].showUrl = '/monitor/view/one.html?serial='+list[i].serial+'&channel='+list[i].channelNo+'&token='+that.ysToken
                    }
                    that.monitorList = list
                    that.totalItems = resp.data.data.PageInfo.total||0
                }
            })
        },


        /**设备运行状态 ******************************************/
        getMacType(){
            var that = this
            myHttp.equipment({
                projectId:this.groupId,
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var data = resp.data.data
                    var list = []
                    // list.push({total:data.collect.sum,online:data.collect.online,offline:data.collect.offline})
                    list.push({total:data.attendance.sum,online:data.attendance.online,offline:data.attendance.offline})
                    list.push({total:data.tower.sum,online:data.tower.online,offline:data.tower.offline})
                    list.push({total:data.projectMonitor.sum,online:data.projectMonitor.online,offline:data.projectMonitor.offline})
                    list.push({total:data.elevator.sum,online:data.elevator.online,offline:data.elevator.offline})
                    // list.push({total:data.highModulus.sum,online:data.highModulus.online,offline:data.highModulus.offline})
                    // list.push({total:data.concrete.sum,online:data.concrete.online,offline:data.concrete.offline})
                    list.push({total:data.waterElectricity.sum,online:data.waterElectricity.online,offline:data.waterElectricity.offline})
                    list.push({total:data.equipCamera.sum,online:data.equipCamera.online,offline:data.equipCamera.offline})
                    that.equipStatusList = list
                    
                }
                //定时刷新
                that.pageTimer["timer18"] = setTimeout(function(){
                    that.getMacType()
                },that.timeout)
            })
        },

        /***监控预警 *******************************************************/
        getQsList(){
            var that = this
            myHttp.selectAiWarningPage({
                projectId:this.groupId,
                pageNum:1,
                pageSize:100,
                startTime:util.myTime.getCurTime(),
                endTime:util.myTime.getCurTime(),
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var list = resp.data.data.aiWarningList.list||[]
                    that.qsList = list
                    if(that.timer4){
                        window.clearInterval(that.timer4)
                    }
                    that.timer4 = setInterval(that.scroll3,1200) // 滚动效果
                }
                //定时刷新
                that.pageTimer["timer19"] = setTimeout(function(){
                    that.getQsList()
                },that.timeout)
            })
        },

        /***安康码 ******************************************************************/
        getAnkang(){
            var that = this
            myHttp.anKangCodeList({
                projectId:this.groupId
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var list = resp.data.data.list||[]
                    that.ankangNum.registered = resp.data.data.registered||0
                    that.ankangNum.green = resp.data.data.green||0
                    that.ankangNum.yellow = resp.data.data.yellow||0
                    that.ankangNum.red = resp.data.data.red||0
                    for(var i=0;i<list.length;i++){
                        list[i].idcardPhoto = list[i].idcardPhoto && ''!=list[i].idcardPhoto?base.httpCtx+list[i].idcardPhoto:require('../../assets/image/zanwutupian.png')
                        if(list[i].healthLevel=='1'){
                            list[i].codeImg = require('../../assets/image/anKang-gress.png')
                        }else if(list[i].healthLevel=='2'){
                            list[i].codeImg = require('../../assets/image/anKang-yellow.png')
                        }else if(list[i].healthLevel=='3'){
                            list[i].codeImg = require('../../assets/image/anKang-red.png')
                        }else if(list[i].healthLevel=='4'||list[i].healthLevel=='0'){
                            list[i].codeImg = require('../../assets/image/anKang-no.png')
                        }
                    }
                    // that.codeList = list
                    that.ankangList = list
                    if(that.timer3){
                        window.clearInterval(that.timer3)
                    }
                    that.timer3 = setInterval(that.scroll2,1400) // 滚动效果
                }
                //定时刷新
                that.pageTimer["timer20"] = setTimeout(function(){
                    that.getAnkang()
                },that.timeout)
            })
        },

        /**升降机监测 */
        getLiftData(){
            var that = this
            myHttp.getEleListByPage({
                projectId:this.groupId
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var list = resp.data.data.elevatorList||[]
                    // that.towerlist = list
                    if(list.length>0){
                        that.getLiftInfo(list[0].id)
                        that.getLiftNum(list[0].deviceId)
                    }
                    // if(list.length>0 && that.towerId==''){
                    //     that.towerId = list[0].id
                    //     that.deviceId = list[0].deviceId
                    // }
                    // if(that.towerId!=''){
                    //     that.getRealInfo()
                    //     that.getHour()
                    //     that.getPerson()
                    // }
                }
            })
        },
        getLiftInfo(id){
            var that = this
            myHttp.getEleInfoById({
                id:this.towerId
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var data = resp.data.data.elevator||{}
                    data.weightReay = data.weight && data.weightPercent?parseFloat(data.weight)/parseFloat(data.weightPercent)*100:''
                    that.liftPart = data
                    // that.allPart = data
                }
                //定时刷新
                that.pageTimer["timer21"] = setTimeout(function(){
                    that.getLiftInfo()
                },that.timeout)
            })
        },
        getLiftNum(id){
            var that = this
            myHttp.elevatorWarning({
                projectId:this.groupId,
                deviceId:id
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var data = resp.data.data
                    that.liftPart.msqm = data.msqm||0
                    that.liftPart.mshm = data.mshm||0
                    that.liftPart.qxyj = data.qxyj||0
                    that.liftPart.zlyj = data.zlyj||0
                    that.liftPart.systemStatusForelockStatus = data.ElevatorLog && data.ElevatorLog.systemStatusForelockStatus?data.ElevatorLog.systemStatusForelockStatus:''
                    that.liftPart.systemStatusBehindlockStatus = data.ElevatorLog && data.ElevatorLog.systemStatusBehindlockStatus?data.ElevatorLog.systemStatusBehindlockStatus:''
                    that.liftPart.systemStatusTilt = data.ElevatorLog && data.ElevatorLog.systemStatusTilt?data.ElevatorLog.systemStatusTilt:''
                    that.liftPart.systemStatusWeight = data.ElevatorLog && data.ElevatorLog.systemStatusWeight?data.ElevatorLog.systemStatusWeight:''
                    // that.towerH = data
                    // that.eleState = data.ElevatorLog||{}
                }
                //定时刷新
                that.pageTimer["timer22"] = setTimeout(function(){
                    that.getLiftNum()
                },that.timeout)
            })
        },

        /**高支模数据 */
        getModulus(){
            var that = this
            myHttp.highModulusDetection({
                projectId:this.groupId
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var obj = {
                        wyVal1:0,
                        wyRate1:'0%',
                        wyVal2:0,
                        wyRate2:'0%',
                        qjVal1:0,
                        qjRate1:'0%',
                        qjVal2:0,
                        qjRate2:'0%',
                        ylVal1:0,
                        ylRate1:'0%',
                        ylVal2:0,
                        ylRate2:'0%'
                    }
                    var list = resp.data.data.list||[]
                    for(var i=0;i<list.length;i++){
                        if(list[i].tsSersorType=='1'){
                            var val = list[i].nowValue?list[i].nowValue.split(','):[0,0]
                            obj.wyVal1 = val[0]
                            obj.wyRate1 = list[i].warning&&''!=list[i].warning?(parseFloat(obj.wyVal1)/parseFloat(list[i].warning).toFixed(2))*100+'%':'0%'
                            obj.wyVal2 = val[1]
                            obj.wyRate2 = list[i].warning&&''!=list[i].warning?(parseFloat(obj.wyVal2)/parseFloat(list[i].warning).toFixed(2))*100+'%':'0%'
                        }else if(list[i].tsSersorType=='2'){
                            var val = list[i].nowValue?list[i].nowValue.split(','):[0,0]
                            obj.qjVal1 = val[0]
                            obj.qjRate1 = list[i].warning&&''!=list[i].warning?(parseFloat(obj.qjRate1)/parseFloat(list[i].warning).toFixed(2))*100+'%':'0%'
                            obj.qjVal2 = val[1]
                            obj.qjRate2 = list[i].warning&&''!=list[i].warning?(parseFloat(obj.qjVal2)/parseFloat(list[i].warning).toFixed(2))*100+'%':'0%'
                        }else if(list[i].tsSersorType=='3'){
                            var val = list[i].nowValue?list[i].nowValue.split(','):[0,0]
                            obj.ylVal1 = val[0]
                            obj.ylRate1 = list[i].warning&&''!=list[i].warning?(parseFloat(obj.ylVal1)/parseFloat(list[i].warning).toFixed(2))*100+'%':'0%'
                            obj.ylVal2 = val[1]
                            obj.ylRate2 = list[i].warning&&''!=list[i].warning?(parseFloat(obj.ylVal2)/parseFloat(list[i].warning).toFixed(2))*100+'%':'0%'
                        }
                    }
                    that.highMod = obj
                }
                //定时刷新
                that.pageTimer["timer23"] = setTimeout(function(){
                    that.getModulus()
                },that.timeout)
            })
        },

        
        /**混凝土 *********************************************/
        getConcreteData(){
            var that = this
            myHttp.concreteDetection({
                projectId:this.groupId
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var list = resp.data.data.entry||[]
                    var list1=[],list2=[],list3=[],dev1=[],dev2=[],dev3=[]
                    for(var i=0;i<list.length;i++){
                        if(list[i].location=='上'){
                            list1 = resp.data.data.entry[i].parameter
                            dev1 = resp.data.data.entry[i].Equipment
                        }else if(list[i].location=='中'){
                            list2 = resp.data.data.entry[i].parameter
                            dev2 = resp.data.data.entry[i].Equipment
                        }else if(list[i].location=='下'){
                            list3 = resp.data.data.entry[i].parameter
                            dev3 = resp.data.data.entry[i].Equipment
                        }
                    }
                    var timeList = [[],[],[]]
                    var data1 = []
                    //上
                    for(var i=0;i<dev1.length;i++){
                        var obj = {name:dev1[i].name,id:dev1[i].id,data:[]}
                        data1.push(obj)
                    }
                    for(var i=0;i<list1.length;i++){
                        var str = []
                        timeList[0].push(list1[i].Time)
                        var subList = list1[i].List||[]
                        for(var j=0;j<subList.length;j++){
                            for(var k=0;k<data1.length;k++){
                                data1[k].data = that.mixFilter(data1[k],subList[j],j)
                            }
                        }
                    }
                    //中
                    var data2=[]
                    for(var i=0;i<dev2.length;i++){
                        var obj = {name:dev2[i].name,id:dev2[i].id,data:[]}
                        data2.push(obj)
                    }
                    for(var i=0;i<list2.length;i++){
                        var str = []
                        timeList[1].push(list2[i].Time)
                        var subList = list2[i].List||[]
                        for(var j=0;j<subList.length;j++){
                            for(var k=0;k<data2.length;k++){
                                data2[k].data = that.mixFilter(data2[k],subList[j],j)
                            }
                        }
                    }
                    //下
                    var data3 = []
                    for(var i=0;i<dev3.length;i++){
                        var obj = {name:dev3[i].name,id:dev3[i].id,data:[]}
                        data3.push(obj)
                    }
                    for(var i=0;i<list3.length;i++){
                        var str = []
                        timeList[2].push(list3[i].Time)
                        var subList = list3[i].List||[]
                        for(var j=0;j<subList.length;j++){
                            for(var k=0;k<data3.length;k++){
                                data3[k].data = that.mixFilter(data3[k],subList[j],j)
                            }
                        }
                    }
                    //console.log(timeList,data1,data2,data3)
                    that.setHunlin(timeList,data1,data2,data3)
                }
                //定时刷新
                that.pageTimer["timer24"] = setTimeout(function(){
                    that.getConcreteData()
                },that.timeout)
            })
        },
        mixFilter(datas,obj,i){
            if(datas.data.length>i){
                if(datas.id==obj.tsDtuSensorId){
                    datas.data[i] = parseFloat(obj.temperature)
                }
            }else{
                if(datas.id==obj.tsDtuSensorId){
                    datas.data.push(parseFloat(obj.temperature))
                }else{
                    datas.data.push(0)
                }
            }
            return datas.data
        },
        unique( arr ){
            return arr.filter(function(item,index){
                return arr.indexOf(item,0) === index;
            });
        },
        sortNumber(a,b){
            return b - a
        },
        setHunlin(time,data1,data2,data3){
            time = time?time:[[],[],[]]
            //上
            data1 = data1?data1:null
            for(var i=0;i<time[0].length;i++){
                time[0][i] = time[0][i]+':00'
            }
            if(document.getElementById('hunlin1')){
                HighCharts.chart('hunlin1',{
                    chart: {
                        type: 'column',
                        backgroundColor:'transparent',
                        spacing:[50,0,10,0],
                    },
                    title: {
                        text: '上孔位',
                        style:{
                            color:'#fff'
                        },
                    },
                    subtitle: {
                        text: ''
                    },
                    legend: {
                        align: 'right',
                        verticalAlign: 'top',
                        y: -40,
                        floating: true,
                        borderWidth: 0,
                        itemStyle:{
                            fontWeight:'500',
                            color:'#fff',
                        },
                    },
                    // legend: {
                    //     enabled: false
                    // },
                    xAxis: {
                        categories: time[0],
                        crosshair: true,
                        title: {
                            text: '',
                            style:{
                                color:'#ffffff'
                            },
                            align:'high'
                        },
                        labels:{
                            style:{
                                color:"#ffffff",
                                fontSize:'16rem',
                            }
                        },
                    },
                    yAxis: {
                        title: {
                            text: '单位：℃',
                            style:{
                                color:'#ffffff',
                                fontSize:'12rem'
                            },
                            align:'high'
                        },
                        // plotLines: [{
                        //     value: 100,
                        //     color: 'red',
                        //     width: 1,
                        //     label: {
                        //         text: '理论模型: 100',
                        //         align: 'center',
                        //         style: {
                        //             color: 'gray'
                        //         }
                        //     }
                        // }],
                        min: 0,
                        labels:{
                            style:{
                                color:"#ffffff",
                                fontSize:'16rem',
                            }
                        },
                        
                    },
                    colors: ['#FFBAAF', '#FF86B9', '#FB6CAD','#F7A861'],
                    tooltip: {
                        headerFormat: '<span style="font-size:10rem">{point.key}</span><table>',
                        pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
                        '<td style="padding:0"><b>{point.y:.1f} 摄氏度</b></td></tr>',
                        footerFormat: '</table>',
                        shared: true,
                        useHTML: true
                    },
                    plotOptions: {
                        column: {
                            borderWidth: 0,
                            pointWidth:15 ,
                        }
                    },
                    series: data1
                });
            }
            
            //中
            data1 = data2?data2:null
            for(var i=0;i<time[1].length;i++){
                time[1][i] = time[1][i]+':00'
            }
            if(document.getElementById('hunlin2')){
                HighCharts.chart('hunlin2',{
                    chart: {
                        type: 'column',
                        backgroundColor:'transparent',
                        spacing:[50,0,10,0],
                    },
                    title: {
                        text: '中孔位',
                        style:{
                            color:'#fff'
                        },
                    },
                    subtitle: {
                        text: ''
                    },
                    legend: {
                        align: 'right',
                        verticalAlign: 'top',
                        y: -40,
                        floating: true,
                        borderWidth: 0,
                        itemStyle:{
                            fontWeight:'500',
                            color:'#fff',
                        },
                    },
                    xAxis: {
                        categories: time[1],
                        crosshair: true,
                        title: {
                            text: '',
                            style:{
                                color:'#ffffff'
                            },
                            align:'high'
                        },
                        labels:{
                            style:{
                                color:"#ffffff",
                                fontSize:'16rem',
                            }
                        },
                    },
                    yAxis: {
                        title: {
                            text: '单位：℃',
                            style:{
                                color:'#ffffff',
                                fontSize:'12rem'
                            },
                            align:'high'
                        },
                        min: 0,
                        labels:{
                            style:{
                                color:"#ffffff",
                                fontSize:'16rem',
                            }
                        },
                        
                    },
                    colors: ['#988BFF', '#B671FE', '#8753EA','#185EFD'],
                    tooltip: {
                        headerFormat: '<span style="font-size:10rem">{point.key}</span><table>',
                        pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
                        '<td style="padding:0"><b>{point.y:.1f} 摄氏度</b></td></tr>',
                        footerFormat: '</table>',
                        shared: true,
                        useHTML: true
                    },
                    plotOptions: {
                        column: {
                            borderWidth: 0,
                            pointWidth:15 ,
                        }
                    },
                    series: data2
                });
            }
            
            //下
            data1 = data3?data3:null
            for(var i=2;i<time[2].length;i++){
                time[2][i] = time[2][i]+':00'
            }
            if(document.getElementById('hunlin3')){
                HighCharts.chart('hunlin3',{
                    chart: {
                        type: 'column',
                        backgroundColor:'transparent',
                        spacing:[50,0,10,0],
                    },
                    title: {
                        text: '下孔位',
                        style:{
                            color:'#fff'
                        },
                    },
                    subtitle: {
                        text: ''
                    },
                    legend: {
                        align: 'right',
                        verticalAlign: 'top',
                        y: -40,
                        floating: true,
                        borderWidth: 0,
                        itemStyle:{
                            fontWeight:'500',
                            color:'#fff',
                        },
                    },
                    // legend: {
                    //     enabled: false
                    // },
                    xAxis: {
                        categories: time[2],
                        crosshair: true,
                        title: {
                            text: '',
                            style:{
                                color:'#ffffff'
                            },
                            align:'high'
                        },
                        labels:{
                            style:{
                                color:"#ffffff",
                                fontSize:'16rem',
                            }
                        },
                    },
                    yAxis: {
                        title: {
                            text: '单位：℃',
                            style:{
                                color:'#ffffff',
                                fontSize:'12rem'
                            },
                            align:'high'
                        },
                        // plotLines: [{
                        //     value: 100,
                        //     color: 'red',
                        //     width: 1,
                        //     label: {
                        //         text: '理论模型: 100',
                        //         align: 'center',
                        //         style: {
                        //             color: 'gray'
                        //         }
                        //     }
                        // }],
                        min: 0,
                        labels:{
                            style:{
                                color:"#ffffff",
                                fontSize:'16rem',
                            }
                        },
                        
                    },
                    colors: ['#798AF7', '#68BBE9', '#0E98CC','#7AF0F7'],
                    tooltip: {
                        headerFormat: '<span style="font-size:10rem">{point.key}</span><table>',
                        pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
                        '<td style="padding:0"><b>{point.y:.1f} 摄氏度</b></td></tr>',
                        footerFormat: '</table>',
                        shared: true,
                        useHTML: true
                    },
                    plotOptions: {
                        column: {
                            borderWidth: 0,
                            pointWidth:15 ,
                        }
                    },
                    series: data3
                });
            }
            
        },

        /**监听模块移动 */
        log(evt){
            // console.log(evt)
            window.clearTimeout(this.pageTimer["timer3"])
            this.getDynPerson()
            window.clearTimeout(this.pageTimer["timer6"])
            this.getQsData()
            window.clearTimeout(this.pageTimer["timer7"])
            this.getDiseaseMonth()  //疫情管控 - 月
            window.clearTimeout(this.pageTimer["timer8"])
            this.getDiseaseWeek()   //疫情管控 - 周
            window.clearTimeout(this.pageTimer["timer9"])
            this.getCarData()  //车辆统计
            window.clearTimeout(this.pageTimer["timer12"])
            this.getWaterLine() //能耗 - 水-年
            window.clearTimeout(this.pageTimer["timer13"])
            this.getWaterPie() //能耗 - 水 -季度
            window.clearTimeout(this.pageTimer["timer10"])
            this.getEleLine() //能耗 - 电-年
            window.clearTimeout(this.pageTimer["timer11"])
            this.getElePie() //能耗 -电-季度
            window.clearTimeout(this.pageTimer["timer15"])
            this.getDustLine()  //扬尘监测 - line
            window.clearTimeout(this.pageTimer["timer16"])
            this.getDustPie()  //扬尘监测 - pie
            window.clearTimeout(this.pageTimer["timer24"])
            this.getConcreteData() //混凝土测温
            this.saveModultList() //保存模块改变
        },
        /**推送 */
        /**
        * socket推送
        */
        initWebsocket(){
            var that = this;
            //判断当前浏览器是否支持WebSocket
            if('WebSocket' in window){
                var url = ''
                if(document.location.protocol=="https:"){
                    url = base.httpsWs+"/websocket/"+this.groupId;//wss地址;
                }else{
                    url = base.httpWs+"/websocket/"+this.groupId;//ws地址;
                }
                // var url= base.httpWs+"/websocket/"+this.groupId;
                that.websocket = new WebSocket(url);
            }
            else{
                alert('Not support websocket')
            }
            //连接发生错误的回调方法
            this.websocket.onerror = function(){
                //setMessageInnerHTML("error");
            };
            //连接成功建立的回调方法
            this.websocket.onopen = function(event){
                console.log('websocket连接成功')
                //$("#serverinfo").hide();
                that.errorFlag = false
                that.timeOutObj=null;
            }
            //接收到消息的回调方法
            this.websocket.onmessage = function(event){
                if(event.data=="连接成功")return;
                var x=JSON.parse(event.data);
                if("1"==x.flag){
                    alert(x.msg);
                    that.closeWebSocket();
                }
                if("2"==x.flag){
                    console.log(x)
                    that.showInOutPerson(x);
                }
            }
            //连接关闭的回调方法
            this.websocket.onclose = function(){
                this.timeOutObj=setTimeout(function(){
                    that.initWebsocket();
                }, 60000);
                // $("#serverinfo").show();
                that.errorFlag = true
            }
            //监听窗口关闭事件，当窗口关闭时，主动去关闭websocket连接，防止连接还没断开就关闭窗口，server端会抛异常。
            window.onbeforeunload = function(){
                that.websocket.close();
            }
        },
        //关闭连接
        closeWebSocket(){
            that.websocket.close();
        },
        //展示入场人员
        showInOutPerson(data){
           var imgUrl = base.httpCtx;
           var statusName = data.status=='0'?'进闸':'出闸';
           var time = this.formatTime(data.clocktime,'YYYY-MM-dd HH:mm:ss');
           data.photoImg = imgUrl+data.photofile;
           data.uploadImg = imgUrl+data.uploadFile;
           data.time = time;
           data.statusName = statusName;
           data.temperatureFlag = parseFloat(data.temperature)>37.3?false:true;
           if(data.healthLevel=='2'){
               data.anSrc = require("../../assets/image/anKang-yellow.png")
           }else if(data.healthLevel=='3'){
               data.anSrc = require("../../assets/image/anKang-red.png")
           }else if(data.healthLevel=='1'){
               data.anSrc = require("../../assets/image/anKang-gress.png")
           }else{
               data.anSrc = require("../../assets/image/anKang-no.png")
           }
           this.inOutList.unshift(data);
           var that = this;
        },
        formatTime(time,format){
            var time = time?new Date(time):new Date();
            var year = time.getFullYear();
            var month = (time.getMonth() + 1).toString().length == 1 ? "0" + (time.getMonth() + 1).toString() : (time.getMonth() + 1);
            var day = time.getDate().toString().length == 1 ? "0" + time.getDate() : time.getDate();
            var hour = time.getHours() < 10 ? '0' + time.getHours() : time.getHours();
            var m = time.getMinutes() < 10 ? '0' + time.getMinutes() : time.getMinutes();
            var s = time.getSeconds() < 10 ? '0' + time.getSeconds() : time.getSeconds();
            var result = format.replace('YYYY',year).replace('MM',month).replace('dd',day).replace('HH',hour).replace('mm',m).replace('ss',s);
            return result;
       },

        /**
         * 卸料平台 - 列表
         */
        getUnloadList(){
            var that = this
            myHttp.equipmentList({
                projectId:this.groupId,
                pageNum:1,
                pageSize:1000
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var list = resp.data.data.pageInfo.list || []
                    that.unloadList = list
                    if(list.length>0){
                        that.unloadId = list[0].verifyCode
                    }
                    that.getUnloadInfo()
                }
                
            })
        },
        getUnloadInfo(){
            var that = this
            myHttp.equipUnloadNewestInformation({
                verifyCode:this.unloadId,
                v:new Date().getTime()
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var data = resp.data.data||{}
                    data.bias = data.bias && ''!=data.bias?data.bias:0
                    that.unloadInfo = data
                    that.setUnloadGauge(data)
                    //定时刷新
                    that.pageTimer["timer25"] = setTimeout(function(){
                        that.getUnloadInfo()
                    },that.timeout)
                }
            })
        },
        getUnloadLog(){
            //unloadLog
            var that = this
            myHttp.equipUnloadLogList({
                projectId:this.groupId,
                verifyCode:this.unloadId,
                date:this.tableTime,
                pageSize:1000,
                pageNum:1,
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var list = resp.data.data.pageInfo.list||[]
                    that.unloadLog = list
                    if(that.timer5){
                        window.clearInterval(that.timer5)
                    }
                    that.timer5 = setInterval(that.scroll5,1500) // 滚动效果
                }
                //定时刷新
                that.pageTimer["timer26"] = setTimeout(function(){
                    that.getUnloadLog()
                },that.timeout1)
            })
        },
        /**
         * 卸料平台-表图
         */
        setUnloadGauge(data1){
            var option = {
                tooltip: {
                    formatter: '{a} <br/>{b} : {c}%'
                },
                series: [
                    {
                        name: '偏置值',
                        type: 'gauge',
                        min: -100,
                        max: 100,
                        radius: '100%',
                        axisLine: {            // 坐标轴线
                            lineStyle: {       // 属性lineStyle控制线条样式
                                color: [[0.8, '#ACBBFA'], [1, '#617AE5']],
                                width: 1,
                                shadowColor: '#fff', //默认透明
                                shadowBlur: 1
                            }
                        },
                        axisLabel:{
                            fontSize:10,
                        },
                        splitLine: {           // 分隔线
                            length: 1,         // 属性length控制线长
                            lineStyle: {       // 属性lineStyle（详见lineStyle）控制线条样式
                                width: 1,
                                color: '#9198B2',
                            }
                        },
                        detail: {formatter: '{value}',fontSize:'100%',offsetCenter:[0,'70%']},
                        data: [{value: 0, name: ''}],
                        pointer: {
                            width: 2,
                            shadowColor: '#fff', //默认透明
                            shadowBlur: 5
                        },
                    }
                ]
            }
            if(document.getElementById('unload1')){
                var echart1 = this.$echarts.init(document.getElementById('unload1'))
                echart1.setOption(option)
            }
            
            var weight = 0 //当前重量
            // 报警重量
            var alarmWeight = 1000
            var option3 = {
                tooltip: {
                    formatter: '{a} <br/>{b} : {c}%'
                },
                series: [
                    {
                        name: '报警重量',
                        type: 'gauge',
                        min: 0,
                        max: alarmWeight,
                        radius: '100%',
                        axisLine: {            // 坐标轴线
                            lineStyle: {       // 属性lineStyle控制线条样式
                                color: [[0.8, '#ACBBFA'], [1, '#617AE5']],
                                width: 0.5,
                                shadowColor: '#fff', //默认透明
                                shadowBlur: 0.5
                            }
                        },
                        axisLabel:{
                            fontSize:10,
                        },
                        splitLine: {           // 分隔线
                            length: 1,         // 属性length控制线长
                            lineStyle: {       // 属性lineStyle（详见lineStyle）控制线条样式
                                width: 1,
                                color: '#9198B2',
                            }
                        },
                        detail: {formatter: '{value}吨',fontSize:'100%',offsetCenter:[0,'70%']},
                        data: [{value: weight, name: ''}],
                        pointer: {
                            width: 2,
                            shadowColor: '#fff', //默认透明
                            shadowBlur: 5
                        },
                    }
                ]
            }
            if(document.getElementById('unload3')){
                var echart3 = this.$echarts.init(document.getElementById('unload3'))
                echart3.setOption(option3)
            }
            
        },

        /**
         * 螺帽主机
         */
        getNutHost(){
            var that = this
            myHttp.selectNutHostList({
                projectId:this.groupId
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var list = resp.data.data.List||[]
                    if(list.length>0 && that.nutId==''){
                        that.nutId = list[0].id
                        that.getNutInfo()
                        that.getNutLog()
                    }
                }
            })
        },
        //获取螺帽主机信息
        getNutInfo(){
            var that = this
            myHttp.selectNutHost({
                id:this.nutId
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var data = resp.data.data.NutHost
                    data.dayLen = util.myTime.getdayByDate(data.createDate,util.myTime.getCurTime())
                    that.nutInfo = data
                }
                //定时刷新
                that.pageTimer["timer27"] = setTimeout(function(){
                    that.getNutInfo()
                },that.timeout1)
            })
        },
        //获取螺帽主机日志
        getNutLog(){
            var that = this
            myHttp.selectNutRecordWaring({
                hostId:this.nutId,
                projectId:this.groupId,
                date:this.nutTime
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var list = resp.data.data.NutRecord||[]
                    that.nutLog = list
                    if(that.timer6){
                        window.clearInterval(that.timer6)
                    }
                    that.timer6 = setInterval(that.scroll6,1500) // 滚动效果
                }
            })
        },
        /**
         * 弹出框操作
         */
        //点击显示
        showDialogFun(){
            this.ctrlVis = true
            this.modularList = JSON.parse(JSON.stringify(this.allList))
        },
        //点击确认
        refreshCtl(){
            var listData = this.modularList
            this.modularList = []
            this.allList = JSON.parse(JSON.stringify(listData))
            for(var i=0;i<this.list0.length;i++){
                this.list0[i].margin = listData[0].margin==''?0:listData[0].margin
                this.list0[i].border = listData[0].border
                this.list0[i].show = listData[0].show
            }
            var allLen = listData.length
            var len1 = this.list1.length
            for(var j=0;j<len1;j++){
                for(var k=0;k<allLen;k++){
                    if(this.list1[j].index==listData[k].index){
                        this.list1[j] = listData[k]
                    }
                }
            }
            var len2 = this.list2.length
            for(var j=0;j<len2;j++){
                for(var k=0;k<allLen;k++){
                    if(this.list2[j].index==listData[k].index){
                        this.list2[j] = listData[k]
                    }
                }
            }
            var len3 = this.list3.length
            for(var j=0;j<len3;j++){
                for(var k=0;k<allLen;k++){
                    if(this.list3[j].index==listData[k].index){
                        this.list3[j] = listData[k]
                    }
                }
            }
            var len4 = this.list4.length
            for(var j=0;j<len4;j++){
                for(var k=0;k<allLen;k++){
                    if(this.list4[j].index==listData[k].index){
                        this.list4[j] = listData[k]
                    }
                }
            }
            this.ctrlVis = false
            //保存修改
            this.saveModultList()
        },

        /**列表滚动 ***************************************************************/
        //班组
        scroll(){
            if(this.attendTeam.length>5){
                var that = this
                this.animate=true;
                setTimeout(()=>{
                        this.attendTeam.push(this.attendTeam[0]);
                        this.attendTeam.shift();
                        this.animate = false;
                },1000)
            }else{
                window.clearInterval(this.timer1)
            }
        },
        //合同列表滚动
        scroll1(){
            if(this.tableAgree.length>7){
                var that = this
                this.animate1=true;    // 因为在消息向上滚动的时候需要添加css3过渡动画，所以这里需要设置true
                setTimeout(()=>{      //  这里直接使用了es6的箭头函数，省去了处理this指向偏移问题，代码也比之前简化了很多
                        this.tableAgree.push(this.tableAgree[0]);  // 将数组的第一个元素添加到数组的
                        this.tableAgree.shift();               //删除数组的第一个元素 attendTeam   
                        this.animate1 = false;  // margin-top 为0 的时候取消过渡动画，实现无缝滚动
                },1000)
            }else{
                window.clearInterval(this.timer2)
            }
        },
        //安康码
        scroll2(){
            if(this.ankangList.length>5){
                var that = this
                this.animate2=true;
                setTimeout(()=>{
                        this.ankangList.push(this.ankangList[0]);
                        this.ankangList.shift();
                        this.animate2 = false;
                },1000)
            }else{
                window.clearInterval(this.timer3)
            }
        },
        //监控预警
        scroll3(){
            if(this.qsList.length>6){
                var that = this
                this.animate4=true;
                setTimeout(()=>{
                        this.qsList.push(this.qsList[0]);
                        this.qsList.shift();
                        this.animate4 = false;
                },1000)
            }else{
                window.clearInterval(this.timer4)
            }
        },
        //卸料平台日志循环
        scroll5(){
            if(this.unloadLog.length>2){
                var that = this
                this.animate5=true;
                setTimeout(()=>{
                    this.unloadLog.push(this.unloadLog[0]);
                    this.unloadLog.shift();
                    this.animate5 = false;
                },1500)
            }else{
                window.clearInterval(this.timer5)
            }
        },
        //螺帽列表
        scroll6(){
            if(this.nutLog.length>3){
                var that = this
                this.animate6=true;
                setTimeout(()=>{
                    this.nutLog.push(this.nutLog[0]);
                    this.nutLog.shift();
                    this.animate6 = false;
                },1500)
            }else{
                window.clearInterval(this.timer5)
            }
        },
        /**
         * 保存模块
         */
        saveModultList(){
            var that = this
            var data = []
            data.push(this.list0)
            data.push(this.list1)
            data.push(this.list2)
            data.push(this.list3)
            data.push(this.list4)
            if(this.moduleExeit){//修改
                myHttp.updateHomePage({
                    groupId:this.groupId,
                    numerical:JSON.stringify(data),
                    type:'3'
                }).then(function(resp){
                    if(resp.data.code=='200'){

                    }else{
                        that.$message.error(resp.data.msg);
                    }
                },function(){
                    that.$message.error('服务器繁忙，请稍后再试');
                })
            }else{  //添加
                myHttp.postHomePage({
                    groupId:this.groupId,
                    numerical:JSON.stringify(data),
                    type:'3'
                }).then(function(resp){
                    if(resp.data.code=='200'){

                    }else{
                        that.$message.error(resp.data.msg);
                    }
                },function(){
                    that.$message.error('服务器繁忙，请稍后再试');
                })
            }
        },
    },
    destroyed(){
        for(var each in this.pageTimer){
            window.clearTimeout(this.pageTimer[each]);
        }
        if(this.timer1){
            window.clearInterval(this.timer1)
        }
        if(this.timer2){
            window.clearInterval(this.timer2)
        }
        if(this.timer3){
            window.clearInterval(this.timer3)
        }
        if(this.timer4){
            window.clearInterval(this.timer4)
        }
    },
}
</script>

<style scoped>
    *{
        color: #fff;
        font-size: 18rem;
    }
    .big-box{
        width: 7680rem;
        height: 3240rem;
        /* width: 5760rem;
        height: 2160rem; */
        position: relative;
        padding: 40rem 160rem;
        background: url('../../assets/image/visual/screen.jpg');
        background-size: 100% 100%;
        display: flex;
        justify-content: flex-start;
        align-content: flex-start;
        flex-wrap: wrap;
        overflow: hidden;
    }
    /* left0 */
    .list-group-box1{
        width: 860rem;
        height: 2940rem;
        position: relative;
        /* padding: 0 0 0 30rem; */
        padding: 0;
        margin-left: 30rem;
    }
    /* .item-01{
        width: 800rem;
        height: 2935rem;
        position: relative;
        border: 1rem solid #ddd;
        margin: 0 50rem;
    } */
    .item-title{
        /* width: 550rem; */
        width: 68.75%;
        height: 10%;
        min-height: 50rem;
        position: relative;
        display: flex;
        justify-content: center;
        justify-items: center;
        align-content: center;
        align-items: center;
        margin: 0 auto;
        background: url('../../assets/image/visual/txt1.png');
        color: #34ECFF;
        font-size: 24rem;
    }
    .item-div{
        width: 100%;
        height: auto;
        /* margin-top: 180rem; */
        position: relative;
    }

    /* .item-02{
        width: 1360rem;
        height: 2055rem;
        position: relative;
        padding: 0 50rem;
        border:1rem solid red;
        margin-bottom: 100rem;
    } */

    /* .item-03{
        width: 1260rem;
        height: 780rem;
        position: relative;
        padding: 0 10rem 30rem 50rem;
        border: 1rem solid yellow;
        margin: 0 50rem;
    } */

    /* .item-04{
        width: 1060rem;
        height: 456rem;
        position: relative;
        padding: 0 10rem 30rem 10rem;
        border: 1rem solid rgb(28, 209, 22);
        margin: 20rem 50rem;
    } */
    .item-head-p{
        width: 100%;
        height: 60rem;
        position: relative;
        display: flex;
        align-content: center;
        align-items: center;
    }
    .item-head-p span{
        width: 14%;
        height: 100%;
        position: relative;
        display: flex;
        justify-content: center;
        justify-items: center;
        align-content: center;
        align-items: center;
    }
    .item-head-p span.b-line,.device-item .b-line{
        border-bottom: 2rem solid rgb(112 197 255 / 0.2);
    }
    .item1-con{
        width: 100%;
        /* height: 25vh; */
        position: relative;
        padding: 0 30rem;
        display: flex;
        flex-wrap: wrap;
        overflow: hidden;
    }
    .device-item{
        width: 100%;
        height: 70rem;
        position: relative;
        display: flex;
    }
    .device-item p,.device-item1 p{
        width: 14%;
        height: 100%;
        position: relative;
        display: flex;
        justify-content: center;
        justify-items: center;
        align-content: center;
        align-items: center;
    }
    .device-item1{
        width: 100%;
        height: 80rem;
        position: relative;
        display: flex;
    }
    .item-span{
        position: absolute;
        width: 100%;
        height: 100%;
        left: -1rem;
        top: 2rem;
        display: flex;
        justify-content: center;
        justify-items: center;
        align-content: center;
        align-items: center;
    }

    .item-05{
        /* width: 1260rem; */
        width: 1060rem;
        height: 322rem;
        position: relative;
        padding: 0 10rem 30rem 10rem;
        border: 1rem solid rgb(22, 209, 209);
        margin: 20rem 50rem;
    }
    .car-img{
        width: 160rem;
        height: 100%;
        position: relative;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        justify-items: center;
        /* align-content: center;
        align-items: center; */
        align-content: flex-start;
        padding-top: 30rem;
    }
    .car-img p{
        width: 100%;
        height: 3rem;
        position: relative;
        text-align: center;
        line-height: 3rem;
    }
    .car-num{
        width: calc( 50% - 160rem );
        height: 100%;
        position: relative;
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-start;
        align-content: center;
    }
    .car-num p{
        width: 100%;
        height: 60rem;
        position: relative;
        display: flex;
        justify-content: flex-start;
        justify-items: flex-start;
        align-content: center;
        align-items: center;
        padding-left: 10rem;
    }

    .item-06{
        width: 1060rem;
        height: 820rem;
        position: relative;
        padding: 0 10rem 30rem 10rem;
        border: 1rem solid rgb(14, 87, 245);
        margin: 20rem 50rem;
    }
    .num-box{
        width: 100%;
        height: 100rem;
        position: relative;
        padding:0 10rem;
        display: flex;
        margin: 30rem 0;
    }
    .num-box-item{
        width: 25%;
        height: 100%;
        padding: 10rem 20rem;
        position: relative;
        cursor: pointer;
    }
    .num-box-item .txt{
        display: flex;
        flex-wrap: wrap;
        align-content: space-between;
        padding: 10rem 0;
        font-size: 18rem;
    }
    .table-li{
        width: 100%;
        height: 40rem;
        position: relative;
        display: flex;
    }
    .table-li p{
        width: 33%;
        height: 100%;
        position: relative;
        display: flex;
        justify-content: center;
        justify-items: center;
        align-content: center;
        align-items: center;
    }
    /* 塔吊 */
    .main-left-item{
        height: 84rem;
        width: 100%;
        position: relative;
        /* background: #E7F1FB; */
        display: flex;
        flex-wrap: wrap;
        align-content: center;
        align-items: center;
        padding: 5rem;
        cursor: pointer;
        margin-top: 10rem;
    }
    .main-left-item p{
        height: 30rem;
        position: relative;
        text-align: left;
        display: flex;
        align-content: center;
        align-items: center;
    }
    .main-left-item .name{
        width: 114rem;
        position: relative;
    }
    .main-left-item .state{
        width: 60rem;
        position: relative;
        justify-content: flex-end;
    }
    .main-left-item .num{
        width: 100%;
        position: relative;
    }
    .real-data-l-item{
        width:100%;
        display:flex;
        height:42rem;
        align-items: flex-end;
        /* margin-bottom: 10rem; */
        transform: scale(0.8);
    }
    .real-data-l-item span{
        display: inline-block;
        /* width: 10vw; */
        margin-left: 16rem;
        height: 40rem;
        display: flex;
        align-content: center;
        align-items: center;
    }
    .real-data-l-item .abr{
        position: absolute;
        bottom: 20rem;
        left: 60%;
        width: 70rem;
        height: 30rem;
        font-size: 16rem;
        text-align: center;
        color: #707070;
        background: #c5c1c1;
        background: url(../../assets/image/box.png) no-repeat;
        background-size: 100% 100%;
    }
    .real-clock{
        width: 33%;
        height: 100%;
        position: relative;
        padding: 10rem;
    }
    #wrap.real-clock-con{
        margin-top: 30rem;
        width: 220rem;
        height: 220rem;
    }
    /* 监控************** */
    .monitorbox-item{
        width:33.33%;
        height: 50%;
        position: relative;
        padding: 0 5rem 10rem;
    }
    .item-monitor{
        width: 100%;
        height: calc( 100% - 60rem );
        position: relative;
        /* background: #fff; */
    }
    .item-info{
        width: 100%;
        height: 50rem;
        position: relative;
        display: flex;
        align-content: center;
        align-items: center;
        justify-content: space-around;
        /* background: #fff; */
    }
    .item-info .name{
        flex:1;
        text-align: center;
        
    }
    .item-info img{
        width:30rem;
        height: auto;
        position: relative;
        margin: 0 20rem;
    }
    .disabled{
        color:#409EFF;
        cursor: pointer;
    }



    .flip-list-move {
        transition: transform 0.5s;
    }
    .no-move {
        transition: transform 0s;
    }
    .ghost {
        opacity: 0.5;
        background: #c8ebfb;
    }
    .list-group {
        /* width: 860rem;
        height: 2935rem; */
        width: 100%;
        height: 100%;
        display: flex;
        flex-wrap: wrap;
        background: url('../../assets/image/visual/left1.png');
        background-size: 100% 100%;
        justify-content: center;
        align-content: flex-start;
        align-items: flex-start;
        padding: 0 20rem;
    }
    .list-group-item {
        cursor: move;
        display: inline-block;
        position: relative;
        width: 100%;
        /* max-width: 1260rem;
        min-width: 800rem; */
    }
    /* .list-group-item i {
        cursor: pointer;
    } */
    .crile{
        width: 16rem;
        height: 16rem;
        position: relative;
        border-radius: 50%;
        background: #34ECFF;
        margin-right: 20rem;
        display: inline-block;
    }
    .map-box{
        width: 100%;
        height: 100%;
        position: relative;
    }
    .borderCss{
        background: rgba(13, 25, 57, 0.45);
        border: 2rem solid #707070;
    }

    .anim{
        transition: all 1s;
        margin-top: -80rem;
    }
    .anim1{
        transition: all 1s;
        margin-top: -60rem;
    }
    .anim2{
        transition: all 1s;
        margin-top: -70rem;
    }
    .anim3{
        transition: all 4s;
        margin-top: -200rem;
    }
</style>

<style>
    @import '../../assets/css/common.css';
    @import '../../assets/css/clock1.css';
    .big-box .el-progress__text{
        color: #fff;
    }
    .big-box .el-input--suffix .el-input__inner{
        background: transparent;
        border: 0;
        color: #fff;
        width: 300rem;
    }
    .big-box .el-select-dropdown__item span{
        color: #000;
    }
    .big-box .hunlin .el-input--suffix .el-input__inner{
        border: 1rem solid #6DBEEA;
        width: 200rem;
    }
    .big-box .list-group-box1 .el-pagination{
        background: rgba(19, 145, 218, 0.2);
        border: 1rem solid #1391DA;
    }
    .big-box .list-group-box1 .el-pagination__total{
        color: #fff;
    }
    .big-box .el-progress-bar{
        padding-right: 70rem;
        margin-right: -70rem;
    }
    .bigVitalDia{
        /* background: rgb(0 0 0 / 0.5); */
        background: rgba(11, 37, 104, 0.45);
        border: 2rem solid #707070;
    }
    .bigVitalDia *{
        color:#34ECFF;
    }
    .bigVitalDia .el-input__inner{
        background: transparent;
        border: 1rem solid #34ECFF;
        height: 80rem;
    }
    .bigVitalDia .el-button{
        border: 1rem solid #34ECFF;
        background: #0B2568;
        color: #fff;
    }
    .big-box *{
        color: #fff;
        font-size: 18rem;
    }
    .big-box .el-pagination{
        padding: 0px !important;
        display: flex;
        align-items: center;
        align-content: center;
        justify-content: center;
        justify-items: center;
        height: 100%;
    }
    .big-box .el-pagination .btn-next, 
    .big-box .el-pagination .btn-prev{
        background: transparent;
    }
    .big-box .el-pager li{
        padding: 0 4rem;
        font-size: 13rem;
        min-width: 35.5rem;
        height: 28rem;
        line-height: 28rem;
        box-sizing: border-box;
        text-align: center;
        background: #0a3165;
        top: 12rem;
    }
    .big-box .el-pagination__editor.el-input .el-input__inner{
        height: 60rem;
    }
    .big-box .el-progress-circle{
        width: 100rem !important;
        height:100rem !important;
    }
    .big-box .el-progress-bar__outer{
        height: 20rem !important;
    }
    .big-box .el-progress__text{
        font-size: 20rem !important;
    }
    #wrap .num180{
        position: absolute;
        top: 150rem;
        right: 62rem;
        margin: 0;
        padding: 0;
        height: 200rem;
        color: #206ED4;
    }
    html{
        font-size:0.25px;
    }
</style>